export interface paths {
    '/api/v2/auth/user/id': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': string;
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/auth/fido2/credentialOptions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['Fido2DomainModelsCredentialOptionsCredentialOptionsCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/auth/fido2/credentials': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['Fido2DomainModelsCredentialsCredentialResultCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRegisterCredentialsCamelCased'];
                    'application/json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRegisterCredentialsCamelCased'];
                    'application/*+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRegisterCredentialsCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsDeleteCredentialsCamelCased'];
                    'application/json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsDeleteCredentialsCamelCased'];
                    'application/*+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsDeleteCredentialsCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/auth/fido2/assertionOptions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['Fido2DomainModelsAssertionOptionsAssertionOptionsCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/auth/fido2/assertion': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['Fido2DomainEntitiesAssertionCommandsMakeAssertionCamelCased'];
                    'application/json': components['schemas']['Fido2DomainEntitiesAssertionCommandsMakeAssertionCamelCased'];
                    'application/*+json': components['schemas']['Fido2DomainEntitiesAssertionCommandsMakeAssertionCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/auth/fido2/credentials/label': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRenameCredentialsLabelCamelCased'];
                    'application/json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRenameCredentialsLabelCamelCased'];
                    'application/*+json': components['schemas']['Fido2DomainEntitiesCredentialsCommandsRenameCredentialsLabelCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        trace?: never;
    };
    '/api/v2/auth/completeRegistration': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['DomainEntitiesUserProfilesCommandsCompleteRegistrationCamelCased'];
                    'application/json': components['schemas']['DomainEntitiesUserProfilesCommandsCompleteRegistrationCamelCased'];
                    'application/*+json': components['schemas']['DomainEntitiesUserProfilesCommandsCompleteRegistrationCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/budgets/sync': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                    'application/json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                    'application/*+json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/budgets/sync': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                    'application/json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                    'application/*+json': components['schemas']['BudgetsToggleBudgetsSyncTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/budgets/{budgetId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    budgetId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['BudgetsEditBudgetSettingsTransferCamelCased'];
                    'application/json': components['schemas']['BudgetsEditBudgetSettingsTransferCamelCased'];
                    'application/*+json': components['schemas']['BudgetsEditBudgetSettingsTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['BudgetsQBooksQBooksBudgetAnswerCamelCased'];
                    };
                };
            };
        };
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/budgets': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['BudgetsQBooksQBooksBudgetsAnswersCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/budgets/{budgetId}/sync': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    budgetId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/budgets/{budgetId}/sync': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    budgetId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/requests/{requestId}/budgets': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['BudgetsGetBudgetImpactsAnswerBudgetsQBooksQBooksBudgetImpactAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerV2CompaniesUserCompanyAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CompaniesCompanyDetailsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['CurrenciesSelectCurrenciesAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/features/{feature}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    feature: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['BackendIntegrationFrameworkFeaturesModelsGetFeatureUsageAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                    pageSize?: number;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiIntegrationsCurrencyCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qBooks/currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                    pageSize?: number;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiIntegrationsCurrencyCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/features/trial/request': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/delegations': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerProfileCompanyDelegationsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['ProfileCompanyDelegationsTransferCamelCased'][];
                    'application/json': components['schemas']['ProfileCompanyDelegationsTransferCamelCased'][];
                    'application/*+json': components['schemas']['ProfileCompanyDelegationsTransferCamelCased'][];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/delegations': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ProfileCompanyDelegationsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/groups-of-xero-accounts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    isArchived?: boolean;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsAnswerCamelCased'];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/groups-of-xero-accounts/{groupOfXeroAccountsId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    groupOfXeroAccountsId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsUpdateGroupOfXeroAccountsTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsGroupsOfXeroAccountsUpdateGroupOfXeroAccountsTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsUpdateGroupOfXeroAccountsTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Conflict */
                409: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    groupOfXeroAccountsId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/groups-of-xero-accounts/{groupOfXeroAccountsId}/is-archived': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    groupOfXeroAccountsId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsToggleGroupOfXeroAccountsIsArchivedTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsGroupsOfXeroAccountsToggleGroupOfXeroAccountsIsArchivedTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsToggleGroupOfXeroAccountsIsArchivedTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/groups-of-xero-accounts/{groupOfXeroAccountsId}/versions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    groupOfXeroAccountsId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    groupOfXeroAccountsId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsVersionTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsVersionTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsVersionTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/invitations': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerV2CompaniesUserCompanyInvitationAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/matching/qbooks/suggestions/item-based-line': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    vendorId: string;
                    billDate: string;
                    requestId: string;
                    itemId: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingQBooksMatchingContextCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/matching/qbooks/suggestions/account-based-line': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    vendorId: string;
                    billDate: string;
                    requestId: string;
                    accountItemId: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingQBooksMatchingContextCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/opportunities': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    customerId: string;
                    query?: string;
                    subsidiaryId?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteOpportunityCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/employees': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteEmployeeCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/customers': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    subsidiaryId?: string;
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteCustomerCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/customers/{customerId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                    customerId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteCustomerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/opportunity/{opportunityId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                    opportunityId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteOpportunityCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/lead-source/{name}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                    name: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteLeadSourceCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/lead-sources': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteLeadSourceCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/discount-items': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                    internalIds?: string[];
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteItemCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/partner/{partnerId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                    partnerId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuitePartnerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/partners': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuitePartnerCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/shipping-methods': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    customerId: string;
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteShippingMethodCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/price-levels': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuitePriceLevelCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/customers/{customerId}/project-tasks': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                    pageSize?: number;
                };
                header?: never;
                path: {
                    companyId: string;
                    customerId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteProjectTaskCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/project-tasks/{projectTaskId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    projectTaskId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteProjectTaskCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/tax-accounts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    query?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteTaxAccountCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/{companyId}/netsuite/{documentType}/{sublistType}/amortization-schedules': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul> */
                    documentType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentType'];
                    /** @description <ul><li><i>ExpenseList</i></li><li><i>ItemList</i></li><li><i>LineList</i></li></ul> */
                    sublistType: components['schemas']['NetSuiteRefDataClientContractsModelsDocumentSublistType'];
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiIntegrationsNetSuiteAmortizationScheduleCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/ocr/companies/{companyId}/requests/{requestId}/attachments/{requestAttachmentId}/result': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    requestAttachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2OcrOcrResultAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/ocr/companies/{companyId}/requests/{requestId}/attachments/{attachmentId}/status': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2OcrStatusAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/ocr/companies/{companyId}/requests/{requestId}/attachments/{attachmentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2OcrResultAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/ocr/companies/{companyId}/documents/{documentType}/upload': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @deprecated */
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    documentType: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/ocr/companies/{companyId}/documents/{documentType}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    /** @description <ul><li><i>NetSuite vendor bill</i> - NetSuite-vendor-bill</li><li><i>QBooks bill</i> - QBooks-bill</li><li><i>Xero AP credit note</i> - Xero-creditnotes-payable</li><li><i>Xero bill</i> - Xero-bill</li><li><i>Xero purchase order</i> - Xero-PO</li><li><i>Xero sales invoice</i> - Xero-invoice</li></ul> */
                    documentType: components['schemas']['OcrContractsOcrDocumentTypes'];
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsOCRUploadFilesForOcrTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    offset?: number;
                    limit?: number;
                    nameFilter?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['PagedAnswerApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/{counterpartyId}/paymentDetails/history': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    counterpartyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecordCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/payment-details/requirements': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    currencyCode: string;
                    payeeBankCountry: string;
                    payerBankCountry: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': unknown[];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/payment-details/verify': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                    'application/json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                    'application/*+json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiAmaxPayPaymentDetailsVerificationResultCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/{counterpartyId}/payment-details': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    counterpartyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiAmaxPayPaymentDetailsResultCamelCased'][];
                    };
                };
            };
        };
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    counterpartyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['IntegrationXeroPaymentDetailsV2CreatePaymentDetailsTransferCamelCased'];
                    'application/json': components['schemas']['IntegrationXeroPaymentDetailsV2CreatePaymentDetailsTransferCamelCased'];
                    'application/*+json': components['schemas']['IntegrationXeroPaymentDetailsV2CreatePaymentDetailsTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiAmaxPayPaymentDetailsResultCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/{counterpartyId}/payment-details/{paymentDetailsId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    counterpartyId: string;
                    paymentDetailsId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['IntegrationXeroPaymentDetailsV2PaymentDetailsTransferCamelCased'];
                    'application/json': components['schemas']['IntegrationXeroPaymentDetailsV2PaymentDetailsTransferCamelCased'];
                    'application/*+json': components['schemas']['IntegrationXeroPaymentDetailsV2PaymentDetailsTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiAmaxPayPaymentDetailsResultCamelCased'];
                    };
                };
            };
        };
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    counterpartyId: string;
                    paymentDetailsId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/counterparties/payment-details/validate': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                    'application/json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                    'application/*+json': components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': unknown;
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/amaxPay/openBanking/bankAccounts/{bankAccountId}/balance': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    bankAccountId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2AmaxPayOpenBankingBankAccountBalanceAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    /** @description <ul><li><i>UserDecisionRequired</i> - 0</li><li><i>RequestsUserCanSee</i> - 6</li><li><i>UserSubmittedOpenRequests</i> - 7</li><li><i>UserDraftRequests</i> - 8</li><li><i>UserReviewRequired</i> - 9</li><li><i>UserOcrRequests</i> - 10</li><li><i>UserReadyToPayRequests</i> - 11</li><li><i>UserOnHoldRequests</i> - 12</li></ul> */
                    filter: components['schemas']['RequestsSelectFilterType'];
                    pageSize?: number;
                    continuationToken?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['RequestsSelectRequestsAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/requests': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    /** @description <ul><li><i>UserDecisionRequired</i> - 0</li><li><i>RequestsUserCanSee</i> - 6</li><li><i>UserSubmittedOpenRequests</i> - 7</li><li><i>UserDraftRequests</i> - 8</li><li><i>UserReviewRequired</i> - 9</li><li><i>UserOcrRequests</i> - 10</li><li><i>UserReadyToPayRequests</i> - 11</li><li><i>UserOnHoldRequests</i> - 12</li></ul> */
                    filter: components['schemas']['RequestsSelectFilterType'];
                    pageSize?: number;
                    continuationToken?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['RequestsSelectRequestsAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/xero/requests/duplicates': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    integrationCode: string;
                    amount: number;
                    currency: string;
                    date: string;
                    counterPartyId: string;
                    invoiceNumber?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerRequestSummaryAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/qbooks/requests/duplicates': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    integrationCode: string;
                    amount: number;
                    currency: string;
                    date: string;
                    vendorId: string;
                    invoiceNumber?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerRequestSummaryAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/xero/bills/{billRequestId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['AnswerRequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/xero/bills/{billRequestId}/attachments/{attachmentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    inline: boolean;
                };
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/octet-stream': Blob;
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/airwallex/xero/bills/{billRequestId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['AnswerRequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/airwallex/xero/bills/{billRequestId}/attachments/{attachmentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    inline: boolean;
                };
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/octet-stream': Blob;
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/amaxPay/xero/bills/{billRequestId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['AnswerRequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{batchPaymentRequestId}/amaxPay/xero/bills/{billRequestId}/attachments/{attachmentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    inline: boolean;
                };
                header?: never;
                path: {
                    companyId: string;
                    batchPaymentRequestId: string;
                    billRequestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/octet-stream': Blob;
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/amaxPay/xero/bills/{billRequestId}/transaction': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    billRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['AmaxPayTransactionDetailsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/standalone/requests/{requestId}/currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['CurrenciesSelectCurrenciesAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/versions': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['RequestDetailsVersionsRequestVersionsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/versions/{requestVersion}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    requestVersion: number;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['RequestDetailsVersionsRequestVersionAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/dext/transaction': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['RequestsRequestReceiptBankTransactionDetailsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/currencyExchangeRate': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    currency: string;
                    date: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiRequestsCurrencyExchangeRateAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/vendor-bills/{vendorBillRequestId}/matching/requests': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    vendorBillRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingNetSuiteGetRequestMatchingAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/purchase-orders/{purchaseOrdersRequestId}/matching/requests': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    purchaseOrdersRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingNetSuiteGetRequestMatchingAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/purchase-orders/item-lines/matching': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    vendorBillRequestId?: string;
                    vendorBillLineNumber?: number;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingNetSuiteGetRequestMatchingAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/purchase-orders/expense-lines/matching': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    vendorBillRequestId?: string;
                    vendorBillLineNumber?: number;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MatchingNetSuiteGetRequestMatchingAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/vendor-bills/{sourceRequestId}/item-lines/{sourceLineNumber}/matching/requests/{targetRequestId}/item-lines/{targetLineNumber}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    sourceRequestId: string;
                    sourceLineNumber: number;
                    targetRequestId: string;
                    targetLineNumber: number;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/vendor-bills/{sourceRequestId}/expense-lines/{sourceLineNumber}/matching/requests/{targetRequestId}/expense-lines/{targetLineNumber}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    sourceRequestId: string;
                    sourceLineNumber: number;
                    targetRequestId: string;
                    targetLineNumber: number;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/vendor-bills/{requestId}/item-lines/{lineNumber}/matching': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    lineNumber: number;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/vendor-bills/{requestId}/expense-lines/{lineNumber}/matching': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                    lineNumber: number;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/bill-payments/{billPaymentRequestId}/lines': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    accountId: string;
                    payeeId: string;
                    payeeType: string;
                    currencyId: string;
                    pageSize: number;
                    page: number;
                    reference?: string;
                    amountDueFrom?: number;
                    amountDueTo?: number;
                    originalAmountFrom?: number;
                    originalAmountTo?: number;
                    dateFrom?: string;
                    dateTo?: string;
                    dueDateFrom?: string;
                    dueDateTo?: string;
                    sortColumn?: string;
                    sortOrder?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    billPaymentRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiIntegrationsNetSuiteDocumentAvailableForBillPaymentCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/amaxPay/xero/batchPayments': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2RequestsRequestCreateAnswerCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/batchPayments/{requestId}/amounts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiRequestsBatchPaymentInvoiceAmountsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/bills/{requestId}/batch-payment-amounts': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ApiRequestsBatchPaymentInvoiceAmountsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/requests/duplicates': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    integrationCode: string;
                    amount: number;
                    currency?: string;
                    date: string;
                    vendorId: string;
                    reference?: string;
                };
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerRequestSummaryAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/putOnHold': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsRequestsPutOnHoldTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsRequestsPutOnHoldTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsRequestsPutOnHoldTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/takeOffHold': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['WebApiModelsRequestsTakeOffHoldTransferCamelCased'];
                    'application/json': components['schemas']['WebApiModelsRequestsTakeOffHoldTransferCamelCased'];
                    'application/*+json': components['schemas']['WebApiModelsRequestsTakeOffHoldTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/bill-payments/{billPaymentRequestId}/lines/{lineRequestId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    accountId: string;
                    payeeId: string;
                    payeeType?: string;
                    currencyId: string;
                };
                header?: never;
                path: {
                    companyId: string;
                    billPaymentRequestId: string;
                    lineRequestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['AnswerRequestsLinkedRequestAnswerMatchingNetSuiteBillMatchingInfo'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/netsuite/bill-payments/{billPaymentRequestId}/lines/{lineRequestId}/attachments/{attachmentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query: {
                    accountId: string;
                    payeeId: string;
                    payeeType?: string;
                    currencyId: string;
                    inline: boolean;
                };
                header?: never;
                path: {
                    companyId: string;
                    billPaymentRequestId: string;
                    lineRequestId: string;
                    attachmentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/nudge': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Too Many Requests */
                429: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/itemReceipt/prepared': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['IntegrationsNetSuiteItemReceiptAnswerCamelCased'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Too Many Requests */
                429: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/requests/{requestId}/itemReceipt': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    requestId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptTransferCamelCased'];
                    'application/json': components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptTransferCamelCased'];
                    'application/*+json': components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptTransferCamelCased'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['IntegrationsNetSuiteItemReceiptAnswerCamelCased'];
                    };
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Not Found */
                404: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Unprocessable Content */
                422: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
                /** @description Too Many Requests */
                429: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetailsCamelCased'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/users/me': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CompanyParticipantsCompanyParticipantDetailsAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/users/me/is-workflow-payer': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2WorkflowsIsUserWorkflowPayerAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/amaxPay/wallets': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiAmaxPayWalletsWalletCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/amaxPay/wallets/{currencyCode}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    currencyCode: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerApiAmaxPayWalletsFundingAccountCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/workflows': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['V2CollectionAnswerV2WorkflowsUserCompanyWorkflowAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/workflows/{workflowId}/generatedOcrEmail': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                    workflowId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['WorkflowsGenerateOcrEmailAddressAnswerCamelCased'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v2/companies/{companyId}/workflows/reviewerV1': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    companyId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * Format: string
         * @description <ul><li><i>Annually</i> - 4</li><li><i>AnnuallyWithCustomFirstMonth</i> - 6</li><li><i>Custom</i> - 8</li><li><i>Monthly</i> - 1</li><li><i>Quarterly</i> - 2</li><li><i>Semiannually</i> - 3</li><li><i>YearToDate</i> - 5</li><li><i>YearToDateWithCustomFirstMonth</i> - 7</li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesBudgetCheckPeriod: AccountingDomainEntitiesBudgetCheckPeriod;
        /**
         * Format: string
         * @description <ul><li><i>Ok</i> - 1</li><li><i>Overbudget</i> - 3</li><li><i>Warning</i> - 2</li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesBudgetCheckStatus: AccountingDomainEntitiesBudgetCheckStatus;
        /**
         * Format: string
         * @description <ul><li><i>Consider</i></li><li><i>NotConsider</i></li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesBudgetZeroAmountHandlingType: AccountingDomainEntitiesBudgetZeroAmountHandlingType;
        /**
         * Format: string
         * @description <ul><li><i>NoTax</i> - No Tax</li><li><i>TaxExclusive</i> - Tax Exclusive</li><li><i>TaxInclusive</i> - Tax Inclusive</li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesDocumentsLineAmountType: AccountingDomainEntitiesDocumentsLineAmountType;
        /**
         * Format: string
         * @description <ul><li><i>Failed</i> - failed</li><li><i>InProgress</i> - in-progress</li><li><i>Succeeded</i> - succeeded</li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesSynchronizationStatus: AccountingDomainEntitiesSynchronizationStatus;
        /**
         * Format: string
         * @description <ul><li><i>LockApproval</i> - 0</li><li><i>ApproveWithNextDay</i> - 1</li></ul>
         * @enum {string}
         */
        AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType: AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType;
        AccountingDomainModelsBudgetBreakdownBudgetsQBooksQBooksBudgetAmountsAnswer: {
            monthOfYear: components['schemas']['SharedKernelDatesMonthOfYear'];
            budgetAmounts: components['schemas']['BudgetsQBooksQBooksBudgetAmountsAnswer'];
        };
        AccountingDomainModelsBudgetBreakdownBudgetsQBooksQBooksBudgetAmountsAnswerCamelCased: {
            monthOfYear: components['schemas']['SharedKernelDatesMonthOfYearCamelCased'];
            budgetAmounts: components['schemas']['BudgetsQBooksQBooksBudgetAmountsAnswerCamelCased'];
        };
        /**
         * Format: string
         * @description <ul><li><i>Postal</i> - 0</li><li><i>Physical</i> - 1</li></ul>
         * @enum {string}
         */
        AddressType: AddressType;
        /**
         * Format: string
         * @description <ul><li><i>AudioVisualServices</i> - audio_visual_services</li><li><i>BusinessExpenses</i> - business_expenses</li><li><i>Construction</i> - construction</li><li><i>DonationCharitableContribution</i> - donation_charitable_contribution</li><li><i>EducationTraining</i> - education_training</li><li><i>FamilySupport</i> - family_support</li><li><i>Freight</i> - freight</li><li><i>GoodsPurchased</i> - goods_purchased</li><li><i>InvestmentCapital</i> - investment_capital</li><li><i>InvestmentProceeds</i> - investment_proceeds</li><li><i>LivingExpenses</i> - living_expenses</li><li><i>LoanCreditRepayment</i> - loan_credit_repayment</li><li><i>MedicalServices</i> - medical_services</li><li><i>OtherServices</i> - other_services</li><li><i>Pension</i> - pension</li><li><i>PersonalRemittance</i> - personal_remittance</li><li><i>ProfessionalBusinessServices</i> - professional_business_services</li><li><i>RealEstate</i> - real_estate</li><li><i>Taxes</i> - taxes</li><li><i>TechnicalServices</i> - technical_services</li><li><i>TransferToOwnAccount</i> - transfer_to_own_account</li><li><i>Travel</i> - travel</li><li><i>WagesOrSalary</i> - wages_salary</li></ul>
         * @enum {string}
         */
        AirwallexApiClientAirwallexPaymentPurpose: AirwallexApiClientAirwallexPaymentPurpose;
        /**
         * Format: string
         * @description <ul><li><i>AwaitingPayment</i> - Awaiting Payment</li><li><i>Failed</i></li><li><i>None</i></li><li><i>Paid</i></li><li><i>PartiallyPaid</i> - Partially Paid</li><li><i>Processing</i></li></ul>
         * @enum {string}
         */
        AirwallexDomainEntitiesAirwallexApprovalEntityStatus: AirwallexDomainEntitiesAirwallexApprovalEntityStatus;
        /**
         * Format: string
         * @description <ul><li><i>Local</i> - local</li><li><i>Swift</i> - swift</li></ul>
         * @enum {string}
         */
        AirwallexDomainEntitiesAirwallexBeneficiaryPaymentMethod: AirwallexDomainEntitiesAirwallexBeneficiaryPaymentMethod;
        /**
         * Format: string
         * @description <ul><li><i>Payer</i></li><li><i>Shared</i></li></ul>
         * @enum {string}
         */
        AirwallexDomainEntitiesAirwallexPaymentFee: AirwallexDomainEntitiesAirwallexPaymentFee;
        /**
         * Format: string
         * @description <ul><li><i>NeverPaid</i> - never-paid</li><li><i>NotChecked</i> - not-checked</li><li><i>PaidPreviously</i> - paid-previously</li><li><i>PaymentDetailsChanged</i> - payment-details-changed</li></ul>
         * @enum {string}
         */
        AirwallexDomainEntitiesBeneficiaryPaymentStatus: AirwallexDomainEntitiesBeneficiaryPaymentStatus;
        AmaxPayTransactionDetailsAnswer: {
            friendlyName?: string | null;
            history?: components['schemas']['ApiAmaxPayTransactionDetailsHistory'][] | null;
        };
        AmaxPayTransactionDetailsAnswerCamelCased: {
            friendlyName?: string | null;
            history?: components['schemas']['ApiAmaxPayTransactionDetailsHistoryCamelCased'][] | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>Awaiting Payment</i> - awaiting-payment</li><li><i>Cancelled</i> - cancelled</li><li><i>Failed</i> - failed</li><li><i>None</i> - none</li><li><i>Paid</i> - paid</li><li><i>Partially Paid</i> - partially-paid</li><li><i>Processing</i> - processing</li></ul>
         * @enum {string}
         */
        AmaxPayXeroDomainEntitiesApprovalEntitiesAmaxPayXeroBatchPaymentStatus: AmaxPayXeroDomainEntitiesApprovalEntitiesAmaxPayXeroBatchPaymentStatus;
        /**
         * Format: string
         * @description <ul><li><i>NeverPaid</i> - never-paid</li><li><i>NotChecked</i> - not-checked</li><li><i>PaidPreviously</i> - paid-previously</li><li><i>PaymentDetailsChanged</i> - payment-details-changed</li></ul>
         * @enum {string}
         */
        AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentDetailsPaymentStatus: AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentDetailsPaymentStatus;
        /**
         * Format: string
         * @description <ul><li><i>None</i> - none</li><li><i>OpenBanking</i> - open-banking</li><li><i>VirtualAccount</i> - virtual-account</li></ul>
         * @enum {string}
         */
        AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource: AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource;
        /**
         * Format: string
         * @description <ul><li><i>CancelledByUser</i> - cancelled-by-user</li><li><i>Failed</i> - failed</li><li><i>Paid</i> - paid</li><li><i>Processing</i> - processing</li><li><i>ReadyToPay</i> - ready-to-pay</li><li><i>Scheduled</i> - scheduled</li></ul>
         * @enum {string}
         */
        AmaxPayXeroDomainEntitiesPaymentsAmaxPayPaymentStatus: AmaxPayXeroDomainEntitiesPaymentsAmaxPayPaymentStatus;
        AnswerRequestsLinkedRequestAnswerMatchingNetSuiteBillMatchingInfo: {
            data?: components['schemas']['RequestsLinkedRequestAnswerMatchingNetSuiteBillMatchingInfo'];
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        AnswerRequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo: {
            data?: components['schemas']['RequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo'];
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>Company</i> - company</li><li><i>Individual</i> - individual</li></ul>
         * @enum {string}
         */
        ApiAmaxPayLegalEntityType: ApiAmaxPayLegalEntityType;
        /**
         * Format: string
         * @description <ul><li><i>CloseMatch</i> - close-match</li><li><i>FullMatch</i> - full-match</li><li><i>NoMatch</i> - no-match</li></ul>
         * @enum {string}
         */
        ApiAmaxPayPaymentDetailsAccountVerificationStatus: ApiAmaxPayPaymentDetailsAccountVerificationStatus;
        ApiAmaxPayPaymentDetailsBase: {
            /** Format: uuid */
            readonly Id: string;
            /** Format: uuid */
            readonly VersionId: string;
        };
        ApiAmaxPayPaymentDetailsBaseCamelCased: {
            /** Format: uuid */
            readonly id: string;
            /** Format: uuid */
            readonly versionId: string;
        };
        ApiAmaxPayPaymentDetailsResult: {
            bankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetails'];
            payNetworkName: string;
            isDefault: boolean;
            /** Format: uuid */
            readonly Id: string;
            /** Format: uuid */
            readonly VersionId: string;
        };
        ApiAmaxPayPaymentDetailsResultCamelCased: {
            bankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
            payNetworkName: string;
            isDefault: boolean;
            /** Format: uuid */
            readonly id: string;
            /** Format: uuid */
            readonly versionId: string;
        };
        ApiAmaxPayPaymentDetailsV2BankAccountRouting: {
            BankAccountNumber?: string | null;
            SortCode?: string | null;
            Iban?: string | null;
            BicSwift?: string | null;
            Cnaps?: string | null;
            Clabe?: string | null;
            Bsb?: string | null;
            Aba?: string | null;
            InstitutionNumber?: string | null;
            IncorporationNumber?: string | null;
            BranchCode?: string | null;
            BankCode?: string | null;
            Ifsc?: string | null;
        };
        ApiAmaxPayPaymentDetailsV2BankAccountRoutingCamelCased: {
            bankAccountNumber?: string | null;
            sortCode?: string | null;
            iban?: string | null;
            bicSwift?: string | null;
            cnaps?: string | null;
            clabe?: string | null;
            bsb?: string | null;
            aba?: string | null;
            institutionNumber?: string | null;
            incorporationNumber?: string | null;
            branchCode?: string | null;
            bankCode?: string | null;
            ifsc?: string | null;
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccount: {
            CountryIsoCode: components['schemas']['CountryIsoCode'];
            BankAccountName?: string | null;
            Routing: components['schemas']['ApiAmaxPayPaymentDetailsV2BankAccountRouting'];
            CurrencyIsoCode: components['schemas']['CurrencyIsoCode'];
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountCamelCased: {
            countryIsoCode: components['schemas']['CountryIsoCode'];
            bankAccountName?: string | null;
            routing: components['schemas']['ApiAmaxPayPaymentDetailsV2BankAccountRoutingCamelCased'];
            currencyIsoCode: components['schemas']['CurrencyIsoCode'];
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetails: {
            bankAccount: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccount'];
            legalEntity: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsLegalEntity'];
            paymentType: components['schemas']['ApiAmaxPayPaymentType'];
            validationAndVerification?: unknown;
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased: {
            bankAccount: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountCamelCased'];
            legalEntity: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsLegalEntityCamelCased'];
            paymentType: components['schemas']['ApiAmaxPayPaymentType'];
            validationAndVerification?: unknown;
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsLegalEntity: {
            LegalEntityType: components['schemas']['ApiAmaxPayLegalEntityType'];
            AddressInfo?: components['schemas']['XeroDomainModelsAddressInfo'];
            CompanyName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
        };
        ApiAmaxPayPaymentDetailsV2PaymentDetailsLegalEntityCamelCased: {
            legalEntityType: components['schemas']['ApiAmaxPayLegalEntityType'];
            addressInfo?: components['schemas']['XeroDomainModelsAddressInfoCamelCased'];
            companyName?: string | null;
            firstName?: string | null;
            lastName?: string | null;
        };
        ApiAmaxPayPaymentDetailsVerificationResult: {
            reason: string;
            actualName: string;
            status: components['schemas']['ApiAmaxPayPaymentDetailsAccountVerificationStatus'];
            reasonType: string;
            reasonCode: string;
        };
        ApiAmaxPayPaymentDetailsVerificationResultCamelCased: {
            reason: string;
            actualName: string;
            status: components['schemas']['ApiAmaxPayPaymentDetailsAccountVerificationStatus'];
            reasonType: string;
            reasonCode: string;
        };
        /**
         * Format: string
         * @description <ul><li><i>CloseMatch</i> - close-match</li><li><i>FullMatch</i> - full-match</li><li><i>NoMatch</i> - no-match</li><li><i>NotChecked</i> - not-checked</li></ul>
         * @enum {string}
         */
        ApiAmaxPayPaymentDetailsVerificationStatus: ApiAmaxPayPaymentDetailsVerificationStatus;
        /**
         * Format: string
         * @description <ul><li><i>Priority</i> - priority</li><li><i>Regular</i> - regular</li></ul>
         * @enum {string}
         */
        ApiAmaxPayPaymentType: ApiAmaxPayPaymentType;
        ApiAmaxPayTransactionDetailsHistory: {
            /** Format: date-time */
            date?: string | null;
            status?: components['schemas']['ApiAmaxPayTransactionStatus'];
            source?: string | null;
            /** Format: date-time */
            scheduledDate?: string | null;
        };
        ApiAmaxPayTransactionDetailsHistoryCamelCased: {
            /** Format: date-time */
            date?: string | null;
            status?: components['schemas']['ApiAmaxPayTransactionStatus'];
            source?: string | null;
            /** Format: date-time */
            scheduledDate?: string | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>Failed</i> - failed</li><li><i>Initiated</i> - initiated</li><li><i>Paid</i> - paid</li><li><i>Processing</i> - processing</li><li><i>Scheduled</i> - scheduled</li><li><i>Unknown</i> - unknown</li></ul>
         * @enum {string}
         */
        ApiAmaxPayTransactionStatus: ApiAmaxPayTransactionStatus;
        ApiAmaxPayWalletsFundingAccount: {
            Title: string;
            Description: string;
            Properties: components['schemas']['ApiAmaxPayWalletsFundingAccountProperty'][];
        };
        ApiAmaxPayWalletsFundingAccountCamelCased: {
            title: string;
            description: string;
            properties: components['schemas']['ApiAmaxPayWalletsFundingAccountPropertyCamelCased'][];
        };
        ApiAmaxPayWalletsFundingAccountProperty: {
            Field: string;
            Value: string;
        };
        ApiAmaxPayWalletsFundingAccountPropertyCamelCased: {
            field: string;
            value: string;
        };
        ApiAmaxPayWalletsWallet: {
            /** Format: double */
            Balance: number;
            CurrencyCode: string;
            /** Format: date-time */
            CreatedAt: string;
        };
        ApiAmaxPayWalletsWalletCamelCased: {
            /** Format: double */
            balance: number;
            currencyCode: string;
            /** Format: date-time */
            createdAt: string;
        };
        ApiAmaxPayXeroAmaxPayXeroBatchPayment: {
            /** Format: uuid */
            amaxPayXeroBatchPaymentId: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            modifiedAt: string;
            /** Format: int32 */
            number?: number | null;
            paymentSource: components['schemas']['AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource'];
            status: components['schemas']['AmaxPayXeroDomainEntitiesApprovalEntitiesAmaxPayXeroBatchPaymentStatus'];
            isMergedBySupplier: boolean;
            items?: components['schemas']['ApiAmaxPayXeroAmaxPayXeroBatchPaymentItem'][] | null;
        };
        ApiAmaxPayXeroAmaxPayXeroBatchPaymentItem: {
            /** Format: uuid */
            xeroBillInvoiceRequestId: string;
            friendlyName: string;
            /** Format: double */
            billInvoiceAmount?: number | null;
            /** Format: date-time */
            date: string;
            /** Format: date-time */
            dueDate: string;
            /** Format: double */
            amountDue?: number | null;
            currency?: components['schemas']['CurrencyIsoCode'];
            contact?: components['schemas']['OptionallyNamedObjectGuid'];
            paymentSource: components['schemas']['AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource'];
            amaxPayBankAccount?: components['schemas']['OptionallyNamedObjectGuid'];
            paymentDetails?: components['schemas']['ApiAmaxPayXeroPaymentDetails'];
            paymentReference?: string | null;
            /** Format: double */
            amount?: number | null;
            xeroUrl?: string | null;
            paymentStatus?: components['schemas']['AmaxPayXeroDomainEntitiesPaymentsAmaxPayPaymentStatus'];
            /** Format: date-time */
            statusUpdatedAt?: string | null;
            paymentDetailsPaymentStatus?: components['schemas']['AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentDetailsPaymentStatus'];
            attachments?: components['schemas']['AttachmentAnswer'][] | null;
            referenceToAmaxPayId?: string | null;
            /** Format: date-time */
            scheduledDate?: string | null;
        };
        ApiAmaxPayXeroPaymentDetails: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            versionId: string;
            name?: string | null;
        };
        ApiIntegrationsAddress: {
            AddressType?: components['schemas']['AddressType'];
            AddressLine1?: string | null;
            AddressLine2?: string | null;
            AddressLine3?: string | null;
            AddressLine4?: string | null;
            City?: string | null;
            Region?: string | null;
            PostalCode?: string | null;
            Country?: string | null;
            AttentionTo?: string | null;
        };
        ApiIntegrationsAddressCamelCased: {
            addressType?: components['schemas']['AddressType'];
            addressLine1?: string | null;
            addressLine2?: string | null;
            addressLine3?: string | null;
            addressLine4?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
            attentionTo?: string | null;
        };
        ApiIntegrationsAirwallexAirwallexBeneficiaryBankDetails: {
            accountName?: string | null;
            accountNumber?: string | null;
            iban?: string | null;
            swiftCode?: string | null;
            bankCountryCode?: components['schemas']['CountryIsoCode'];
            bankName?: string | null;
            bankBranch?: string | null;
            localClearingSystem?: string | null;
            accountingRoutingType1?: string | null;
            accountingRoutingType2?: string | null;
            accountingRoutingValue1?: string | null;
            accountingRoutingValue2?: string | null;
        };
        ApiIntegrationsAirwallexAirwallexBeneficiaryBankDetailsCamelCased: {
            accountName?: string | null;
            accountNumber?: string | null;
            iban?: string | null;
            swiftCode?: string | null;
            bankCountryCode?: components['schemas']['CountryIsoCode'];
            bankName?: string | null;
            bankBranch?: string | null;
            localClearingSystem?: string | null;
            accountingRoutingType1?: string | null;
            accountingRoutingType2?: string | null;
            accountingRoutingValue1?: string | null;
            accountingRoutingValue2?: string | null;
        };
        ApiIntegrationsAirwallexAirwallexBeneficiaryVersion: {
            /** Format: uuid */
            airwallexBeneficiaryId: string;
            name?: string | null;
            /** Format: int32 */
            version: number;
            accountCurrency?: components['schemas']['CurrencyIsoCode'];
            paymentMethod?: components['schemas']['AirwallexDomainEntitiesAirwallexBeneficiaryPaymentMethod'];
            bankDetails?: components['schemas']['ApiIntegrationsAirwallexAirwallexBeneficiaryBankDetails'];
            isDeleted: boolean;
        };
        ApiIntegrationsAirwallexAirwallexBeneficiaryVersionCamelCased: {
            /** Format: uuid */
            airwallexBeneficiaryId: string;
            name?: string | null;
            /** Format: int32 */
            version: number;
            accountCurrency?: components['schemas']['CurrencyIsoCode'];
            paymentMethod?: components['schemas']['AirwallexDomainEntitiesAirwallexBeneficiaryPaymentMethod'];
            bankDetails?: components['schemas']['ApiIntegrationsAirwallexAirwallexBeneficiaryBankDetailsCamelCased'];
            isDeleted: boolean;
        };
        ApiIntegrationsAirwallexLastPaymentBeneficiaryDiscrepancy: {
            /** Format: uuid */
            airwallexBeneficiaryId: string;
            beneficiaryName?: string | null;
            lastPaymentProperties?: components['schemas']['ApiIntegrationsPropertyDifference'][] | null;
        };
        ApiIntegrationsAirwallexLastPaymentBeneficiaryDiscrepancyCamelCased: {
            /** Format: uuid */
            airwallexBeneficiaryId: string;
            beneficiaryName?: string | null;
            lastPaymentProperties?: components['schemas']['ApiIntegrationsPropertyDifferenceCamelCased'][] | null;
        };
        ApiIntegrationsContact: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsContactCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsContactPerson: {
            FirstName?: string | null;
            LastName?: string | null;
            EmailAddress?: string | null;
            IncludeInEmails?: boolean | null;
        };
        ApiIntegrationsContactPersonCamelCased: {
            firstName?: string | null;
            lastName?: string | null;
            emailAddress?: string | null;
            includeInEmails?: boolean | null;
        };
        ApiIntegrationsCurrency: {
            readonly Id?: string | null;
            ISOCode?: components['schemas']['CurrencyIsoCode'];
            Name?: string | null;
            /** Format: double */
            RateToCompanyCurrency?: number | null;
        };
        ApiIntegrationsCurrencyCamelCased: {
            readonly id?: string | null;
            iSOCode?: components['schemas']['CurrencyIsoCode'];
            name?: string | null;
            /** Format: double */
            rateToCompanyCurrency?: number | null;
        };
        ApiIntegrationsNetSuiteAmortizationSchedule: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteAmortizationScheduleCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteCustomer: {
            Addresses?: components['schemas']['NetSuiteDomainEntitiesApprovalEntitiesNetSuiteAddress'][] | null;
            Currency?: components['schemas']['NetSuiteDomainEntitiesRecordRef'];
            Partner?: components['schemas']['NetSuiteDomainEntitiesRecordRef'];
            LeadSource?: components['schemas']['NetSuiteDomainEntitiesRecordRef'];
            SalesRep?: components['schemas']['NetSuiteDomainEntitiesRecordRef'];
            TaxNumber?: string | null;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteCustomerCamelCased: {
            addresses?:
                | components['schemas']['NetSuiteDomainEntitiesApprovalEntitiesNetSuiteAddressCamelCased'][]
                | null;
            currency?: components['schemas']['NetSuiteDomainEntitiesRecordRefCamelCased'];
            partner?: components['schemas']['NetSuiteDomainEntitiesRecordRefCamelCased'];
            leadSource?: components['schemas']['NetSuiteDomainEntitiesRecordRefCamelCased'];
            salesRep?: components['schemas']['NetSuiteDomainEntitiesRecordRefCamelCased'];
            taxNumber?: string | null;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteDocumentAvailableForBillPayment: {
            Type: string;
            /** Format: uuid */
            RequestId: string;
            FriendlyName: string;
            CurrencyName?: string | null;
            /** Format: double */
            DiscountAvailable?: number | null;
            /** Format: date-time */
            DiscountDate?: string | null;
            TransactionId?: string | null;
            /** Format: double */
            AmountDue?: number | null;
            /** Format: double */
            OriginalAmount?: number | null;
            /** Format: date-time */
            DateDue?: string | null;
            Reference?: string | null;
            Url?: string | null;
            Attachments: components['schemas']['AttachmentAnswer'][];
        };
        ApiIntegrationsNetSuiteDocumentAvailableForBillPaymentCamelCased: {
            type: string;
            /** Format: uuid */
            requestId: string;
            friendlyName: string;
            currencyName?: string | null;
            /** Format: double */
            discountAvailable?: number | null;
            /** Format: date-time */
            discountDate?: string | null;
            transactionId?: string | null;
            /** Format: double */
            amountDue?: number | null;
            /** Format: double */
            originalAmount?: number | null;
            /** Format: date-time */
            dateDue?: string | null;
            reference?: string | null;
            url?: string | null;
            attachments: components['schemas']['AttachmentAnswerCamelCased'][];
        };
        ApiIntegrationsNetSuiteEmployee: {
            DefaultCurrencyId?: string | null;
            CurrencyIds?: string[] | null;
            Addresses?: components['schemas']['ApiIntegrationsNetSuiteEmployeeAddress'][] | null;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteEmployeeAddress: {
            IsDefaultBillings: boolean;
            IsDefaultShipping: boolean;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteEmployeeAddressCamelCased: {
            isDefaultBillings: boolean;
            isDefaultShipping: boolean;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteEmployeeCamelCased: {
            defaultCurrencyId?: string | null;
            currencyIds?: string[] | null;
            addresses?: components['schemas']['ApiIntegrationsNetSuiteEmployeeAddressCamelCased'][] | null;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteItem: {
            Units?: components['schemas']['ApiIntegrationsNetSuiteUnit'][] | null;
            /** Format: double */
            PurchasePrices?: number | null;
            PurchaseDescription?: string | null;
            ItemsOnGroup?: components['schemas']['ApiIntegrationsNetSuiteItemMember'][] | null;
            BasePrice?: string | null;
            Type?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsItemType'];
            SalesPrices?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPricing'][] | null;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteItemCamelCased: {
            units?: components['schemas']['ApiIntegrationsNetSuiteUnitCamelCased'][] | null;
            /** Format: double */
            purchasePrices?: number | null;
            purchaseDescription?: string | null;
            itemsOnGroup?: components['schemas']['ApiIntegrationsNetSuiteItemMemberCamelCased'][] | null;
            basePrice?: string | null;
            type?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsItemType'];
            salesPrices?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPricingCamelCased'][] | null;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteItemMember: {
            InternalId: string;
            Name?: string | null;
            /** Format: double */
            Quantity?: number | null;
        };
        ApiIntegrationsNetSuiteItemMemberCamelCased: {
            internalId: string;
            name?: string | null;
            /** Format: double */
            quantity?: number | null;
        };
        ApiIntegrationsNetSuiteLeadSource: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteLeadSourceCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteOpportunity: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteOpportunityCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuitePartner: {
            PartnerCode?: string | null;
            CompanyName?: string | null;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuitePartnerCamelCased: {
            partnerCode?: string | null;
            companyName?: string | null;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuitePriceLevel: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuitePriceLevelCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteProjectTask: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteProjectTaskCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteShippingMethod: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteShippingMethodCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteTaxAccount: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteTaxAccountCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsNetSuiteUnit: {
            IsItemPrimaryPurchaseUnit?: boolean | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsNetSuiteUnitCamelCased: {
            isItemPrimaryPurchaseUnit?: boolean | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsPropertyDifference: {
            name: string;
            value: string;
        };
        ApiIntegrationsPropertyDifferenceCamelCased: {
            name: string;
            value: string;
        };
        ApiIntegrationsQBooksAccount: {
            Id?: string | null;
            Code?: string | null;
            Name?: string | null;
            FullyQualifiedName?: string | null;
            ParentId?: string | null;
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            CurrencyCode?: string | null;
            Type?: string | null;
            Classification?: string | null;
            Currency?: components['schemas']['ApiIntegrationsCurrency'];
        };
        ApiIntegrationsQBooksAccountCamelCased: {
            id?: string | null;
            code?: string | null;
            name?: string | null;
            fullyQualifiedName?: string | null;
            parentId?: string | null;
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            currencyCode?: string | null;
            type?: string | null;
            classification?: string | null;
            currency?: components['schemas']['ApiIntegrationsCurrencyCamelCased'];
        };
        ApiIntegrationsQBooksClass: {
            Id?: string | null;
            Name?: string | null;
            ParentId?: string | null;
        };
        ApiIntegrationsQBooksClassCamelCased: {
            id?: string | null;
            name?: string | null;
            parentId?: string | null;
        };
        ApiIntegrationsQBooksCustomField: {
            Id?: string | null;
            Name?: string | null;
            Value?: string | null;
        };
        ApiIntegrationsQBooksCustomFieldCamelCased: {
            id?: string | null;
            name?: string | null;
            value?: string | null;
        };
        ApiIntegrationsQBooksDepartment: {
            Id?: string | null;
            Name?: string | null;
            ParentId?: string | null;
        };
        ApiIntegrationsQBooksDepartmentCamelCased: {
            id?: string | null;
            name?: string | null;
            parentId?: string | null;
        };
        ApiIntegrationsQBooksExpenseTaxComponent: {
            /** Format: double */
            TaxAmount: number;
            /** Format: double */
            TaxableAmount: number;
            /** Format: double */
            TaxPercent: number;
            TaxRateId?: string | null;
            Hidden: boolean;
        };
        ApiIntegrationsQBooksExpenseTaxComponentCamelCased: {
            /** Format: double */
            taxAmount: number;
            /** Format: double */
            taxableAmount: number;
            /** Format: double */
            taxPercent: number;
            taxRateId?: string | null;
            hidden: boolean;
        };
        ApiIntegrationsQBooksJournalEntryTaxComponent: {
            /** Format: double */
            TaxDebitAmount: number;
            /** Format: double */
            TaxCreditAmount: number;
            /** Format: double */
            TaxableDebitAmount: number;
            /** Format: double */
            TaxableCreditAmount: number;
            TaxCodeName?: string | null;
            TaxCodeId?: string | null;
            TaxApplicableOnType?: components['schemas']['QBooksDomainEntitiesDocumentsJournalEntriesTaxApplicableOnType'];
            /** Format: double */
            TaxPercent: number;
            TaxRateId?: string | null;
            Hidden: boolean;
        };
        ApiIntegrationsQBooksPayee: {
            Id?: string | null;
            Name?: string | null;
            Currency?: components['schemas']['ApiIntegrationsCurrency'];
            Addresses?: components['schemas']['ApiIntegrationsAddress'][] | null;
            ContactPersons?: components['schemas']['ApiIntegrationsContactPerson'][] | null;
            Email?: string | null;
            TaxId?: string | null;
        };
        ApiIntegrationsQBooksPayeeCamelCased: {
            id?: string | null;
            name?: string | null;
            currency?: components['schemas']['ApiIntegrationsCurrencyCamelCased'];
            addresses?: components['schemas']['ApiIntegrationsAddressCamelCased'][] | null;
            contactPersons?: components['schemas']['ApiIntegrationsContactPersonCamelCased'][] | null;
            email?: string | null;
            taxId?: string | null;
        };
        ApiIntegrationsQBooksPayeeType: {
            Value?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsQBooksPayeeTypeCamelCased: {
            value?: string | null;
            name?: string | null;
        };
        ApiIntegrationsQBooksPaymentMethod: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsQBooksPaymentMethodCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsQBooksPaymentType: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsQBooksPaymentTypeCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsQBooksTaxCode: {
            Id?: string | null;
            Name?: string | null;
            TaxCodeId?: string | null;
            PurchaseTaxRateList?: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRef'][] | null;
            SalesTaxRateList?: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRef'][] | null;
        };
        ApiIntegrationsQBooksTaxCodeCamelCased: {
            id?: string | null;
            name?: string | null;
            taxCodeId?: string | null;
            purchaseTaxRateList?: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRefCamelCased'][] | null;
            salesTaxRateList?: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRefCamelCased'][] | null;
        };
        ApiIntegrationsQBooksTaxCodeTaxRateRef: {
            TaxRateId?: string | null;
            TaxApplicable: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRefTaxTypeApplicable'];
            /** Format: int32 */
            TaxOnTaxOrder: number;
        };
        ApiIntegrationsQBooksTaxCodeTaxRateRefCamelCased: {
            taxRateId?: string | null;
            taxApplicable: components['schemas']['ApiIntegrationsQBooksTaxCodeTaxRateRefTaxTypeApplicable'];
            /** Format: int32 */
            taxOnTaxOrder: number;
        };
        /**
         * Format: string
         * @description <ul><li><i>TaxOnAmount</i> - 0</li><li><i>TaxOnAmountPlusTax</i> - 1</li><li><i>TaxOnTax</i> - 2</li></ul>
         * @enum {string}
         */
        ApiIntegrationsQBooksTaxCodeTaxRateRefTaxTypeApplicable: ApiIntegrationsQBooksTaxCodeTaxRateRefTaxTypeApplicable;
        ApiIntegrationsQBooksTerm: {
            Id?: string | null;
            Name?: string | null;
        };
        ApiIntegrationsQBooksTermCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        ApiIntegrationsXeroPaymentDetailsCounterparty: {
            /** Format: uuid */
            readonly counterpartyId: string;
            readonly name: string;
            billingAddress?: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyBillingAddress'];
            readonly isSupplier?: boolean | null;
            readonly isCustomer?: boolean | null;
            financialDetails: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyFinancialDetails'];
            readonly url: string;
            readonly paymentDetails?: components['schemas']['ApiAmaxPayPaymentDetailsBase'][] | null;
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyBillingAddress: {
            addressLine1?: string | null;
            addressLine2?: string | null;
            addressLine3?: string | null;
            addressLine4?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyBillingAddressCamelCased: {
            addressLine1?: string | null;
            addressLine2?: string | null;
            addressLine3?: string | null;
            addressLine4?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased: {
            /** Format: uuid */
            readonly counterpartyId: string;
            readonly name: string;
            billingAddress?: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyBillingAddressCamelCased'];
            readonly isSupplier?: boolean | null;
            readonly isCustomer?: boolean | null;
            financialDetails: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyFinancialDetailsCamelCased'];
            readonly url: string;
            readonly paymentDetails?: components['schemas']['ApiAmaxPayPaymentDetailsBaseCamelCased'][] | null;
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyFinancialDetails: {
            bankAccountName?: string | null;
            sortCode?: string | null;
            bankAccountNumber?: string | null;
            reference?: string | null;
            currency: components['schemas']['CurrencyIsoCode'];
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyFinancialDetailsCamelCased: {
            bankAccountName?: string | null;
            sortCode?: string | null;
            bankAccountNumber?: string | null;
            reference?: string | null;
            currency: components['schemas']['CurrencyIsoCode'];
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecord: {
            /** Format: uuid */
            readonly paymentDetailsId: string;
            /** Format: uuid */
            readonly paymentDetailsVersionId: string;
            eventType: components['schemas']['ApiIntegrationsXeroPaymentDetailsEventType'];
            readonly bankAccountName: string;
            /** Format: date-time */
            readonly createdDate: string;
            author: components['schemas']['UserAnswer'];
        };
        ApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecordCamelCased: {
            /** Format: uuid */
            readonly paymentDetailsId: string;
            /** Format: uuid */
            readonly paymentDetailsVersionId: string;
            eventType: components['schemas']['ApiIntegrationsXeroPaymentDetailsEventType'];
            readonly bankAccountName: string;
            /** Format: date-time */
            readonly createdDate: string;
            author: components['schemas']['UserAnswerCamelCased'];
        };
        /**
         * Format: string
         * @description <ul><li><i>Create</i> - create</li><li><i>Delete</i> - delete</li><li><i>Unspecified</i> - unspecified</li><li><i>Update</i> - update</li></ul>
         * @enum {string}
         */
        ApiIntegrationsXeroPaymentDetailsEventType: ApiIntegrationsXeroPaymentDetailsEventType;
        ApiRequestsBatchPaymentInvoiceAmountsAnswer: {
            /** Format: uuid */
            invoiceRequestId: string;
            /** Format: double */
            amountOnReview: number;
            /** Format: double */
            amountOnApproval: number;
            /** Format: double */
            amountAwaitingPayment: number;
            /** Format: double */
            amountInProcessing: number;
        };
        ApiRequestsBatchPaymentInvoiceAmountsAnswerCamelCased: {
            /** Format: uuid */
            invoiceRequestId: string;
            /** Format: double */
            amountOnReview: number;
            /** Format: double */
            amountOnApproval: number;
            /** Format: double */
            amountAwaitingPayment: number;
            /** Format: double */
            amountInProcessing: number;
        };
        ApiRequestsCurrencyExchangeRateAnswer: {
            source: components['schemas']['DomainEntitiesExchangeRateSource'];
            isoCode: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            exchangeRate: number;
        };
        ApiRequestsCurrencyExchangeRateAnswerCamelCased: {
            source: components['schemas']['DomainEntitiesExchangeRateSource'];
            isoCode: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            exchangeRate: number;
        };
        AttachmentAnswer: {
            /** Format: uuid */
            Id: string;
            /** Format: uuid */
            AttachmentId: string;
            Name?: string | null;
            /** Format: int64 */
            Size: number;
            CreatedDate?: string | null;
            Author?: components['schemas']['UserAnswer'];
            AttachmentType: components['schemas']['DomainEntitiesAttachmentType'];
            UploadResult?: components['schemas']['FilesFileUploadResult'];
            ExternalId?: string | null;
            OcrStatus?: components['schemas']['DomainEntitiesOcrOcrStatus'];
            IsOcrOngoing: boolean;
        };
        AttachmentAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            attachmentId: string;
            name?: string | null;
            /** Format: int64 */
            size: number;
            createdDate?: string | null;
            author?: components['schemas']['UserAnswerCamelCased'];
            attachmentType: components['schemas']['DomainEntitiesAttachmentType'];
            uploadResult?: components['schemas']['FilesFileUploadResult'];
            externalId?: string | null;
            ocrStatus?: components['schemas']['DomainEntitiesOcrOcrStatus'];
            isOcrOngoing: boolean;
        };
        BackendCoreOcrOcrFileUploadOptions: {
            FileContentType: components['schemas']['OcrContractsOcrFileContentType'];
        };
        BackendCoreOcrOcrFileUploadOptionsCamelCased: {
            fileContentType: components['schemas']['OcrContractsOcrFileContentTypeCamelCased'];
        };
        BackendIntegrationFrameworkFeaturesModelsGetFeatureUsageAnswer: {
            HasBeenUsed: boolean;
        };
        BackendIntegrationFrameworkFeaturesModelsGetFeatureUsageAnswerCamelCased: {
            hasBeenUsed: boolean;
        };
        BudgetsEditBudgetSettingsTransfer: {
            IsEnabled?: boolean | null;
            CheckPeriod?: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            CheckPeriodFirstMonth?: components['schemas']['SharedKernelDatesMonth'];
            ZeroAmountHandlingType?: components['schemas']['AccountingDomainEntitiesBudgetZeroAmountHandlingType'];
        };
        BudgetsEditBudgetSettingsTransferCamelCased: {
            isEnabled?: boolean | null;
            checkPeriod?: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            checkPeriodFirstMonth?: components['schemas']['SharedKernelDatesMonthCamelCased'];
            zeroAmountHandlingType?: components['schemas']['AccountingDomainEntitiesBudgetZeroAmountHandlingType'];
        };
        BudgetsGetBudgetImpactsAnswerBudgetsQBooksQBooksBudgetImpactAnswer: {
            readonly currency: string;
            readonly budgetImpacts: components['schemas']['BudgetsQBooksQBooksBudgetImpactAnswer'][];
        };
        BudgetsGetBudgetImpactsAnswerBudgetsQBooksQBooksBudgetImpactAnswerCamelCased: {
            readonly currency: string;
            readonly budgetImpacts: components['schemas']['BudgetsQBooksQBooksBudgetImpactAnswerCamelCased'][];
        };
        /**
         * Format: string
         * @description <ul><li><i>Class</i> - class</li><li><i>Customer</i> - customer</li><li><i>Location</i> - location</li><li><i>None</i> - none</li></ul>
         * @enum {string}
         */
        BudgetsQBooksDimensionType: BudgetsQBooksDimensionType;
        BudgetsQBooksQBooksBudgetAmountsAnswer: {
            /** Format: double */
            remainingAmount: number;
            /** Format: double */
            billOnReviewAmount: number;
            /** Format: double */
            poOnReviewAmount: number;
            /** Format: double */
            expensesApprovedAmount: number;
            /** Format: double */
            expensesOnReviewAmount: number;
            /** Format: double */
            expensesSubmittedAmount: number;
            /** Format: double */
            plannedAmount: number;
            /** Format: double */
            billApprovedAmount: number;
            /** Format: double */
            billSubmittedAmount: number;
            /** Format: double */
            poApprovedAmount: number;
            /** Format: double */
            poSubmittedAmount: number;
        };
        BudgetsQBooksQBooksBudgetAmountsAnswerCamelCased: {
            /** Format: double */
            remainingAmount: number;
            /** Format: double */
            billOnReviewAmount: number;
            /** Format: double */
            poOnReviewAmount: number;
            /** Format: double */
            expensesApprovedAmount: number;
            /** Format: double */
            expensesOnReviewAmount: number;
            /** Format: double */
            expensesSubmittedAmount: number;
            /** Format: double */
            plannedAmount: number;
            /** Format: double */
            billApprovedAmount: number;
            /** Format: double */
            billSubmittedAmount: number;
            /** Format: double */
            poApprovedAmount: number;
            /** Format: double */
            poSubmittedAmount: number;
        };
        BudgetsQBooksQBooksBudgetAnswer: {
            synchronizationStatus: components['schemas']['AccountingDomainEntitiesSynchronizationStatus'];
            /** Format: date-time */
            lastSyncDate?: string | null;
            subdividedBy: components['schemas']['BudgetsQBooksSubdividedByAnswer'];
            periodFrom: components['schemas']['SharedKernelDatesMonthOfYear'];
            periodTill: components['schemas']['SharedKernelDatesMonthOfYear'];
            budgetId?: string | null;
            name: string;
            /** Format: date-time */
            modifiedDate: string;
            checkPeriod: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            checkPeriodFirstMonth?: components['schemas']['SharedKernelDatesMonth'];
            isEnabled: boolean;
            zeroAmountHandlingType?: components['schemas']['AccountingDomainEntitiesBudgetZeroAmountHandlingType'];
        };
        BudgetsQBooksQBooksBudgetAnswerCamelCased: {
            synchronizationStatus: components['schemas']['AccountingDomainEntitiesSynchronizationStatus'];
            /** Format: date-time */
            lastSyncDate?: string | null;
            subdividedBy: components['schemas']['BudgetsQBooksSubdividedByAnswerCamelCased'];
            periodFrom: components['schemas']['SharedKernelDatesMonthOfYearCamelCased'];
            periodTill: components['schemas']['SharedKernelDatesMonthOfYearCamelCased'];
            budgetId?: string | null;
            name: string;
            /** Format: date-time */
            modifiedDate: string;
            checkPeriod: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            checkPeriodFirstMonth?: components['schemas']['SharedKernelDatesMonthCamelCased'];
            isEnabled: boolean;
            zeroAmountHandlingType?: components['schemas']['AccountingDomainEntitiesBudgetZeroAmountHandlingType'];
        };
        BudgetsQBooksQBooksBudgetImpactAnswer: {
            readonly BudgetId: string;
            readonly BudgetName: string;
            BudgetCheckPeriod: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            readonly AccountName: string;
            BudgetBreakdowns: components['schemas']['AccountingDomainModelsBudgetBreakdownBudgetsQBooksQBooksBudgetAmountsAnswer'][];
            BudgetAmounts: components['schemas']['BudgetsQBooksQBooksBudgetAmountsAnswer'];
            BudgetPeriodStart: components['schemas']['SharedKernelDatesMonthOfYear'];
            BudgetPeriodEnd: components['schemas']['SharedKernelDatesMonthOfYear'];
            LineItemIds: string[];
            /** Format: double */
            LinesAmount: number;
            SubdividedBy: components['schemas']['BudgetsQBooksSubdividedByAnswer'];
            BudgetCheckStatus: components['schemas']['AccountingDomainEntitiesBudgetCheckStatus'];
        };
        BudgetsQBooksQBooksBudgetImpactAnswerCamelCased: {
            readonly budgetId: string;
            readonly budgetName: string;
            budgetCheckPeriod: components['schemas']['AccountingDomainEntitiesBudgetCheckPeriod'];
            readonly accountName: string;
            budgetBreakdowns: components['schemas']['AccountingDomainModelsBudgetBreakdownBudgetsQBooksQBooksBudgetAmountsAnswerCamelCased'][];
            budgetAmounts: components['schemas']['BudgetsQBooksQBooksBudgetAmountsAnswerCamelCased'];
            budgetPeriodStart: components['schemas']['SharedKernelDatesMonthOfYearCamelCased'];
            budgetPeriodEnd: components['schemas']['SharedKernelDatesMonthOfYearCamelCased'];
            lineItemIds: string[];
            /** Format: double */
            linesAmount: number;
            subdividedBy: components['schemas']['BudgetsQBooksSubdividedByAnswerCamelCased'];
            budgetCheckStatus: components['schemas']['AccountingDomainEntitiesBudgetCheckStatus'];
        };
        BudgetsQBooksQBooksBudgetsAnswers: {
            isSyncEnabled: boolean;
            items: components['schemas']['BudgetsQBooksQBooksBudgetAnswer'][];
        };
        BudgetsQBooksQBooksBudgetsAnswersCamelCased: {
            isSyncEnabled: boolean;
            items: components['schemas']['BudgetsQBooksQBooksBudgetAnswerCamelCased'][];
        };
        BudgetsQBooksSubdividedByAnswer: {
            type: components['schemas']['BudgetsQBooksDimensionType'];
            value?: string | null;
            label?: string | null;
        };
        BudgetsQBooksSubdividedByAnswerCamelCased: {
            type: components['schemas']['BudgetsQBooksDimensionType'];
            value?: string | null;
            label?: string | null;
        };
        BudgetsToggleBudgetsSyncTransfer: {
            IsEnabled: boolean;
        };
        BudgetsToggleBudgetsSyncTransferCamelCased: {
            isEnabled: boolean;
        };
        CompaniesWorkflowInfoAnswer: {
            /** Format: uuid */
            id: string;
            name?: string | null;
            /** Format: uuid */
            companyId: string;
            integrationCode?: string | null;
            enabled: boolean;
        };
        CompaniesWorkflowInfoAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            name?: string | null;
            /** Format: uuid */
            companyId: string;
            integrationCode?: string | null;
            enabled: boolean;
        };
        /**
         * Format: string
         * @description <ul><li><i>AD</i></li><li><i>AE</i></li><li><i>AF</i></li><li><i>AG</i></li><li><i>AI</i></li><li><i>AL</i></li><li><i>AM</i></li><li><i>AO</i></li><li><i>AQ</i></li><li><i>AR</i></li><li><i>AS</i></li><li><i>AT</i></li><li><i>AU</i></li><li><i>AW</i></li><li><i>AX</i></li><li><i>AZ</i></li><li><i>BA</i></li><li><i>BB</i></li><li><i>BD</i></li><li><i>BE</i></li><li><i>BF</i></li><li><i>BG</i></li><li><i>BH</i></li><li><i>BI</i></li><li><i>BJ</i></li><li><i>BL</i></li><li><i>BM</i></li><li><i>BN</i></li><li><i>BO</i></li><li><i>BQ</i></li><li><i>BR</i></li><li><i>BS</i></li><li><i>BT</i></li><li><i>BV</i></li><li><i>BW</i></li><li><i>BY</i></li><li><i>BZ</i></li><li><i>CA</i></li><li><i>CC</i></li><li><i>CD</i></li><li><i>CF</i></li><li><i>CG</i></li><li><i>CH</i></li><li><i>CI</i></li><li><i>CK</i></li><li><i>CL</i></li><li><i>CM</i></li><li><i>CN</i></li><li><i>CO</i></li><li><i>CR</i></li><li><i>CU</i></li><li><i>CV</i></li><li><i>CW</i></li><li><i>CX</i></li><li><i>CY</i></li><li><i>CZ</i></li><li><i>DE</i></li><li><i>DJ</i></li><li><i>DK</i></li><li><i>DM</i></li><li><i>DO</i></li><li><i>DZ</i></li><li><i>EC</i></li><li><i>EE</i></li><li><i>EG</i></li><li><i>EH</i></li><li><i>ER</i></li><li><i>ES</i></li><li><i>ET</i></li><li><i>FI</i></li><li><i>FJ</i></li><li><i>FK</i></li><li><i>FM</i></li><li><i>FO</i></li><li><i>FR</i></li><li><i>GA</i></li><li><i>GB</i></li><li><i>GD</i></li><li><i>GE</i></li><li><i>GF</i></li><li><i>GG</i></li><li><i>GH</i></li><li><i>GI</i></li><li><i>GL</i></li><li><i>GM</i></li><li><i>GN</i></li><li><i>GP</i></li><li><i>GQ</i></li><li><i>GR</i></li><li><i>GS</i></li><li><i>GT</i></li><li><i>GU</i></li><li><i>GW</i></li><li><i>GY</i></li><li><i>HK</i></li><li><i>HM</i></li><li><i>HN</i></li><li><i>HR</i></li><li><i>HT</i></li><li><i>HU</i></li><li><i>ID</i></li><li><i>IE</i></li><li><i>IL</i></li><li><i>IM</i></li><li><i>IN</i></li><li><i>IO</i></li><li><i>IQ</i></li><li><i>IR</i></li><li><i>IS</i></li><li><i>IT</i></li><li><i>JE</i></li><li><i>JM</i></li><li><i>JO</i></li><li><i>JP</i></li><li><i>KE</i></li><li><i>KG</i></li><li><i>KH</i></li><li><i>KI</i></li><li><i>KM</i></li><li><i>KN</i></li><li><i>KP</i></li><li><i>KR</i></li><li><i>KW</i></li><li><i>KY</i></li><li><i>KZ</i></li><li><i>LA</i></li><li><i>LB</i></li><li><i>LC</i></li><li><i>LI</i></li><li><i>LK</i></li><li><i>LR</i></li><li><i>LS</i></li><li><i>LT</i></li><li><i>LU</i></li><li><i>LV</i></li><li><i>LY</i></li><li><i>MA</i></li><li><i>MC</i></li><li><i>MD</i></li><li><i>ME</i></li><li><i>MF</i></li><li><i>MG</i></li><li><i>MH</i></li><li><i>MK</i></li><li><i>ML</i></li><li><i>MM</i></li><li><i>MN</i></li><li><i>MO</i></li><li><i>MP</i></li><li><i>MQ</i></li><li><i>MR</i></li><li><i>MS</i></li><li><i>MT</i></li><li><i>MU</i></li><li><i>MV</i></li><li><i>MW</i></li><li><i>MX</i></li><li><i>MY</i></li><li><i>MZ</i></li><li><i>NA</i></li><li><i>NC</i></li><li><i>NE</i></li><li><i>NF</i></li><li><i>NG</i></li><li><i>NI</i></li><li><i>NL</i></li><li><i>NO</i></li><li><i>NP</i></li><li><i>NR</i></li><li><i>NU</i></li><li><i>NZ</i></li><li><i>OM</i></li><li><i>PA</i></li><li><i>PE</i></li><li><i>PF</i></li><li><i>PG</i></li><li><i>PH</i></li><li><i>PK</i></li><li><i>PL</i></li><li><i>PM</i></li><li><i>PN</i></li><li><i>PR</i></li><li><i>PS</i></li><li><i>PT</i></li><li><i>PW</i></li><li><i>PY</i></li><li><i>QA</i></li><li><i>RE</i></li><li><i>RO</i></li><li><i>RS</i></li><li><i>RU</i></li><li><i>RW</i></li><li><i>SA</i></li><li><i>SB</i></li><li><i>SC</i></li><li><i>SD</i></li><li><i>SE</i></li><li><i>SG</i></li><li><i>SH</i></li><li><i>SI</i></li><li><i>SJ</i></li><li><i>SK</i></li><li><i>SL</i></li><li><i>SM</i></li><li><i>SN</i></li><li><i>SO</i></li><li><i>SR</i></li><li><i>SS</i></li><li><i>ST</i></li><li><i>SV</i></li><li><i>SX</i></li><li><i>SY</i></li><li><i>SZ</i></li><li><i>TC</i></li><li><i>TD</i></li><li><i>TF</i></li><li><i>TG</i></li><li><i>TH</i></li><li><i>TJ</i></li><li><i>TK</i></li><li><i>TL</i></li><li><i>TM</i></li><li><i>TN</i></li><li><i>TO</i></li><li><i>TR</i></li><li><i>TT</i></li><li><i>TV</i></li><li><i>TW</i></li><li><i>TZ</i></li><li><i>UA</i></li><li><i>UG</i></li><li><i>UM</i></li><li><i>US</i></li><li><i>UY</i></li><li><i>UZ</i></li><li><i>VA</i></li><li><i>VC</i></li><li><i>VE</i></li><li><i>VG</i></li><li><i>VI</i></li><li><i>VN</i></li><li><i>VU</i></li><li><i>WF</i></li><li><i>WS</i></li><li><i>XK</i></li><li><i>YE</i></li><li><i>YT</i></li><li><i>ZA</i></li><li><i>ZM</i></li><li><i>ZW</i></li></ul>
         * @enum {string}
         */
        CountryIsoCode: CountryIsoCode;
        CurrenciesCurrencyAnswer: {
            code: string;
            isCrypto: boolean;
            isExpired: boolean;
        };
        CurrenciesCurrencyAnswerCamelCased: {
            code: string;
            isCrypto: boolean;
            isExpired: boolean;
        };
        CurrenciesSelectCurrenciesAnswer: {
            currencies: components['schemas']['CurrenciesCurrencyAnswer'][];
        };
        CurrenciesSelectCurrenciesAnswerCamelCased: {
            currencies: components['schemas']['CurrenciesCurrencyAnswerCamelCased'][];
        };
        /**
         * Format: string
         * @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul>
         * @enum {string}
         */
        CurrencyIsoCode: CurrencyIsoCode;
        /**
         * Format: string
         * @description <ul><li><i>InvoiceFirst</i></li><li><i>StockFirst</i></li><li><i>Unknown</i></li></ul>
         * @enum {string}
         */
        DearDomainEntitiesApprovalEntitiesApproachType: DearDomainEntitiesApprovalEntitiesApproachType;
        /**
         * Format: string
         * @description <ul><li><i>Authorised</i></li><li><i>AuthorisedWithoutAllocation</i></li><li><i>Closed</i></li><li><i>Draft</i></li><li><i>Fulfilled</i></li><li><i>NotAvailable</i></li><li><i>Received</i></li><li><i>Unknown</i></li><li><i>Voided</i></li></ul>
         * @enum {string}
         */
        DearDomainEntitiesApprovalEntitiesPurchaseOrdersOrderStatus: DearDomainEntitiesApprovalEntitiesPurchaseOrdersOrderStatus;
        /**
         * Format: string
         * @description <ul><li><i>Completed</i></li><li><i>CompletedCreditNoteClosed</i></li><li><i>Credited</i></li><li><i>Draft</i></li><li><i>Invoiced</i></li><li><i>Ordered</i></li><li><i>Ordering</i></li><li><i>PartiallyInvoiced</i></li><li><i>Received</i></li><li><i>ReceivedCredited</i></li><li><i>Receiving</i></li><li><i>ReceivingCredited</i></li><li><i>Unknown</i></li><li><i>Voided</i></li></ul>
         * @enum {string}
         */
        DearDomainEntitiesApprovalEntitiesPurchaseStatus: DearDomainEntitiesApprovalEntitiesPurchaseStatus;
        /**
         * Format: string
         * @description <ul><li><i>AdvancedPurchase</i></li><li><i>ServicePurchase</i></li><li><i>SimplePurchase</i></li><li><i>Unknown</i></li></ul>
         * @enum {string}
         */
        DearDomainEntitiesApprovalEntitiesPurchaseType: DearDomainEntitiesApprovalEntitiesPurchaseType;
        /**
         * Format: string
         * @description <ul><li><i>TaxExclusive</i></li><li><i>TaxInclusive</i></li><li><i>Unknown</i></li></ul>
         * @enum {string}
         */
        DearDomainEntitiesApprovalEntitiesTaxCalculationType: DearDomainEntitiesApprovalEntitiesTaxCalculationType;
        /**
         * Format: string
         * @description <ul><li><i>Gross</i> - 0</li><li><i>Net</i> - 1</li></ul>
         * @enum {string}
         */
        DomainEntitiesAmountConditionType: DomainEntitiesAmountConditionType;
        /**
         * Format: string
         * @description <ul><li><i>Credit</i></li><li><i>Debit</i></li><li><i>None</i></li></ul>
         * @enum {string}
         */
        DomainEntitiesAmountSide: DomainEntitiesAmountSide;
        /**
         * Format: string
         * @description <ul><li><i>NoResponse</i> - 0</li><li><i>Reject</i> - 1</li><li><i>Approve</i> - 2</li></ul>
         * @enum {string}
         */
        DomainEntitiesApproverResponse: DomainEntitiesApproverResponse;
        /**
         * Format: string
         * @description <ul><li><i>General</i> - 0</li><li><i>DocumentPDF</i> - 1</li></ul>
         * @enum {string}
         */
        DomainEntitiesAttachmentType: DomainEntitiesAttachmentType;
        /**
         * Format: string
         * @description <ul><li><i>PaymentDetailsAdd</i> - payment-details-add</li><li><i>PaymentDetailsEdit</i> - payment-details-edit</li><li><i>PaymentDetailsView</i> - payment-details-view</li></ul>
         * @enum {string}
         */
        DomainEntitiesCompaniesParticipantsPermission: DomainEntitiesCompaniesParticipantsPermission;
        /**
         * Format: string
         * @description <ul><li><i>Participant</i> - 0</li><li><i>Manager</i> - 1</li><li><i>Auditor</i> - 2</li><li><i>WorkflowManager</i> - 3</li></ul>
         * @enum {string}
         */
        DomainEntitiesCompanyRole: DomainEntitiesCompanyRole;
        /**
         * Format: string
         * @description <ul><li><i>Bills</i></li><li><i>Cin7Core</i></li><li><i>CoinLayer</i></li><li><i>Fixer</i></li><li><i>Manual</i></li><li><i>NetSuite</i></li><li><i>None</i></li><li><i>OpenExchangeRate</i></li><li><i>QBooks</i></li><li><i>Xero</i></li></ul>
         * @enum {string}
         */
        DomainEntitiesExchangeRateSource: DomainEntitiesExchangeRateSource;
        /**
         * Format: string
         * @description <ul><li><i>General</i> - 0</li><li><i>Amount</i> - 1</li><li><i>XeroTracking</i> - 2</li><li><i>XeroSupplier</i> - 3</li><li><i>XeroCustomer</i> - 4</li><li><i>XeroAccount</i> - 5</li><li><i>XeroItem</i> - 6</li><li><i>Requester</i> - 7</li><li><i>XeroBranding</i> - 8</li><li><i>XeroTax</i> - 9</li><li><i>QBooksVendor</i> - 10</li><li><i>QBooksPoItem</i> - 11</li><li><i>QBooksDepartment</i> - 12</li><li><i>QBooksClass</i> - 13</li><li><i>QBooksCustomer</i> - 14</li><li><i>QBooksCustom</i> - 15</li><li><i>QBooksAccount</i> - 16</li><li><i>QBooksTerm</i> - 17</li><li><i>XeroBankAccount</i> - 18</li><li><i>NetSuiteSubsidiary</i> - 19</li><li><i>NetSuiteVendor</i> - 20</li><li><i>NetSuiteAccount</i> - 21</li><li><i>NetSuiteExpenseCategory</i> - 22</li><li><i>NetSuiteItem</i> - 23</li><li><i>NetSuiteDepartment</i> - 24</li><li><i>NetSuiteClass</i> - 25</li><li><i>NetSuiteLocation</i> - 26</li><li><i>QBooksPaymentMethod</i> - 27</li><li><i>QBooksPaymentType</i> - 28</li><li><i>QBooksPaymentAccount</i> - 29</li><li><i>QBooksPayeeCustomer</i> - 30</li><li><i>QBooksPayeeVendor</i> - 31</li><li><i>QBooksPayeeEmployee</i> - 32</li><li><i>XeroManualExchangeRate</i> - 33</li><li><i>QBooksManualExchangeRate</i> - 34</li><li><i>NetSuiteCurrency</i> - 35</li><li><i>QBooksDocumentStatus</i> - 36</li><li><i>DearSupplier</i> - 37</li><li><i>DearInventoryAccount</i> - 38</li><li><i>DearProduct</i> - 39</li><li><i>DearProductCategory</i> - 40</li><li><i>DearProductFamily</i> - 41</li><li><i>DearBrand</i> - 42</li><li><i>DearLocation</i> - 43</li><li><i>NetSuiteCustom</i> - 44</li><li><i>AirwallexBeneficiary</i> - 45</li><li><i>AirwallexCurrency</i> - 46</li><li><i>AirwallexPaymentFee</i> - 47</li><li><i>AirwallexPaymentPurpose</i> - 48</li><li><i>AirwallexPaymentMethod</i> - 49</li><li><i>AirwallexSourceAmount</i> - 50</li><li><i>AirwallexFeeAmount</i> - 51</li><li><i>AirwallexBatchPaymentStatus</i> - 52</li><li><i>AirwallexPaymentItemStatus</i> - 53</li><li><i>QBooksCurrency</i> - 54</li><li><i>NetSuiteEmployee</i> - 55</li><li><i>NetSuiteCustomer</i> - 56</li><li><i>NetSuiteTaxCode</i> - 57</li><li><i>QBooksTax</i> - 58</li><li><i>AmaxPayBankAccount</i> - 59</li><li><i>XeroDate</i> - 60</li><li><i>XeroDueDate</i> - 61</li><li><i>XeroLineDescription</i> - 62</li><li><i>XeroLineDiscount</i> - 63</li><li><i>NoteForApprovers</i> - 64</li><li><i>EmailToSupplier</i> - 65</li><li><i>XeroCurrency</i> - 66</li><li><i>XeroReference</i> - 67</li><li><i>XeroAttachment</i> - 68</li><li><i>XeroLineAmountType</i> - 69</li><li><i>XeroLineQty</i> - 70</li><li><i>XeroLineUnitPrice</i> - 71</li><li><i>XeroLineTaxAmount</i> - 72</li><li><i>XeroDeliveryAddress</i> - 73</li><li><i>XeroContactName</i> - 74</li><li><i>XeroContactAccountNumber</i> - 75</li><li><i>XeroContactPrimaryPersonFirstName</i> - 76</li><li><i>XeroContactPrimaryPersonLastName</i> - 77</li><li><i>XeroContactPrimaryPersonEmail</i> - 78</li><li><i>XeroContactPersons</i> - 79</li><li><i>XeroContactPhone</i> - 80</li><li><i>XeroContactFax</i> - 81</li><li><i>XeroContactMobile</i> - 82</li><li><i>XeroContactDirectDial</i> - 83</li><li><i>XeroContactSkypeNameOrNumber</i> - 84</li><li><i>XeroContactBillingAddress</i> - 85</li><li><i>XeroContactDeliveryAddress</i> - 86</li><li><i>XeroContactSalesAccount</i> - 87</li><li><i>XeroContactSalesTrackingCategories</i> - 88</li><li><i>XeroContactPurchaseAccount</i> - 89</li><li><i>XeroContactPurchaseTrackingCategories</i> - 90</li><li><i>XeroContactTaxNumber</i> - 91</li><li><i>XeroContactCompanyNumber</i> - 92</li><li><i>XeroContactSalesTax</i> - 93</li><li><i>XeroContactPurchaseTax</i> - 94</li><li><i>XeroContactDefaultCurrency</i> - 95</li><li><i>XeroContactBankAccountDetails</i> - 96</li><li><i>XeroQuoteNumber</i> - 97</li><li><i>XeroQuoteTitle</i> - 98</li><li><i>XeroQuoteSummary</i> - 99</li><li><i>XeroQuoteTerms</i> - 100</li><li><i>XeroQuoteExpiry</i> - 101</li><li><i>XeroDeliveryDate</i> - 102</li><li><i>NetSuitePayee</i> - 103</li><li><i>QBooksEmployee</i> - 104</li><li><i>QBooksSalesItem</i> - 105</li><li><i>QBooksInvoiceCustomer</i> - 106</li><li><i>QBooksInvoiceCustom</i> - 107</li><li><i>XeroBatchPaymentItems</i> - 108</li><li><i>AmaxPayWallet</i> - 109</li></ul>
         * @enum {string}
         */
        DomainEntitiesFieldPurpose: DomainEntitiesFieldPurpose;
        /**
         * Format: string
         * @description <ul><li><i>NumericRange</i> - 0</li><li><i>ExactValueRange</i> - 1</li><li><i>ExactValueRangeNegative</i> - 2</li></ul>
         * @enum {string}
         */
        DomainEntitiesFieldType: DomainEntitiesFieldType;
        /**
         * Format: string
         * @description <ul><li><i>Fully Received</i> - FullyReceived</li><li><i>Not Received</i> - NotReceived</li><li><i>Partially Received</i> - PartiallyReceived</li></ul>
         * @enum {string}
         */
        DomainEntitiesGrnStatus: DomainEntitiesGrnStatus;
        /**
         * Format: string
         * @description <ul><li><i>Undefined</i> - 0</li><li><i>Active</i> - 1</li><li><i>InActive</i> - 2</li><li><i>Expired</i> - 3</li><li><i>AwaitingActivation</i> - 4</li></ul>
         * @enum {string}
         */
        DomainEntitiesLicensesAllFeaturesTrialStatus: DomainEntitiesLicensesAllFeaturesTrialStatus;
        /**
         * Format: string
         * @description <ul><li><i>Failed</i></li><li><i>InProgress</i></li><li><i>Requested</i></li><li><i>Skipped</i></li><li><i>Succeeded</i></li></ul>
         * @enum {string}
         */
        DomainEntitiesOcrOcrStatus: DomainEntitiesOcrOcrStatus;
        /**
         * Format: string
         * @description <ul><li><i>RequesterSubmitted</i> - 0</li><li><i>ApproverApproved</i> - 1</li><li><i>ApproverApprovedStepApproved</i> - 2</li><li><i>ApproverApprovedRequestApproved</i> - 3</li><li><i>ApproverRejected</i> - 4</li><li><i>ApproverRevoked</i> - 5</li><li><i>ApproverRevokedStepChanged</i> - 6</li><li><i>RequesterClosed</i> - 7</li><li><i>RequesterCancelled</i> - 8</li><li><i>Comment</i> - 9</li><li><i>CommentDeleted</i> - 10</li><li><i>RequesterReopened</i> - 11</li><li><i>RequesterReopenedWithReset</i> - 12</li><li><i>RequesterReopenedStepChanged</i> - 13</li><li><i>RequesterReopenedRequestApproved</i> - 14</li><li><i>RequesterUpdated</i> - 15</li><li><i>RequesterUpdatedWithReset</i> - 16</li><li><i>RequesterUpdatedStepChanged</i> - 17</li><li><i>RequesterUpdatedRequestApproved</i> - 18</li><li><i>StepSkipped</i> - 19</li><li><i>StepSkippedRequestApproved</i> - 20</li><li><i>ForcedApproval</i> - 21</li><li><i>ForcedReject</i> - 22</li><li><i>ApprovedInXero</i> - 23</li><li><i>CancelledInXero</i> - 24</li><li><i>RequesterResetTemplate</i> - 25</li><li><i>ParticipantsWereChanged</i> - 26</li><li><i>ParticipantsWereChangedStepChanged</i> - 27</li><li><i>ParticipantsWereChangedRequestApproved</i> - 28</li><li><i>EmailToPartnerSent</i> - 29</li><li><i>EditorEdited</i> - 30</li><li><i>EditorEditedStepApproved</i> - 31</li><li><i>EditorEditedRequestApproved</i> - 32</li><li><i>RejectedExternally</i> - 33</li><li><i>StepSkippedRequestRejected</i> - 34</li><li><i>PulledFromSource</i> - 35</li><li><i>PushedToSource</i> - 36</li><li><i>RequestMatchedByUser</i> - 37</li><li><i>RequestMatchedBySystem</i> - 38</li><li><i>RequestUnmatchedByUser</i> - 39</li><li><i>RequestUnmatchedBySystem</i> - 40</li><li><i>MarkedAsBilled</i> - 41</li><li><i>UnmarkedAsBilled</i> - 42</li><li><i>MarkAsBilledSynced</i> - 43</li><li><i>PostApprovalChangeDetected</i> - 44</li><li><i>UpdatedExternallyResetTemplate</i> - 45</li><li><i>MatchingAllocationAdded</i> - 46</li><li><i>MatchingAllocationRemoved</i> - 47</li><li><i>AutoMarkedAsBilled</i> - 48</li><li><i>AutoUnmarkedAsBilled</i> - 49</li><li><i>LineMatchingAdded</i> - 50</li><li><i>LineMatchingRemoved</i> - 51</li><li><i>CancelledExternally</i> - 52</li><li><i>DocumentClosed</i> - 53</li><li><i>DocumentOpened</i> - 54</li><li><i>DocumentClosedStatusSynced</i> - 55</li><li><i>DocumentOpenedStatusSynced</i> - 56</li><li><i>AirwallexBatchPaymentRequestPaid</i> - 57</li><li><i>AttachmentUploadFailed</i> - 58</li><li><i>GrnStatusChangedToNotReceived</i> - 59</li><li><i>GrnStatusChangedToPartiallyReceived</i> - 60</li><li><i>GrnStatusChangedToFullyReceived</i> - 61</li><li><i>DocumentStatusSyncFailed</i> - 62</li><li><i>ParticipantsWereAddedDueToMatchingBillWithPO</i> - 63</li><li><i>MarkAsCustomerDecisionSynced</i> - 64</li><li><i>WatchersChanged</i> - 65</li><li><i>ApprovedExternally</i> - 66</li><li><i>QuoteDecisionSet</i> - 67</li><li><i>AirwallexRequestScheduledForPayment</i> - 68</li><li><i>AirwallexScheduledPaymentCancelled</i> - 69</li><li><i>AirwallexScheduledPaymentFailedDueToPaymentServiceIntegrationDisconnected</i> - 70</li><li><i>AirwallexScheduledPaymentFailedDueToExceededAmountDue</i> - 71</li><li><i>AirwallexScheduledPaymentFailedDueToBeneficiaryDiscrepancy</i> - 72</li><li><i>AirwallexScheduledPaymentFailedDueToInsufficientFunds</i> - 73</li><li><i>AirwallexScheduledPaymentFailedDueToCompanyIntegrationDisabled</i> - 74</li><li><i>ReviewersChanged</i> - 75</li><li><i>ReviewForcedByAdmin</i> - 76</li><li><i>ReviewCompleted</i> - 77</li><li><i>MarkedAsSentSynced</i> - 78</li><li><i>AttachmentsAdded</i> - 79</li><li><i>AttachmentDeleted</i> - 80</li><li><i>ReturnedToReview</i> - 81</li><li><i>ReviewerEdited</i> - 82</li><li><i>AmaxPayBatchPaymentBillPaymentCancelled</i> - 83</li><li><i>ReviewSkipped</i> - 84</li><li><i>ApproverEdited</i> - 85</li><li><i>PushingSkipped</i> - 86</li><li><i>AmaxPayBatchPaymentFinalStatusSet</i> - 87</li><li><i>PutOnHold</i> - 88</li><li><i>TakenOffHold</i> - 89</li><li><i>AmaxPayPaymentApprovedAsPartOfBatchPayment</i> - 90</li><li><i>AmaxPayPaymentCancelledAsPartOfBatchPayment</i> - 91</li><li><i>CaptureRequestCreatedFromFile</i> - 92</li><li><i>CaptureAttachmentAssigned</i> - 93</li><li><i>CaptureSubmitRequestFailed</i> - 94</li><li><i>ParticipantsNudged</i> - 95</li><li><i>CommentPushFailed</i> - 96</li><li><i>CreditNoteInvoiceAllocationCreated</i> - 97</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestHistoryRecordsRequestEventType: DomainEntitiesRequestHistoryRecordsRequestEventType;
        /**
         * Format: string
         * @description <ul><li><i>PostApprovalChange</i> - 1</li><li><i>ExternalResolving</i> - 2</li><li><i>AutomaticResolving</i> - 3</li><li><i>AdminEnforcedResolving</i> - 4</li><li><i>DroppingOffApprovers</i> - 5</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsRequestFraudulentActivity: DomainEntitiesRequestsRequestFraudulentActivity;
        /**
         * Format: string
         * @description <ul><li><i>ApprovalMax</i> - 0</li><li><i>Xero</i> - 1</li><li><i>QBooks</i> - 2</li><li><i>ReceiptBank</i> - 3</li><li><i>NetSuite</i> - 4</li><li><i>Dear</i> - 5</li><li><i>PublicApi</i> - 6</li><li><i>Email</i> - 7</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsRequestOrigin: DomainEntitiesRequestsRequestOrigin;
        /**
         * Format: string
         * @description <ul><li><i>ResolvedRegularly</i> - 0</li><li><i>EnforcedExternally</i> - 1</li><li><i>EnforcedByAdmin</i> - 2</li><li><i>ResolvedAutomatically</i> - 3</li><li><i>ChangedApprovers</i> - 4</li><li><i>ResolvedExternally</i> - 5</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsRequestResolutionOrigin: DomainEntitiesRequestsRequestResolutionOrigin;
        /**
         * Format: string
         * @description <ul><li><i>Approved</i> - approved</li><li><i>Cancelled</i> - cancelled</li><li><i>Draft</i> - draft</li><li><i>On Approval</i> - on-approval</li><li><i>On Hold</i> - on-hold</li><li><i>On Review</i> - on-review</li><li><i>Rejected</i> - rejected</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsRequestStatusV2: DomainEntitiesRequestsRequestStatusV2;
        /**
         * Format: string
         * @description <ul><li><i>NotStarted</i> - 0</li><li><i>Active</i> - 1</li><li><i>Done</i> - 2</li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsStepsRequestStepState: DomainEntitiesRequestsStepsRequestStepState;
        /**
         * Format: string
         * @description <ul><li><i>backup</i></li><li><i>manual</i></li><li><i>rules</i></li></ul>
         * @enum {string}
         */
        DomainEntitiesRequestsStepsReviewersRequestStepReviewerOrigin: DomainEntitiesRequestsStepsReviewersRequestStepReviewerOrigin;
        /**
         * Format: string
         * @description <ul><li><i>All</i> - 0</li><li><i>AnyOf</i> - 1</li></ul>
         * @enum {string}
         */
        DomainEntitiesStepApprovalType: DomainEntitiesStepApprovalType;
        /**
         * Format: string
         * @description <ul><li><i>ByRules</i> - 0</li><li><i>IsBackup</i> - 1</li><li><i>Manually</i> - 2</li><li><i>ByMatching</i> - 3</li></ul>
         * @enum {string}
         */
        DomainEntitiesStepParticipantOrigin: DomainEntitiesStepParticipantOrigin;
        /**
         * Format: string
         * @description <ul><li><i>NoResolution</i> - 0</li><li><i>Rejected</i> - 1</li><li><i>Approved</i> - 2</li></ul>
         * @enum {string}
         */
        DomainEntitiesStepResolution: DomainEntitiesStepResolution;
        DomainEntitiesUserProfilesCommandsCompleteRegistration: {
            IsEmailSendingPostponed: boolean;
        };
        DomainEntitiesUserProfilesCommandsCompleteRegistrationCamelCased: {
            isEmailSendingPostponed: boolean;
        };
        /**
         * Format: string
         * @description <ul><li><i>Dear</i></li><li><i>NetSuite</i></li><li><i>None</i></li><li><i>QBooks</i></li><li><i>Xero</i></li></ul>
         * @enum {string}
         */
        DomainIntegrationType: DomainIntegrationType;
        /**
         * Format: string
         * @description <ul><li><i>Email</i> - email</li><li><i>Mobile</i> - mobile</li><li><i>Slack</i> - slack</li><li><i>Web</i> - web</li></ul>
         * @enum {string}
         */
        DomainUserPlatform: DomainUserPlatform;
        ExactConstraintAnswer: {
            Id?: string | null;
            Value?: string | null;
        };
        Fido2DomainEntitiesAssertionCommandsMakeAssertion: {
            Id: string;
            OptionsId: string;
            RawId: string;
            Type: string;
            Response: components['schemas']['Fido2DomainModelsAssertionAssertionResponse'];
            Extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsOutputs'];
        };
        Fido2DomainEntitiesAssertionCommandsMakeAssertionCamelCased: {
            id: string;
            optionsId: string;
            rawId: string;
            type: string;
            response: components['schemas']['Fido2DomainModelsAssertionAssertionResponseCamelCased'];
            extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsOutputsCamelCased'];
        };
        Fido2DomainEntitiesCredentialsCommandsDeleteCredentials: {
            CredentialId: string;
        };
        Fido2DomainEntitiesCredentialsCommandsDeleteCredentialsCamelCased: {
            credentialId: string;
        };
        Fido2DomainEntitiesCredentialsCommandsRegisterCredentials: {
            AttestationResponse: components['schemas']['Fido2DomainModelsCredentialsAttestationResponse'];
            Label: string;
        };
        Fido2DomainEntitiesCredentialsCommandsRegisterCredentialsCamelCased: {
            attestationResponse: components['schemas']['Fido2DomainModelsCredentialsAttestationResponseCamelCased'];
            label: string;
        };
        Fido2DomainEntitiesCredentialsCommandsRenameCredentialsLabel: {
            CredentialId: string;
            NewLabel: string;
        };
        Fido2DomainEntitiesCredentialsCommandsRenameCredentialsLabelCamelCased: {
            credentialId: string;
            newLabel: string;
        };
        Fido2DomainModelsAssertionAssertionResponse: {
            AuthenticatorData: string;
            Signature: string;
            ClientDataJson: string;
        };
        Fido2DomainModelsAssertionAssertionResponseCamelCased: {
            authenticatorData: string;
            signature: string;
            clientDataJson: string;
        };
        Fido2DomainModelsAssertionOptionsAssertionOptions: {
            readonly id: string;
            readonly challenge: string;
            readonly relayingPartyId?: string | null;
            readonly userVerification?: string | null;
            readonly allowCredentials?: components['schemas']['Fido2DomainModelsCredentialDescriptor'][] | null;
            extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsInputs'];
            /** Format: int64 */
            readonly timeoutInMilliseconds: number;
        };
        Fido2DomainModelsAssertionOptionsAssertionOptionsCamelCased: {
            readonly id: string;
            readonly challenge: string;
            readonly relayingPartyId?: string | null;
            readonly userVerification?: string | null;
            readonly allowCredentials?:
                | components['schemas']['Fido2DomainModelsCredentialDescriptorCamelCased'][]
                | null;
            extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsInputsCamelCased'];
            /** Format: int64 */
            readonly timeoutInMilliseconds: number;
        };
        Fido2DomainModelsAuthenticationExtensionsInputs: {
            readonly example: unknown;
            readonly appID: string;
            readonly authenticatorSelection: string[];
            readonly extensions?: boolean | null;
            readonly userVerificationMethod?: boolean | null;
        };
        Fido2DomainModelsAuthenticationExtensionsInputsCamelCased: {
            readonly example: unknown;
            readonly appID: string;
            readonly authenticatorSelection: string[];
            readonly extensions?: boolean | null;
            readonly userVerificationMethod?: boolean | null;
        };
        Fido2DomainModelsAuthenticationExtensionsOutputs: {
            Example?: unknown;
            IsAppIdExtension: boolean;
            IsAuthenticatorSelectionEnabled: boolean;
            Extensions?: string[] | null;
            UserVerificationMethod?: number[][] | null;
        };
        Fido2DomainModelsAuthenticationExtensionsOutputsCamelCased: {
            example?: unknown;
            isAppIdExtension: boolean;
            isAuthenticatorSelectionEnabled: boolean;
            extensions?: string[] | null;
            userVerificationMethod?: number[][] | null;
        };
        Fido2DomainModelsCredentialDescriptor: {
            /** Format: byte */
            readonly id: string;
            readonly type?: string | null;
            readonly transports?: string[] | null;
        };
        Fido2DomainModelsCredentialDescriptorCamelCased: {
            /** Format: byte */
            readonly id: string;
            readonly type?: string | null;
            readonly transports?: string[] | null;
        };
        Fido2DomainModelsCredentialOptionsAuthenticatorSelectionCriteria: {
            readonly authenticatorAttachment?: string | null;
            readonly requireResidentKey: boolean;
            readonly userVerification: string;
        };
        Fido2DomainModelsCredentialOptionsAuthenticatorSelectionCriteriaCamelCased: {
            readonly authenticatorAttachment?: string | null;
            readonly requireResidentKey: boolean;
            readonly userVerification: string;
        };
        Fido2DomainModelsCredentialOptionsCredentialOptions: {
            readonly id: string;
            readonly challenge: string;
            relayingParty: components['schemas']['Fido2DomainModelsCredentialOptionsRelyingPartyIdentifier'];
            user: components['schemas']['Fido2DomainModelsCredentialOptionsUser'];
            readonly pubKeyCredParams: components['schemas']['Fido2DomainModelsCredentialOptionsCredentialParameters'][];
            authenticatorSelection: components['schemas']['Fido2DomainModelsCredentialOptionsAuthenticatorSelectionCriteria'];
            readonly attestationConveyance: string;
            readonly excludeCredentials: components['schemas']['Fido2DomainModelsCredentialDescriptor'][];
            extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsInputs'];
            /** Format: int64 */
            readonly timeoutInMilliseconds: number;
        };
        Fido2DomainModelsCredentialOptionsCredentialOptionsCamelCased: {
            readonly id: string;
            readonly challenge: string;
            relayingParty: components['schemas']['Fido2DomainModelsCredentialOptionsRelyingPartyIdentifierCamelCased'];
            user: components['schemas']['Fido2DomainModelsCredentialOptionsUserCamelCased'];
            readonly pubKeyCredParams: components['schemas']['Fido2DomainModelsCredentialOptionsCredentialParametersCamelCased'][];
            authenticatorSelection: components['schemas']['Fido2DomainModelsCredentialOptionsAuthenticatorSelectionCriteriaCamelCased'];
            readonly attestationConveyance: string;
            readonly excludeCredentials: components['schemas']['Fido2DomainModelsCredentialDescriptorCamelCased'][];
            extensions?: components['schemas']['Fido2DomainModelsAuthenticationExtensionsInputsCamelCased'];
            /** Format: int64 */
            readonly timeoutInMilliseconds: number;
        };
        Fido2DomainModelsCredentialOptionsCredentialParameters: {
            readonly credentialType: string;
            /** Format: int64 */
            readonly algorithm: number;
        };
        Fido2DomainModelsCredentialOptionsCredentialParametersCamelCased: {
            readonly credentialType: string;
            /** Format: int64 */
            readonly algorithm: number;
        };
        Fido2DomainModelsCredentialOptionsRelyingPartyIdentifier: {
            readonly id: string;
            readonly name: string;
        };
        Fido2DomainModelsCredentialOptionsRelyingPartyIdentifierCamelCased: {
            readonly id: string;
            readonly name: string;
        };
        Fido2DomainModelsCredentialOptionsUser: {
            /** Format: byte */
            readonly id: string;
            readonly name: string;
            readonly displayName: string;
        };
        Fido2DomainModelsCredentialOptionsUserCamelCased: {
            /** Format: byte */
            readonly id: string;
            readonly name: string;
            readonly displayName: string;
        };
        Fido2DomainModelsCredentialsAttestationResponse: {
            Id: string;
            OptionsId: string;
            RawId: string;
            Type?: string | null;
            Response: components['schemas']['Fido2DomainModelsCredentialsResponseData'];
            Extensions: components['schemas']['Fido2DomainModelsAuthenticationExtensionsOutputs'];
        };
        Fido2DomainModelsCredentialsAttestationResponseCamelCased: {
            id: string;
            optionsId: string;
            rawId: string;
            type?: string | null;
            response: components['schemas']['Fido2DomainModelsCredentialsResponseDataCamelCased'];
            extensions: components['schemas']['Fido2DomainModelsAuthenticationExtensionsOutputsCamelCased'];
        };
        Fido2DomainModelsCredentialsCredentialResult: {
            /** Format: byte */
            credentialId: string;
            label: string;
            /** Format: date-time */
            createdDate: string;
        };
        Fido2DomainModelsCredentialsCredentialResultCamelCased: {
            /** Format: byte */
            credentialId: string;
            label: string;
            /** Format: date-time */
            createdDate: string;
        };
        Fido2DomainModelsCredentialsResponseData: {
            AttestationObject: string;
            ClientDataJson: string;
        };
        Fido2DomainModelsCredentialsResponseDataCamelCased: {
            attestationObject: string;
            clientDataJson: string;
        };
        FieldAnswer: {
            /** Format: uuid */
            FieldId: string;
            Name?: string | null;
            Type: components['schemas']['DomainEntitiesFieldType'];
            SystemPurpose: components['schemas']['DomainEntitiesFieldPurpose'];
            CurrencyISOCode?: string | null;
            ExactValues?: components['schemas']['FieldValueAnswer'][] | null;
            HasMore?: boolean | null;
            readonly SubmitterApplicable: boolean;
        };
        FieldValueAnswer: {
            FieldValueId?: string | null;
            Value?: string | null;
        };
        FieldValueAnswerCamelCased: {
            fieldValueId?: string | null;
            value?: string | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>OK</i> - 0</li><li><i>TooBig</i> - 1</li><li><i>RestrictedFileType</i> - 2</li><li><i>VirusFound</i> - 3</li></ul>
         * @enum {string}
         */
        FilesFileUploadResult: FilesFileUploadResult;
        GroupOfXeroAccountsConstraintAnswer: {
            /** Format: uuid */
            Id: string;
            /** Format: uuid */
            VersionId: string;
            /** Format: int32 */
            VersionNumber: number;
        };
        HistoryReviewStepChangeData: {
            /** Format: uuid */
            StepId: string;
            AddedReviewers: components['schemas']['UserAnswer'][];
            RemovedReviewers: components['schemas']['UserAnswer'][];
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptExpenseLineTransfer: {
            IsChecked: boolean;
            /** Format: int64 */
            OrderLine?: number | null;
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptExpenseLineTransferCamelCased: {
            isChecked: boolean;
            /** Format: int64 */
            orderLine?: number | null;
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptItemLineTransfer: {
            LocationId?: string | null;
            /** Format: double */
            Quantity?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            IsUnitPriceAbsolute?: boolean | null;
            IsChecked: boolean;
            /** Format: int64 */
            OrderLine?: number | null;
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptItemLineTransferCamelCased: {
            locationId?: string | null;
            /** Format: double */
            quantity?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            isUnitPriceAbsolute?: boolean | null;
            isChecked: boolean;
            /** Format: int64 */
            orderLine?: number | null;
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptTransfer: {
            /** Format: date-time */
            Date?: string | null;
            Memo?: string | null;
            PostingPeriodId?: string | null;
            LandedCostPerLine: boolean;
            ItemLines: components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptItemLineTransfer'][];
            ExpenseLines: components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptExpenseLineTransfer'][];
        };
        IntegrationNetSuitePurchaseOrderReceivingItemReceiptTransferCamelCased: {
            /** Format: date-time */
            date?: string | null;
            memo?: string | null;
            postingPeriodId?: string | null;
            landedCostPerLine: boolean;
            itemLines: components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptItemLineTransferCamelCased'][];
            expenseLines: components['schemas']['IntegrationNetSuitePurchaseOrderReceivingItemReceiptExpenseLineTransferCamelCased'][];
        };
        IntegrationXeroDeliveryAddressInfo: {
            /** @deprecated */
            SameAsPostalAddress: boolean;
            SameAsBillingAddress: boolean;
            Address?: string | null;
            City?: string | null;
            Region?: string | null;
            PostalCode?: string | null;
            Country?: string | null;
            AttentionTo?: string | null;
        };
        IntegrationXeroDeliveryAddressInfoCamelCased: {
            /** @deprecated */
            sameAsPostalAddress: boolean;
            sameAsBillingAddress: boolean;
            address?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
            attentionTo?: string | null;
        };
        IntegrationXeroPaymentDetailsV2CreatePaymentDetailsTransfer: {
            BankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetails'];
            ExpectedVerificationStatus: components['schemas']['ApiAmaxPayPaymentDetailsVerificationStatus'];
            IsDefault: boolean;
        };
        IntegrationXeroPaymentDetailsV2CreatePaymentDetailsTransferCamelCased: {
            bankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
            expectedVerificationStatus: components['schemas']['ApiAmaxPayPaymentDetailsVerificationStatus'];
            isDefault: boolean;
        };
        IntegrationXeroPaymentDetailsV2PaymentDetailsTransfer: {
            BankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetails'];
            IsDefault: boolean;
        };
        IntegrationXeroPaymentDetailsV2PaymentDetailsTransferCamelCased: {
            bankAccountDetails: components['schemas']['ApiAmaxPayPaymentDetailsV2PaymentDetailsBankAccountDetailsCamelCased'];
            isDefault: boolean;
        };
        /**
         * Format: string
         * @description <ul><li><i>Cancelled</i></li><li><i>Failed</i></li><li><i>Processing</i></li><li><i>Rejected</i></li><li><i>Sent</i></li></ul>
         * @enum {string}
         */
        IntegrationsAirwallexAirwallexInvoiceUIStatus: IntegrationsAirwallexAirwallexInvoiceUIStatus;
        IntegrationsAirwallexXeroAirwallexBatchPaymentAnswer: {
            /** Format: uuid */
            airwallexXeroBatchPaymentId: string;
            /** Format: int32 */
            number?: number | null;
            /** Format: date-time */
            createdDate?: string | null;
            /** Format: date-time */
            modifiedDate?: string | null;
            items: components['schemas']['IntegrationsAirwallexXeroAirwallexBatchPaymentItemAnswer'][];
            status?: components['schemas']['AirwallexDomainEntitiesAirwallexApprovalEntityStatus'];
            /** Format: date-time */
            scheduledPaymentDate?: string | null;
            scheduledPaymentFailed: boolean;
            paymentProcessingDetails?: components['schemas']['IntegrationsAirwallexXeroAirwallexPaymentProcessingDetails'];
        };
        IntegrationsAirwallexXeroAirwallexBatchPaymentAnswerCamelCased: {
            /** Format: uuid */
            airwallexXeroBatchPaymentId: string;
            /** Format: int32 */
            number?: number | null;
            /** Format: date-time */
            createdDate?: string | null;
            /** Format: date-time */
            modifiedDate?: string | null;
            items: components['schemas']['IntegrationsAirwallexXeroAirwallexBatchPaymentItemAnswerCamelCased'][];
            status?: components['schemas']['AirwallexDomainEntitiesAirwallexApprovalEntityStatus'];
            /** Format: date-time */
            scheduledPaymentDate?: string | null;
            scheduledPaymentFailed: boolean;
            paymentProcessingDetails?: components['schemas']['IntegrationsAirwallexXeroAirwallexPaymentProcessingDetailsCamelCased'];
        };
        IntegrationsAirwallexXeroAirwallexBatchPaymentItemAnswer: {
            friendlyName: string;
            /** Format: uuid */
            xeroBillInvoiceRequestId?: string | null;
            /** Format: uuid */
            xeroInvoicePaymentId?: string | null;
            bankAccount?: components['schemas']['IntegrationsXeroBankAccountAnswer'];
            contact?: components['schemas']['OptionallyNamedObjectGuid'];
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            billInvoiceAmount?: number | null;
            /** Format: double */
            amountDue?: number | null;
            currency?: string | null;
            sourceCurrency?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            /** Format: date-time */
            date?: string | null;
            paymentFee?: components['schemas']['AirwallexDomainEntitiesAirwallexPaymentFee'];
            paymentPurpose?: components['schemas']['AirwallexApiClientAirwallexPaymentPurpose'];
            paymentReference?: string | null;
            note?: string | null;
            /** Format: date-time */
            plannedPaymentDate?: string | null;
            attachments?: components['schemas']['AttachmentAnswer'][] | null;
            /** Format: double */
            sourceAmount?: number | null;
            /** Format: double */
            feeAmount?: number | null;
            /** Format: date-time */
            dispatchedAt?: string | null;
            status?: components['schemas']['IntegrationsAirwallexAirwallexInvoiceUIStatus'];
            errorMessage?: string | null;
            /** Format: date-time */
            statusUpdatedAt?: string | null;
            xeroUrl?: string | null;
            airwallexUrl?: string | null;
            beneficiary?: components['schemas']['ApiIntegrationsAirwallexAirwallexBeneficiaryVersion'];
            beneficiaryDiscrepancy?: components['schemas']['ApiIntegrationsAirwallexLastPaymentBeneficiaryDiscrepancy'];
            beneficiaryPaymentStatus?: components['schemas']['AirwallexDomainEntitiesBeneficiaryPaymentStatus'];
        };
        IntegrationsAirwallexXeroAirwallexBatchPaymentItemAnswerCamelCased: {
            friendlyName: string;
            /** Format: uuid */
            xeroBillInvoiceRequestId?: string | null;
            /** Format: uuid */
            xeroInvoicePaymentId?: string | null;
            bankAccount?: components['schemas']['IntegrationsXeroBankAccountAnswerCamelCased'];
            contact?: components['schemas']['OptionallyNamedObjectGuidCamelCased'];
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            billInvoiceAmount?: number | null;
            /** Format: double */
            amountDue?: number | null;
            currency?: string | null;
            sourceCurrency?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            /** Format: date-time */
            date?: string | null;
            paymentFee?: components['schemas']['AirwallexDomainEntitiesAirwallexPaymentFee'];
            paymentPurpose?: components['schemas']['AirwallexApiClientAirwallexPaymentPurpose'];
            paymentReference?: string | null;
            note?: string | null;
            /** Format: date-time */
            plannedPaymentDate?: string | null;
            attachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
            /** Format: double */
            sourceAmount?: number | null;
            /** Format: double */
            feeAmount?: number | null;
            /** Format: date-time */
            dispatchedAt?: string | null;
            status?: components['schemas']['IntegrationsAirwallexAirwallexInvoiceUIStatus'];
            errorMessage?: string | null;
            /** Format: date-time */
            statusUpdatedAt?: string | null;
            xeroUrl?: string | null;
            airwallexUrl?: string | null;
            beneficiary?: components['schemas']['ApiIntegrationsAirwallexAirwallexBeneficiaryVersionCamelCased'];
            beneficiaryDiscrepancy?: components['schemas']['ApiIntegrationsAirwallexLastPaymentBeneficiaryDiscrepancyCamelCased'];
            beneficiaryPaymentStatus?: components['schemas']['AirwallexDomainEntitiesBeneficiaryPaymentStatus'];
        };
        IntegrationsAirwallexXeroAirwallexPaymentProcessingDetails: {
            /** Format: int32 */
            totalPayments: number;
            /** Format: int32 */
            paymentsSent: number;
            /** Format: int32 */
            paymentsFailed: number;
            /** Format: int32 */
            paymentsInProcessing: number;
        };
        IntegrationsAirwallexXeroAirwallexPaymentProcessingDetailsCamelCased: {
            /** Format: int32 */
            totalPayments: number;
            /** Format: int32 */
            paymentsSent: number;
            /** Format: int32 */
            paymentsFailed: number;
            /** Format: int32 */
            paymentsInProcessing: number;
        };
        IntegrationsDearProductAnswer: {
            SKU?: string | null;
            readonly DisplayName: string;
            /** Format: uuid */
            Id: string;
            Name: string;
        };
        IntegrationsDearPurchaseOrderAdditionalChargeLineAnswer: {
            Description?: string | null;
            Reference?: string | null;
            /** Format: double */
            Quantity: number;
            /** Format: double */
            Price: number;
            /** Format: double */
            Discount: number;
            TaxRule?: string | null;
            /** Format: double */
            Tax: number;
            /** Format: double */
            Total: number;
        };
        IntegrationsDearPurchaseOrderAnswer: {
            /** Format: uuid */
            InternalId: string;
            PurchaseStatus: components['schemas']['DearDomainEntitiesApprovalEntitiesPurchaseStatus'];
            OrderStatus: components['schemas']['DearDomainEntitiesApprovalEntitiesPurchaseOrdersOrderStatus'];
            Supplier?: components['schemas']['NamedObjectAnswerGuid'];
            Contact?: string | null;
            Phone?: string | null;
            BillingAddress?: string | null;
            Approach: components['schemas']['DearDomainEntitiesApprovalEntitiesApproachType'];
            Terms?: string | null;
            /** Format: date-time */
            RequiredBy?: string | null;
            InventoryAccount?: string | null;
            /** Format: double */
            CurrencyRate?: number | null;
            BaseCurrency?: string | null;
            SupplierCurrency?: string | null;
            TaxCalculation: components['schemas']['DearDomainEntitiesApprovalEntitiesTaxCalculationType'];
            TaxRule?: string | null;
            PurchaseType?: components['schemas']['DearDomainEntitiesApprovalEntitiesPurchaseType'];
            OrderNumber?: string | null;
            /** Format: date-time */
            OrderDate?: string | null;
            Location?: string | null;
            ShippingAddress?: string | null;
            Note?: string | null;
            Memo?: string | null;
            /** Format: double */
            TotalBeforeTax?: number | null;
            /** Format: double */
            Tax?: number | null;
            /** Format: double */
            Total?: number | null;
            Url?: string | null;
            ItemLines: components['schemas']['IntegrationsDearPurchaseOrderItemLineAnswer'][];
            AdditionalChargeLines: components['schemas']['IntegrationsDearPurchaseOrderAdditionalChargeLineAnswer'][];
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            LastUpdatedDate?: string | null;
        };
        IntegrationsDearPurchaseOrderItemLineAnswer: {
            Product?: components['schemas']['IntegrationsDearProductAnswer'];
            Comment?: string | null;
            SupplierSKU?: string | null;
            /** Format: double */
            Quantity: number;
            /** Format: double */
            Price: number;
            /** Format: double */
            Discount: number;
            TaxRule?: string | null;
            /** Format: double */
            Tax: number;
            /** Format: double */
            Total: number;
        };
        IntegrationsEmailToContactAnswer: {
            EmailHasToBeSent?: boolean | null;
            EmailIsSent?: boolean | null;
            EmailTo?: string | null;
            EmailCC?: string | null;
            EmailBCC?: string | null;
            EmailFrom?: string | null;
            EmailReplyTo?: string | null;
            EmailSubject?: string | null;
            EmailBody?: string | null;
            Attachments?: components['schemas']['AttachmentAnswer'][] | null;
        };
        IntegrationsEmailToContactAnswerCamelCased: {
            emailHasToBeSent?: boolean | null;
            emailIsSent?: boolean | null;
            emailTo?: string | null;
            emailCC?: string | null;
            emailBCC?: string | null;
            emailFrom?: string | null;
            emailReplyTo?: string | null;
            emailSubject?: string | null;
            emailBody?: string | null;
            attachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
        };
        IntegrationsEmailToContactParamsAnswer: {
            SendToContact?: boolean | null;
            EmailIsSent?: boolean | null;
            EmailToContactTo?: string | null;
            EmailToContactCC?: string | null;
            EmailToContactBCC?: string | null;
            EmailToContactFrom?: string | null;
            EmailToContactReplyTo?: string | null;
            EmailToContactSubject?: string | null;
            EmailToContactBody?: string | null;
            Attachments?: components['schemas']['AttachmentAnswer'][] | null;
        };
        IntegrationsEmailToContactParamsAnswerCamelCased: {
            sendToContact?: boolean | null;
            emailIsSent?: boolean | null;
            emailToContactTo?: string | null;
            emailToContactCC?: string | null;
            emailToContactBCC?: string | null;
            emailToContactFrom?: string | null;
            emailToContactReplyTo?: string | null;
            emailToContactSubject?: string | null;
            emailToContactBody?: string | null;
            attachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
        };
        IntegrationsNetSuiteBillPaymentAnswer: {
            InternalId?: string | null;
            TransactionNumber?: string | null;
            PayeeType?: components['schemas']['NetSuiteApiClientModelsCommonPayeeType'];
            Payee?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Balance?: number | null;
            /** Format: double */
            Amount?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ToBePrinted?: boolean | null;
            PrintVoucher?: boolean | null;
            CheckNumber?: string | null;
            Memo?: string | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            PayeeAddress?: components['schemas']['IntegrationsNetSuitePayeeAddressAnswer'];
            APAccount?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Url?: string | null;
            ApprovalStatus?: string | null;
            Status?: string | null;
            /** Format: date-time */
            TransactionDate?: string | null;
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            CreditList: components['schemas']['IntegrationsNetSuiteBillPaymentCreditLineAnswer'][];
            ApplyList: components['schemas']['IntegrationsNetSuiteBillPaymentApplyLineAnswer'][];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteBillPaymentApplyLineAnswer: {
            /** Format: double */
            PaymentAmount?: number | null;
            CurrencyName?: string | null;
            /** Format: double */
            DiscountAvailable?: number | null;
            /** Format: date-time */
            DiscountDate?: string | null;
            TransactionId?: string | null;
            /** Format: double */
            AmountDue?: number | null;
            /** Format: int64 */
            LineNumber?: number | null;
            /** Format: double */
            OriginalAmount?: number | null;
            /** Format: date-time */
            DateDue?: string | null;
            /** Format: double */
            DiscountAmount?: number | null;
            Type: string;
            Reference?: string | null;
            /** Format: double */
            AmountOnApproval: number;
            Url?: string | null;
            FriendlyName?: string | null;
            /** Format: uuid */
            RequestId?: string | null;
            Attachments: components['schemas']['AttachmentAnswer'][];
        };
        IntegrationsNetSuiteBillPaymentCreditLineAnswer: {
            Reference?: string | null;
            AppliedTo?: string | null;
            Type: string;
            /** Format: date-time */
            DateDue?: string | null;
            /** Format: double */
            Total?: number | null;
            /** Format: int64 */
            LineNumber?: number | null;
            TransactionId?: string | null;
            CurrencyName?: string | null;
            /** Format: double */
            PaymentAmount?: number | null;
            FriendlyName?: string | null;
            /** Format: uuid */
            RequestId?: string | null;
            Attachments: components['schemas']['AttachmentAnswer'][];
            Url?: string | null;
        };
        IntegrationsNetSuiteCustomFieldRefAnswer: {
            ScriptId?: string | null;
            Id: string;
            Name?: string | null;
        };
        IntegrationsNetSuiteDocumentCustomFieldAnswer: {
            /** Format: uuid */
            CompanyFieldId: string;
            ScriptId: string;
            InternalId?: string | null;
            FieldName: string;
            /** Format: int32 */
            FieldOrder: number;
            FieldType: string;
            ValueString?: string | null;
            ValueBoolean?: boolean | null;
            /** Format: date-time */
            ValueDate?: string | null;
            /** Format: double */
            ValueDecimal?: number | null;
            /** Format: int64 */
            ValueLong?: number | null;
            ValueRef?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ValueRefs?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'][] | null;
        };
        IntegrationsNetSuiteExpenseReportAnswer: {
            InternalId?: string | null;
            TransactionNumber?: string | null;
            Employee?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            /** Format: double */
            Advance?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            Memo?: string | null;
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            DueDate?: string | null;
            UseMultiCurrency?: boolean | null;
            /** Format: double */
            TotalAmount?: number | null;
            /** Format: double */
            ReimbursableAmount?: number | null;
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            AccountForCorporateCardExpenses?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            Date?: string | null;
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            ApprovalStatus?: string | null;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Status?: string | null;
            Url?: string | null;
            ExpenseLines: components['schemas']['IntegrationsNetSuiteExpenseReportExpenseLineAnswer'][];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteExpenseReportExpenseLineAnswer: {
            /** Format: int64 */
            RefLineNumber?: number | null;
            /** Format: date-time */
            ExpenseDate?: string | null;
            ExpenseAccount?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Quantity?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: double */
            ForeignAmount?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            Memo?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            IsNonReimbursable?: boolean | null;
            Attachment?: components['schemas']['IntegrationsNetSuiteExpenseReportExpenseLineAttachmentAnswer'];
            IsReceipt?: boolean | null;
            IsCorporateCreditCard?: boolean | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteExpenseReportExpenseLineAttachmentAnswer: {
            /** Format: uuid */
            AttachmentId: string;
            Name?: string | null;
            /** Format: int32 */
            Size: number;
            ExternalId?: string | null;
            /** Format: date-time */
            CreatedDate: string;
        };
        IntegrationsNetSuiteInvoiceAnswer: {
            /** Format: double */
            AmountPaid?: number | null;
            /** Format: double */
            AmountRemaining?: number | null;
            InternalId?: string | null;
            BillingAddress?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DiscountItem?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            DiscountRate?: number | null;
            /** Format: double */
            DiscountTotal?: number | null;
            /** Format: date-time */
            EndDate?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            ExcludeCommissions?: boolean | null;
            /** Format: double */
            HandlingCost?: number | null;
            /** Format: date-time */
            LastModifiedDate?: string | null;
            LeadSource?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            Opportunity?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            TransactionReference?: string | null;
            Partner?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            SalesEffectiveDate?: string | null;
            /** Format: date-time */
            ShipDate?: string | null;
            ShipMethod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ShippingAddress?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            /** Format: double */
            ShippingCost?: number | null;
            /** Format: date-time */
            StartDate?: string | null;
            Status?: string | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TaxTotal?: number | null;
            Terms?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Total?: number | null;
            TransactionNumber?: string | null;
            VatRegistrationNumber?: string | null;
            SalesRep?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            TransactionDate: string;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            CreatedDate: string;
            /** Format: date-time */
            ModifiedDate: string;
            /** Format: date-time */
            DueDate?: string | null;
            /** Format: double */
            DiscountAmount?: number | null;
            /** Format: date-time */
            DiscountDate?: string | null;
            Url?: string | null;
            IsDiscountRateAbsolute?: boolean | null;
            ItemList: components['schemas']['IntegrationsNetSuiteInvoiceItemAnswer'][];
            ExpenseCostList: components['schemas']['IntegrationsNetSuiteInvoiceExpenseCostAnswer'][];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            ItemCostList?: components['schemas']['IntegrationsNetSuiteInvoiceItemCostAnswer'][] | null;
            InvoiceTimeList?: components['schemas']['IntegrationsNetSuiteInvoiceTimeAnswer'][] | null;
        };
        IntegrationsNetSuiteInvoiceExpenseCostAnswer: {
            /** Format: date-time */
            BillDate?: string | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
        };
        IntegrationsNetSuiteInvoiceItemAnswer: {
            /** Format: double */
            Quantity?: number | null;
            Description?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            PriceLevel?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteInvoiceItemCostAnswer: {
            /** Format: date-time */
            BilledDate?: string | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            Quantity?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
        };
        IntegrationsNetSuiteInvoiceTimeAnswer: {
            /** Format: date-time */
            BilledDate?: string | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            Quantity?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            UnitPrice?: number | null;
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DocumentId?: string | null;
            Description?: string | null;
        };
        IntegrationsNetSuiteItemReceiptAnswer: {
            InternalId?: string | null;
            /** Format: double */
            ExchangeRate?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Vendor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            PurchaseOrder?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Partner?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            InboundShipment?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ItemFulfillment?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            LandedCostPerLine?: boolean | null;
            ItemLines: components['schemas']['IntegrationsNetSuiteItemReceiptItemLineAnswer'][];
            ExpenseLines: components['schemas']['IntegrationsNetSuiteItemReceiptExpenseLineAnswer'][];
        };
        IntegrationsNetSuiteItemReceiptAnswerCamelCased: {
            internalId?: string | null;
            /** Format: double */
            exchangeRate?: number | null;
            currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            vendor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            purchaseOrder?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            memo?: string | null;
            postingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            partner?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            inboundShipment?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            itemFulfillment?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            landedCostPerLine?: boolean | null;
            itemLines: components['schemas']['IntegrationsNetSuiteItemReceiptItemLineAnswerCamelCased'][];
            expenseLines: components['schemas']['IntegrationsNetSuiteItemReceiptExpenseLineAnswerCamelCased'][];
        };
        IntegrationsNetSuiteItemReceiptExpenseLineAnswer: {
            MarkReceived?: boolean | null;
            IsChecked: boolean;
            /** Format: int64 */
            OrderLine?: number | null;
            Account?: string | null;
            /** Format: double */
            Amount?: number | null;
            Description?: string | null;
            /** Format: int64 */
            LineNumber?: number | null;
        };
        IntegrationsNetSuiteItemReceiptExpenseLineAnswerCamelCased: {
            markReceived?: boolean | null;
            isChecked: boolean;
            /** Format: int64 */
            orderLine?: number | null;
            account?: string | null;
            /** Format: double */
            amount?: number | null;
            description?: string | null;
            /** Format: int64 */
            lineNumber?: number | null;
        };
        IntegrationsNetSuiteItemReceiptItemLineAnswer: {
            IsChecked: boolean;
            JobName?: string | null;
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int64 */
            OrderLine?: number | null;
            /** Format: int64 */
            LineNumber?: number | null;
            ItemName?: string | null;
            Description?: string | null;
            /** Format: double */
            OnHand?: number | null;
            /** Format: double */
            QuantityRemaining?: number | null;
            /** Format: double */
            Quantity?: number | null;
            UnitsDisplay?: string | null;
            /** Format: double */
            UnitCostOverride?: number | null;
            SerialNumbers?: string | null;
            BinNumbers?: string | null;
            /** Format: date-time */
            ExpirationDate?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            IsUnitPriceAbsolute?: boolean | null;
            Currency?: string | null;
            Restock?: boolean | null;
            IsDropShipment?: boolean | null;
            /** Format: double */
            Amount?: number | null;
        };
        IntegrationsNetSuiteItemReceiptItemLineAnswerCamelCased: {
            isChecked: boolean;
            jobName?: string | null;
            item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            /** Format: int64 */
            orderLine?: number | null;
            /** Format: int64 */
            lineNumber?: number | null;
            itemName?: string | null;
            description?: string | null;
            /** Format: double */
            onHand?: number | null;
            /** Format: double */
            quantityRemaining?: number | null;
            /** Format: double */
            quantity?: number | null;
            unitsDisplay?: string | null;
            /** Format: double */
            unitCostOverride?: number | null;
            serialNumbers?: string | null;
            binNumbers?: string | null;
            /** Format: date-time */
            expirationDate?: string | null;
            /** Format: double */
            unitPrice?: number | null;
            isUnitPriceAbsolute?: boolean | null;
            currency?: string | null;
            restock?: boolean | null;
            isDropShipment?: boolean | null;
            /** Format: double */
            amount?: number | null;
        };
        IntegrationsNetSuiteJournalEntryAnswer: {
            InternalId?: string | null;
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Status?: string | null;
            /** Format: double */
            Total?: number | null;
            /** Format: date */
            TransactionDate: string;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            CreatedDate: string;
            /** Format: date-time */
            ModifiedDate: string;
            /** Format: uuid */
            CompanyId: string;
            /** Format: date-time */
            Date: string;
            Url?: string | null;
            /** Format: date */
            ReversalDate?: string | null;
            ReversalDefer: boolean;
            ReversalEntry?: string | null;
            Reference?: string | null;
            FriendlyName?: string | null;
            Enabled: boolean;
            ReversalUrl?: string | null;
            IsReversal: boolean;
            Lines: components['schemas']['IntegrationsNetSuiteJournalEntryLineAnswer'][];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            /** Format: double */
            readonly DebitTotal: number;
            /** Format: double */
            readonly CreditTotal: number;
        };
        IntegrationsNetSuiteJournalEntryLineAnswer: {
            /** Format: double */
            DebitAmount?: number | null;
            AmortizationSchedule?: components['schemas']['NetSuiteDomainEntitiesRecordRef'];
            Memo?: string | null;
            /** Format: double */
            AmortizationResidual?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            CreditAmount?: number | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date */
            AmortizationEndDate?: string | null;
            /** Format: date */
            AmortizationStartDate?: string | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            TaxAccount?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteNetSuiteAddressAnswer: {
            Id?: string | null;
            FullAddress: string;
        };
        IntegrationsNetSuitePayeeAddressAnswer: {
            AddressText: string;
            Id: string;
        };
        IntegrationsNetSuitePurchaseOrderAnswer: {
            InternalId?: string | null;
            VendorReference?: string | null;
            Vendor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Employee?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            DueDate?: string | null;
            /** Format: date-time */
            TransactionDate?: string | null;
            Reference?: string | null;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            ApprovalStatus?: string | null;
            Status?: string | null;
            Address?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            Terms?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Incoterm?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            VatRegistrationNumber?: string | null;
            /** Format: double */
            Subtotal?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            TotalAmount?: number | null;
            Memo?: string | null;
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            IntegrationEnabled?: boolean | null;
            /** Format: int32 */
            WorkflowLockDatePolicy?: number | null;
            /** Format: date-time */
            CompanyLockDate?: string | null;
            Url?: string | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            ItemLines: components['schemas']['IntegrationsNetSuitePurchaseOrderItemLineAnswer'][];
            ExpenseLines: components['schemas']['IntegrationsNetSuitePurchaseOrderExpenseLineAnswer'][];
            /** Format: double */
            NetAmount?: number | null;
            /** Format: date-time */
            ShipDate?: string | null;
            ShipMethod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ShippingAddress?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ShipTo?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ShipIsResidential?: boolean | null;
            TrackingNumbers?: string | null;
            FreeOnBoard?: string | null;
        };
        IntegrationsNetSuitePurchaseOrderExpenseLineAnswer: {
            Category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            CatalogAmount?: number | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuitePurchaseOrderItemLineAnswer: {
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            VendorName?: string | null;
            /** Format: double */
            QuantityReceived?: number | null;
            /** Format: double */
            QuantityBilled?: number | null;
            /** Format: double */
            Quantity?: number | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            UnitPriceV2?: components['schemas']['NetSuiteDomainEntitiesUnitPrice'];
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            IsMatchBillToReceipt?: boolean | null;
            /** Format: date-time */
            ExpectedReceiptDate?: string | null;
            IsClosed?: boolean | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteRecordRefAnswer: {
            Id: string;
            Name?: string | null;
        };
        IntegrationsNetSuiteRecordRefAnswerCamelCased: {
            id: string;
            name?: string | null;
        };
        IntegrationsNetSuiteReturnAuthorizationAnswer: {
            InternalId?: string | null;
            TransactionNumber?: string | null;
            TransactionReference?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            TransactionDate?: string | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DiscountItem?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            DiscountRate?: number | null;
            Memo?: string | null;
            BillingAddress?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            /** Format: double */
            Subtotal?: number | null;
            /** Format: double */
            DiscountTotal?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            TotalAmount?: number | null;
            ExcludeCommissions?: boolean | null;
            Project?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            LeadSource?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Partner?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date */
            SalesEffectiveDate?: string | null;
            SalesRep?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            Status?: string | null;
            /** Format: date-time */
            CompanyLockDate?: string | null;
            Url?: string | null;
            IntegrationEnabled?: boolean | null;
            /** Format: int32 */
            WorkflowLockDatePolicy?: number | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            ItemLines: components['schemas']['IntegrationsNetSuiteReturnAuthorizationItemLineAnswer'][];
        };
        IntegrationsNetSuiteReturnAuthorizationItemLineAnswer: {
            /** Format: double */
            QuantityReceived?: number | null;
            /** Format: double */
            QuantityBilled?: number | null;
            /** Format: double */
            Quantity?: number | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            PriceLevel?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            IsClosed?: boolean | null;
            IsDropShipment?: boolean | null;
            CostEstimateType?: string | null;
            /** Format: double */
            CostEstimate?: number | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteSalesOrderAnswer: {
            InternalId?: string | null;
            Reference?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            TransactionDate?: string | null;
            /** Format: date-time */
            StartDate?: string | null;
            /** Format: date-time */
            EndDate?: string | null;
            PaymentReference?: string | null;
            Memo?: string | null;
            ApprovalStatus?: string | null;
            Status?: string | null;
            SalesRep?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Opportunity?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            SalesEffectiveDate?: string | null;
            ExcludeCommissions?: boolean | null;
            Partner?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DiscountItem?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            DiscountRate?: number | null;
            IsDiscountRateAbsolute?: boolean | null;
            /** Format: double */
            DiscountTotal?: number | null;
            /** Format: double */
            Subtotal?: number | null;
            /** Format: double */
            TaxTotal?: number | null;
            /** Format: double */
            Tax2Total?: number | null;
            /** Format: double */
            Total?: number | null;
            /** Format: date-time */
            ShipDate?: string | null;
            ShipMethod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ShipComplete?: boolean | null;
            ShippingAddress?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            Terms?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            BillingSchedule?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Address?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            PaymentMethod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            CreditCardNumber?: string | null;
            /** Format: date-time */
            CreditCardExpirationDate?: string | null;
            CreditCardCardholderName?: string | null;
            CreditCardStreet?: string | null;
            CreditCardZipCode?: string | null;
            CreditCardProcessor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            CreditCardApproved?: boolean | null;
            PnRef?: string | null;
            AuthCode?: string | null;
            AvsStreetMatch?: string | null;
            AvsZipMatch?: string | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            VatRegistrationNumber?: string | null;
            RevenueStatus?: string | null;
            /** Format: double */
            RecognizedRevenue?: number | null;
            /** Format: double */
            DeferredRevenue?: number | null;
            Url?: string | null;
            ItemLines: components['schemas']['IntegrationsNetSuiteSalesOrderItemLineAnswer'][];
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteSalesOrderItemLineAnswer: {
            /** Format: int64 */
            LineUniqueKey?: number | null;
            /** Format: double */
            QuantityCommitted?: number | null;
            /** Format: double */
            QuantityFulfilled?: number | null;
            /** Format: double */
            QuantityBilled?: number | null;
            /** Format: double */
            QuantityBackOrdered?: number | null;
            /** Format: double */
            Quantity?: number | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            SerialNumbers?: string | null;
            PriceLevel?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            UnitPrice?: number | null;
            UnitPriceV2?: components['schemas']['NetSuiteDomainEntitiesUnitPrice'];
            /** Format: double */
            OrderPriority?: number | null;
            RevenueRecognitionSchedule?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: date-time */
            RevenueRecognitionStartDate?: string | null;
            /** Format: date-time */
            RevenueRecognitionEndDate?: string | null;
            ExcludeFromRateRequest?: boolean | null;
            IsClosed?: boolean | null;
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteVendorAddressLineAnswer: {
            InternalId?: string | null;
            Label?: string | null;
            DefaultBilling?: boolean | null;
            DefaultShipping?: boolean | null;
            AddressInternalId?: string | null;
            PrimaryAddress?: string | null;
            SecondaryAddress?: string | null;
            AdditionalAddress?: string | null;
            Addressee?: string | null;
            Attention?: string | null;
            City?: string | null;
            Zip?: string | null;
            State?: string | null;
            Phone?: string | null;
            AddressRepresentation?: string | null;
            Country?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
        };
        IntegrationsNetSuiteVendorAnswer: {
            InternalId?: string | null;
            VendorId?: string | null;
            CompanyName?: string | null;
            WebAddress?: string | null;
            Salutation?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            MiddleName?: string | null;
            JobTitle?: string | null;
            Comments?: string | null;
            Email?: string | null;
            Phone?: string | null;
            AltPhone?: string | null;
            Fax?: string | null;
            LegalName?: string | null;
            AccountNumber?: string | null;
            /** Format: double */
            CreditLimit?: number | null;
            TaxNumber?: string | null;
            Is1099Eligible?: boolean | null;
            IsJobResource?: boolean | null;
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            Category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Incoterm?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DefaultExpenseAccount?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            DefaultPayablesAccount?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Terms?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Type?: components['schemas']['NetSuiteApiClientModelsVendorsVendorType'];
            Currencies: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'][];
            Subsidiaries: components['schemas']['IntegrationsNetSuiteVendorSubsidiaryRelationshipAnswer'][];
            AddressLines: components['schemas']['IntegrationsNetSuiteVendorAddressLineAnswer'][];
            CustomFields: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][];
            Url?: string | null;
        };
        IntegrationsNetSuiteVendorBillAnswer: {
            InternalId?: string | null;
            TransactionNumber?: string | null;
            Reference?: string | null;
            Vendor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TotalAmount?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            VatRegistrationNumber?: string | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            DiscountAmount?: number | null;
            /** Format: date-time */
            DiscountDate?: string | null;
            IsPaymentHold?: boolean | null;
            /** Format: date-time */
            DueDate?: string | null;
            /** Format: date-time */
            TransactionDate?: string | null;
            Memo?: string | null;
            PostingPeriod?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ApprovalStatus?: string | null;
            Status?: string | null;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Terms?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Address?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            IntegrationEnabled?: boolean | null;
            /** Format: int32 */
            WorkflowLockDatePolicy?: number | null;
            /** Format: date-time */
            CompanyLockDate?: string | null;
            Url?: string | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            ItemLines: components['schemas']['IntegrationsNetSuiteVendorBillItemLineAnswer'][];
            ExpenseLines: components['schemas']['IntegrationsNetSuiteVendorBillExpenseLineAnswer'][];
            /** Format: double */
            NetAmount?: number | null;
        };
        IntegrationsNetSuiteVendorBillExpenseLineAnswer: {
            AmortizationSchedule?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            AmortizationResidual?: number | null;
            IsAmortizationResidualAbsolute?: boolean | null;
            /** Format: date-time */
            AmortizationStartDate?: string | null;
            /** Format: date-time */
            AmortizationEndDate?: string | null;
            Category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            CatalogAmount?: number | null;
            ProjectTask?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            OrderDocId?: string | null;
            /** Format: int32 */
            OrderLineNumber?: number | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteVendorBillItemLineAnswer: {
            AmortizationSchedule?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            AmortizationResidual?: number | null;
            IsAmortizationResidualAbsolute?: boolean | null;
            /** Format: date-time */
            AmortizationStartDate?: string | null;
            /** Format: date-time */
            AmortizationEndDate?: string | null;
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            VendorName?: string | null;
            /** Format: double */
            Quantity?: number | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            UnitPriceV2?: components['schemas']['NetSuiteDomainEntitiesUnitPrice'];
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Options?: components['schemas']['IntegrationsNetSuiteCustomFieldRefAnswer'][] | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            ProjectTask?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            OrderDocId?: string | null;
            /** Format: int32 */
            OrderLineNumber?: number | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteVendorReturnAuthorizationAnswer: {
            InternalId?: string | null;
            TransactionNumber?: string | null;
            Vendor?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TotalAmount?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            ExchangeRate?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: date-time */
            TransactionDate?: string | null;
            Memo?: string | null;
            Status?: string | null;
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            BillingAddress?: components['schemas']['IntegrationsNetSuiteNetSuiteAddressAnswer'];
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            IntegrationEnabled?: boolean | null;
            /** Format: int32 */
            WorkflowLockDatePolicy?: number | null;
            /** Format: date-time */
            CompanyLockDate?: string | null;
            Url?: string | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
            ItemLines: components['schemas']['IntegrationsNetSuiteVendorReturnAuthorizationItemLineAnswer'][];
            ExpenseLines: components['schemas']['IntegrationsNetSuiteVendorReturnAuthorizationExpenseLineAnswer'][];
            /** Format: double */
            NetAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
        };
        IntegrationsNetSuiteVendorReturnAuthorizationExpenseLineAnswer: {
            /** Format: double */
            CatalogAmount?: number | null;
            Category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Memo?: string | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteVendorReturnAuthorizationItemLineAnswer: {
            Item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            VendorName?: string | null;
            /** Format: double */
            Quantity?: number | null;
            Units?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Description?: string | null;
            /** Format: double */
            UnitPrice?: number | null;
            UnitPriceV2?: components['schemas']['NetSuiteDomainEntitiesUnitPrice'];
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Options?: components['schemas']['IntegrationsNetSuiteCustomFieldRefAnswer'][] | null;
            Customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            IsClosed?: boolean | null;
            /** Format: double */
            Amount?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRate2?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Tax2Amount?: number | null;
            /** Format: double */
            GrossAmount?: number | null;
            Department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            /** Format: int32 */
            LineNumber?: number | null;
            IsBillable?: boolean | null;
            CustomFields?: components['schemas']['IntegrationsNetSuiteDocumentCustomFieldAnswer'][] | null;
        };
        IntegrationsNetSuiteVendorSubsidiaryRelationshipAnswer: {
            IsPrimary: boolean;
            /** Format: double */
            CreditLimit?: number | null;
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Subsidiary?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
        };
        IntegrationsQBooksAccountBasedLineAnswer: {
            AccountId?: string | null;
            Account?: string | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksAccountBasedLineAnswerCamelCased: {
            accountId?: string | null;
            account?: string | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksBillInvoiceAccountBasedLineAnswer: {
            /** Format: uuid */
            MatchedLineItemId?: string | null;
            AccountId?: string | null;
            Account?: string | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksBillInvoiceAccountBasedLineAnswerCamelCased: {
            /** Format: uuid */
            matchedLineItemId?: string | null;
            accountId?: string | null;
            account?: string | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksBillInvoiceAnswer: {
            Date?: string | null;
            DueDate?: string | null;
            BillInvoiceNumber?: string | null;
            Vendor?: components['schemas']['ApiIntegrationsContact'];
            Term?: components['schemas']['ApiIntegrationsQBooksTerm'];
            Department?: components['schemas']['ApiIntegrationsQBooksDepartment'];
            DepartmentTerminology?: string | null;
            MailingAddress?: string | null;
            Memo?: string | null;
            /** Format: double */
            TotalTax?: number | null;
            /** Format: double */
            SubTotal: number;
            TaxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponent'][] | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            ItemBasedLines?: components['schemas']['IntegrationsQBooksBillInvoiceItemBasedLineAnswer'][] | null;
            AccountBasedLines?: components['schemas']['IntegrationsQBooksBillInvoiceAccountBasedLineAnswer'][] | null;
            Url?: string | null;
            EditUrl?: string | null;
            IsPaid: boolean;
            IsStatusPushPending: boolean;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksBillInvoiceAnswerCamelCased: {
            date?: string | null;
            dueDate?: string | null;
            billInvoiceNumber?: string | null;
            vendor?: components['schemas']['ApiIntegrationsContactCamelCased'];
            term?: components['schemas']['ApiIntegrationsQBooksTermCamelCased'];
            department?: components['schemas']['ApiIntegrationsQBooksDepartmentCamelCased'];
            departmentTerminology?: string | null;
            mailingAddress?: string | null;
            memo?: string | null;
            /** Format: double */
            totalTax?: number | null;
            /** Format: double */
            subTotal: number;
            taxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponentCamelCased'][] | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            itemBasedLines?:
                | components['schemas']['IntegrationsQBooksBillInvoiceItemBasedLineAnswerCamelCased'][]
                | null;
            accountBasedLines?:
                | components['schemas']['IntegrationsQBooksBillInvoiceAccountBasedLineAnswerCamelCased'][]
                | null;
            url?: string | null;
            editUrl?: string | null;
            isPaid: boolean;
            isStatusPushPending: boolean;
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksBillInvoiceItemBasedLineAnswer: {
            /** Format: uuid */
            MatchedLineItemId?: string | null;
            ItemId?: string | null;
            Item?: string | null;
            AccountId?: string | null;
            Account?: string | null;
            IsInventory?: boolean | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksBillInvoiceItemBasedLineAnswerCamelCased: {
            /** Format: uuid */
            matchedLineItemId?: string | null;
            itemId?: string | null;
            item?: string | null;
            accountId?: string | null;
            account?: string | null;
            isInventory?: boolean | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksExpenseAnswer: {
            PayeeType?: components['schemas']['ApiIntegrationsQBooksPayeeType'];
            Payee?: components['schemas']['ApiIntegrationsQBooksPayee'];
            PaymentAccount?: components['schemas']['ApiIntegrationsQBooksAccount'];
            PaymentType?: components['schemas']['ApiIntegrationsQBooksPaymentType'];
            PaymentMethod?: components['schemas']['ApiIntegrationsQBooksPaymentMethod'];
            Date?: string | null;
            DueDate?: string | null;
            ExpenseNumber?: string | null;
            Vendor?: components['schemas']['ApiIntegrationsContact'];
            Term?: components['schemas']['ApiIntegrationsQBooksTerm'];
            Department?: components['schemas']['ApiIntegrationsQBooksDepartment'];
            DepartmentTerminology?: string | null;
            MailingAddress?: string | null;
            Memo?: string | null;
            /** Format: double */
            TotalTax?: number | null;
            /** Format: double */
            SubTotal: number;
            TaxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponent'][] | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            ItemBasedLines?: components['schemas']['IntegrationsQBooksItemBasedLineAnswer'][] | null;
            AccountBasedLines?: components['schemas']['IntegrationsQBooksAccountBasedLineAnswer'][] | null;
            Url?: string | null;
            EditUrl?: string | null;
            IsStatusPushPending: boolean;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksExpenseAnswerCamelCased: {
            payeeType?: components['schemas']['ApiIntegrationsQBooksPayeeTypeCamelCased'];
            payee?: components['schemas']['ApiIntegrationsQBooksPayeeCamelCased'];
            paymentAccount?: components['schemas']['ApiIntegrationsQBooksAccountCamelCased'];
            paymentType?: components['schemas']['ApiIntegrationsQBooksPaymentTypeCamelCased'];
            paymentMethod?: components['schemas']['ApiIntegrationsQBooksPaymentMethodCamelCased'];
            date?: string | null;
            dueDate?: string | null;
            expenseNumber?: string | null;
            vendor?: components['schemas']['ApiIntegrationsContactCamelCased'];
            term?: components['schemas']['ApiIntegrationsQBooksTermCamelCased'];
            department?: components['schemas']['ApiIntegrationsQBooksDepartmentCamelCased'];
            departmentTerminology?: string | null;
            mailingAddress?: string | null;
            memo?: string | null;
            /** Format: double */
            totalTax?: number | null;
            /** Format: double */
            subTotal: number;
            taxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponentCamelCased'][] | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            itemBasedLines?: components['schemas']['IntegrationsQBooksItemBasedLineAnswerCamelCased'][] | null;
            accountBasedLines?: components['schemas']['IntegrationsQBooksAccountBasedLineAnswerCamelCased'][] | null;
            url?: string | null;
            editUrl?: string | null;
            isStatusPushPending: boolean;
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksItemBasedLineAnswer: {
            ItemId?: string | null;
            Item?: string | null;
            AccountId?: string | null;
            Account?: string | null;
            IsInventory?: boolean | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksItemBasedLineAnswerCamelCased: {
            itemId?: string | null;
            item?: string | null;
            accountId?: string | null;
            account?: string | null;
            isInventory?: boolean | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksJournalEntryAnswer: {
            /** Format: date-time */
            Date?: string | null;
            Number?: string | null;
            Memo?: string | null;
            DepartmentTerminology?: string | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            TaxComponents?: components['schemas']['ApiIntegrationsQBooksJournalEntryTaxComponent'][] | null;
            /** Format: double */
            DebitSubTotal?: number | null;
            /** Format: double */
            CreditSubTotal?: number | null;
            /** Format: double */
            DebitTotalTax?: number | null;
            /** Format: double */
            CreditTotalTax?: number | null;
            Status?: components['schemas']['QBooksDomainEntitiesDocumentsQBooksDocumentStatus'];
            /** Format: date-time */
            CreatedDate: string;
            /** Format: date-time */
            ModifiedDate: string;
            EditUrl?: string | null;
            Url?: string | null;
            Lines?: components['schemas']['IntegrationsQBooksJournalEntryLineAnswer'][] | null;
            IsStatusPushPending: boolean;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksJournalEntryLineAnswer: {
            /** Format: uuid */
            LineId: string;
            /** Format: uuid */
            QBooksDocumentId: string;
            /** Format: int32 */
            LineOrder: number;
            Account?: components['schemas']['ApiIntegrationsQBooksAccount'];
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            AmountSide?: components['schemas']['DomainEntitiesAmountSide'];
            Description?: string | null;
            PayeeType?: components['schemas']['QBooksDomainEntitiesDocumentsPayeeType'];
            Payee?: components['schemas']['ApiIntegrationsQBooksPayee'];
            Department?: components['schemas']['ApiIntegrationsQBooksDepartment'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxApplicableOnType?: components['schemas']['QBooksDomainEntitiesDocumentsJournalEntriesTaxApplicableOnType'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
        };
        IntegrationsQBooksPurchaseOrderAccountBasedLineAnswer: {
            /** Format: double */
            RemainingBalanceForRequest?: number | null;
            MatchedLineItemIds: string[];
            AccountId?: string | null;
            Account?: string | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksPurchaseOrderAccountBasedLineAnswerCamelCased: {
            /** Format: double */
            remainingBalanceForRequest?: number | null;
            matchedLineItemIds: string[];
            accountId?: string | null;
            account?: string | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksPurchaseOrderAnswer: {
            PurchaseOrderNumber?: string | null;
            Vendor?: components['schemas']['ApiIntegrationsContact'];
            Department?: components['schemas']['ApiIntegrationsQBooksDepartment'];
            DepartmentTerminology?: string | null;
            MailingAddress?: string | null;
            ShippingAddress?: string | null;
            ShippingMethod?: string | null;
            Date?: string | null;
            Memo?: string | null;
            VendorMessage?: string | null;
            EmailToContactParams?: components['schemas']['IntegrationsEmailToContactParamsAnswer'];
            LineItems?: components['schemas']['IntegrationsQBooksPurchaseOrderItemBasedLineAnswer'][] | null;
            AccountBasedLines?: components['schemas']['IntegrationsQBooksPurchaseOrderAccountBasedLineAnswer'][] | null;
            CustomFields?: components['schemas']['ApiIntegrationsQBooksCustomField'][] | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            /** Format: double */
            TotalTax?: number | null;
            /** Format: double */
            SubTotal: number;
            TaxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponent'][] | null;
            Url?: string | null;
            EditUrl?: string | null;
            Status?: components['schemas']['QBooksDomainEntitiesDocumentsQBooksDocumentStatus'];
            GrnStatus?: components['schemas']['DomainEntitiesGrnStatus'];
            IsStatusPushPending: boolean;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksPurchaseOrderAnswerCamelCased: {
            purchaseOrderNumber?: string | null;
            vendor?: components['schemas']['ApiIntegrationsContactCamelCased'];
            department?: components['schemas']['ApiIntegrationsQBooksDepartmentCamelCased'];
            departmentTerminology?: string | null;
            mailingAddress?: string | null;
            shippingAddress?: string | null;
            shippingMethod?: string | null;
            date?: string | null;
            memo?: string | null;
            vendorMessage?: string | null;
            emailToContactParams?: components['schemas']['IntegrationsEmailToContactParamsAnswerCamelCased'];
            lineItems?: components['schemas']['IntegrationsQBooksPurchaseOrderItemBasedLineAnswerCamelCased'][] | null;
            accountBasedLines?:
                | components['schemas']['IntegrationsQBooksPurchaseOrderAccountBasedLineAnswerCamelCased'][]
                | null;
            customFields?: components['schemas']['ApiIntegrationsQBooksCustomFieldCamelCased'][] | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            /** Format: double */
            totalTax?: number | null;
            /** Format: double */
            subTotal: number;
            taxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponentCamelCased'][] | null;
            url?: string | null;
            editUrl?: string | null;
            status?: components['schemas']['QBooksDomainEntitiesDocumentsQBooksDocumentStatus'];
            grnStatus?: components['schemas']['DomainEntitiesGrnStatus'];
            isStatusPushPending: boolean;
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksPurchaseOrderItemBasedLineAnswer: {
            /** Format: double */
            RemainingBalanceForRequest?: number | null;
            MatchedLineItemIds: string[];
            ItemId?: string | null;
            Item?: string | null;
            AccountId?: string | null;
            Account?: string | null;
            IsInventory?: boolean | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksPurchaseOrderItemBasedLineAnswerCamelCased: {
            /** Format: double */
            remainingBalanceForRequest?: number | null;
            matchedLineItemIds: string[];
            itemId?: string | null;
            item?: string | null;
            accountId?: string | null;
            account?: string | null;
            isInventory?: boolean | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            /** Format: double */
            unitPriceGross?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            customer?: components['schemas']['ApiIntegrationsContactCamelCased'];
            class?: components['schemas']['ApiIntegrationsQBooksClassCamelCased'];
            taxCode?: components['schemas']['ApiIntegrationsQBooksTaxCodeCamelCased'];
            isBillable?: boolean | null;
            isTaxable?: boolean | null;
            isMatched?: boolean | null;
            /** Format: double */
            remainingBalance?: number | null;
        };
        IntegrationsQBooksSalesInvoiceAnswer: {
            SalesInvoiceNumber?: string | null;
            Department?: components['schemas']['ApiIntegrationsQBooksDepartment'];
            DepartmentTerminology?: string | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            BillingAddress?: string | null;
            Term?: components['schemas']['ApiIntegrationsQBooksTerm'];
            DueDate?: string | null;
            Date?: string | null;
            ShippingFromAddress?: string | null;
            ShippingAddress?: string | null;
            ShippingMethod?: string | null;
            ShippingDate?: string | null;
            TrackingNumber?: string | null;
            CustomerMemo?: string | null;
            Memo?: string | null;
            /** Format: double */
            Shipping?: number | null;
            ShippingTaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            /** Format: double */
            ShippingTaxAmount?: number | null;
            /** Format: double */
            Deposit?: number | null;
            /** Format: double */
            Balance?: number | null;
            /** Format: double */
            Discount?: number | null;
            /** Format: double */
            DiscountAmount?: number | null;
            ApplyTaxAfterDiscount?: boolean | null;
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            UseAutoTaxes?: boolean | null;
            LineItems?: components['schemas']['IntegrationsQBooksSalesInvoiceItemBasedLineAnswer'][] | null;
            CustomFields?: components['schemas']['ApiIntegrationsQBooksCustomField'][] | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            /** Format: double */
            TotalTax?: number | null;
            /** Format: double */
            SubTotal: number;
            TaxComponents?: components['schemas']['ApiIntegrationsQBooksExpenseTaxComponent'][] | null;
            Url?: string | null;
            EditUrl?: string | null;
            Status?: components['schemas']['QBooksDomainEntitiesDocumentsQBooksDocumentStatus'];
            /** Format: date-time */
            CreatedDate: string;
            /** Format: date-time */
            ModifiedDate: string;
            EmailIsSentFromQBooks?: boolean | null;
            IsPaid: boolean;
            IsStatusPushPending: boolean;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
        };
        IntegrationsQBooksSalesInvoiceItemBasedLineAnswer: {
            ItemId?: string | null;
            Item?: string | null;
            AccountId?: string | null;
            Account?: string | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: date-time */
            ServiceDate?: string | null;
            /** Format: double */
            Discount?: number | null;
            /** Format: double */
            DiscountAmount?: number | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            /** Format: double */
            UnitPriceGross?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            Customer?: components['schemas']['ApiIntegrationsContact'];
            Class?: components['schemas']['ApiIntegrationsQBooksClass'];
            TaxCode?: components['schemas']['ApiIntegrationsQBooksTaxCode'];
            IsBillable?: boolean | null;
            IsTaxable?: boolean | null;
            IsMatched?: boolean | null;
            /** Format: double */
            RemainingBalance?: number | null;
        };
        IntegrationsQBooksVendorAnswer: {
            /** Format: uuid */
            id: string;
            title?: string | null;
            firstName?: string | null;
            middleName?: string | null;
            lastName?: string | null;
            suffix?: string | null;
            displayName?: string | null;
            printOnCheckName?: string | null;
            companyName?: string | null;
            address?: components['schemas']['QBooksDomainModelsAddress'];
            notes?: string | null;
            emailAddress?: string | null;
            phone?: string | null;
            mobile?: string | null;
            fax?: string | null;
            webSite?: string | null;
            accountNumber?: string | null;
            businessNumber?: string | null;
            currencyCode?: string | null;
            paymentDetails?: components['schemas']['QBooksDomainEntitiesApprovalEntitiesPaymentDetails'];
        };
        IntegrationsXeroAccountAnswer: {
            id: string;
            text: string;
        };
        IntegrationsXeroAccountAnswerCamelCased: {
            id: string;
            text: string;
        };
        IntegrationsXeroAllocationAnswer: {
            RequestFriendlyName: string;
            /** Format: uuid */
            RequestId: string;
            /** Format: double */
            Amount: number;
        };
        IntegrationsXeroAllocationAnswerCamelCased: {
            requestFriendlyName: string;
            /** Format: uuid */
            requestId: string;
            /** Format: double */
            amount: number;
        };
        IntegrationsXeroBankAccountAnswer: {
            /** Format: uuid */
            Id: string;
            Name: string;
            Code?: string | null;
        };
        IntegrationsXeroBankAccountAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            name: string;
            code?: string | null;
        };
        IntegrationsXeroBillBatchPaymentAnswer: {
            /** Format: date-time */
            createdDate: string;
            /** Format: date-time */
            modifiedDate: string;
            /** Format: uuid */
            xeroBillBatchPaymentId: string;
            bankAccount?: components['schemas']['IntegrationsXeroBankAccountAnswer'];
            /** Format: date-time */
            paymentDate?: string | null;
            narrative?: string | null;
            details?: string | null;
            reference?: string | null;
            particulars?: string | null;
            code?: string | null;
            items: components['schemas']['IntegrationsXeroBillBatchPaymentItemAnswer'][];
            url?: string | null;
            editUrl?: string | null;
            /** Format: date-time */
            lockDate?: string | null;
            /** Format: date-time */
            companyLockDate?: string | null;
            workflowLockDatePolicy?: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
            workflowIsSupplierBankAccountRequired: boolean;
            /** Format: double */
            amount: number;
        };
        IntegrationsXeroBillBatchPaymentAnswerCamelCased: {
            /** Format: date-time */
            createdDate: string;
            /** Format: date-time */
            modifiedDate: string;
            /** Format: uuid */
            xeroBillBatchPaymentId: string;
            bankAccount?: components['schemas']['IntegrationsXeroBankAccountAnswerCamelCased'];
            /** Format: date-time */
            paymentDate?: string | null;
            narrative?: string | null;
            details?: string | null;
            reference?: string | null;
            particulars?: string | null;
            code?: string | null;
            items: components['schemas']['IntegrationsXeroBillBatchPaymentItemAnswerCamelCased'][];
            url?: string | null;
            editUrl?: string | null;
            /** Format: date-time */
            lockDate?: string | null;
            /** Format: date-time */
            companyLockDate?: string | null;
            workflowLockDatePolicy?: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
            workflowIsSupplierBankAccountRequired: boolean;
            /** Format: double */
            amount: number;
        };
        IntegrationsXeroBillBatchPaymentItemAnswer: {
            /** Format: uuid */
            xeroBillInvoiceRequestId: string;
            xeroBillInvoiceReference?: string | null;
            friendlyName: string;
            contact?: components['schemas']['ApiIntegrationsContact'];
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            note?: string | null;
            currency?: string | null;
            /** Format: date-time */
            plannedDate?: string | null;
            bankAccountNumber?: string | null;
            defaultBankAccountNumber?: string | null;
            details?: string | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            billInvoiceAmount?: number | null;
            /** Format: double */
            amountDue?: number | null;
            particulars?: string | null;
            code?: string | null;
            reference?: string | null;
            attachments?: components['schemas']['AttachmentAnswer'][] | null;
        };
        IntegrationsXeroBillBatchPaymentItemAnswerCamelCased: {
            /** Format: uuid */
            xeroBillInvoiceRequestId: string;
            xeroBillInvoiceReference?: string | null;
            friendlyName: string;
            contact?: components['schemas']['ApiIntegrationsContactCamelCased'];
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            note?: string | null;
            currency?: string | null;
            /** Format: date-time */
            plannedDate?: string | null;
            bankAccountNumber?: string | null;
            defaultBankAccountNumber?: string | null;
            details?: string | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            billInvoiceAmount?: number | null;
            /** Format: double */
            amountDue?: number | null;
            particulars?: string | null;
            code?: string | null;
            reference?: string | null;
            attachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
        };
        IntegrationsXeroContactAnswer: {
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            emailAddress?: string | null;
            accountNumber?: string | null;
            isSupplier: boolean;
            isCustomer: boolean;
            persons: components['schemas']['ApiIntegrationsContactPerson'][];
            phoneNumber?: components['schemas']['XeroDomainModelsPhone'];
            fax?: components['schemas']['XeroDomainModelsPhone'];
            mobile?: components['schemas']['XeroDomainModelsPhone'];
            directDial?: components['schemas']['XeroDomainModelsPhone'];
            skypeName?: string | null;
            postalAddress?: components['schemas']['XeroDomainModelsAddressInfo'];
            billingAddress?: components['schemas']['XeroDomainModelsAddressInfo'];
            MailingAddress?: components['schemas']['IntegrationXeroDeliveryAddressInfo'];
            deliveryAddress?: components['schemas']['IntegrationXeroDeliveryAddressInfo'];
            bankAccountDetails?: string | null;
            defaultCurrency?: string | null;
            taxNumber?: string | null;
            companyNumber?: string | null;
            salesTax?: components['schemas']['IntegrationsXeroTaxAnswer'];
            purchaseTax?: components['schemas']['IntegrationsXeroTaxAnswer'];
            salesAccount?: components['schemas']['IntegrationsXeroAccountAnswer'];
            purchaseAccount?: components['schemas']['IntegrationsXeroAccountAnswer'];
            salesTrackingCategories: components['schemas']['IntegrationsXeroTrackingCategoryAnswer'][];
            purchaseTrackingCategories: components['schemas']['IntegrationsXeroTrackingCategoryAnswer'][];
            integrationEnabled: boolean;
            primaryPerson?: components['schemas']['ApiIntegrationsContactPerson'];
            url?: string | null;
            editUrl?: string | null;
            isStatusPushPending: boolean;
        };
        IntegrationsXeroContactAnswerCamelCased: {
            id: string;
            name?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            emailAddress?: string | null;
            accountNumber?: string | null;
            isSupplier: boolean;
            isCustomer: boolean;
            persons: components['schemas']['ApiIntegrationsContactPersonCamelCased'][];
            phoneNumber?: components['schemas']['XeroDomainModelsPhoneCamelCased'];
            fax?: components['schemas']['XeroDomainModelsPhoneCamelCased'];
            mobile?: components['schemas']['XeroDomainModelsPhoneCamelCased'];
            directDial?: components['schemas']['XeroDomainModelsPhoneCamelCased'];
            skypeName?: string | null;
            postalAddress?: components['schemas']['XeroDomainModelsAddressInfoCamelCased'];
            billingAddress?: components['schemas']['XeroDomainModelsAddressInfoCamelCased'];
            mailingAddress?: components['schemas']['IntegrationXeroDeliveryAddressInfoCamelCased'];
            deliveryAddress?: components['schemas']['IntegrationXeroDeliveryAddressInfoCamelCased'];
            bankAccountDetails?: string | null;
            defaultCurrency?: string | null;
            taxNumber?: string | null;
            companyNumber?: string | null;
            salesTax?: components['schemas']['IntegrationsXeroTaxAnswerCamelCased'];
            purchaseTax?: components['schemas']['IntegrationsXeroTaxAnswerCamelCased'];
            salesAccount?: components['schemas']['IntegrationsXeroAccountAnswerCamelCased'];
            purchaseAccount?: components['schemas']['IntegrationsXeroAccountAnswerCamelCased'];
            salesTrackingCategories: components['schemas']['IntegrationsXeroTrackingCategoryAnswerCamelCased'][];
            purchaseTrackingCategories: components['schemas']['IntegrationsXeroTrackingCategoryAnswerCamelCased'][];
            integrationEnabled: boolean;
            primaryPerson?: components['schemas']['ApiIntegrationsContactPersonCamelCased'];
            url?: string | null;
            editUrl?: string | null;
            isStatusPushPending: boolean;
        };
        IntegrationsXeroCreditNoteAnswer: {
            /** Format: uuid */
            CreditNoteId: string;
            CreditNoteType?: string | null;
            IntegrationEnabled: boolean;
            Contact?: components['schemas']['ApiIntegrationsContact'];
            Date?: string | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            LineItems?: components['schemas']['IntegrationsXeroLineItemWithCisDeductionAnswer'][] | null;
            /** Format: double */
            SubTotal?: number | null;
            InvoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswer'][] | null;
            CreditNoteNumber?: string | null;
            CreditNoteReference?: string | null;
            /** Format: double */
            RemainingCredit: number;
            Url?: string | null;
            EditUrl?: string | null;
            Status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            BrandingTheme?: string | null;
            /** Format: uuid */
            BrandingThemeId?: string | null;
            HasCisDeduction: boolean;
            /** Format: double */
            CisTaxAmount?: number | null;
            Allocations: components['schemas']['IntegrationsXeroAllocationAnswer'][];
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            IsStatusPushPending: boolean;
        };
        IntegrationsXeroCreditNoteAnswerCamelCased: {
            /** Format: uuid */
            creditNoteId: string;
            creditNoteType?: string | null;
            integrationEnabled: boolean;
            contact?: components['schemas']['ApiIntegrationsContactCamelCased'];
            date?: string | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            lineItems?: components['schemas']['IntegrationsXeroLineItemWithCisDeductionAnswerCamelCased'][] | null;
            /** Format: double */
            subTotal?: number | null;
            invoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswerCamelCased'][] | null;
            creditNoteNumber?: string | null;
            creditNoteReference?: string | null;
            /** Format: double */
            remainingCredit: number;
            url?: string | null;
            editUrl?: string | null;
            status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            brandingTheme?: string | null;
            /** Format: uuid */
            brandingThemeId?: string | null;
            hasCisDeduction: boolean;
            /** Format: double */
            cisTaxAmount?: number | null;
            allocations: components['schemas']['IntegrationsXeroAllocationAnswerCamelCased'][];
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
        };
        IntegrationsXeroInvoiceAnswer: {
            /** Format: uuid */
            InvoiceId: string;
            InvoiceType?: string | null;
            IntegrationEnabled: boolean;
            Contact?: components['schemas']['ApiIntegrationsContact'];
            Date?: string | null;
            DueDate?: string | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            LineItems?: components['schemas']['IntegrationsXeroLineItemWithCisDeductionAnswer'][] | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            AmountDue?: number | null;
            InvoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswer'][] | null;
            InvoiceNumber?: string | null;
            InvoiceReference?: string | null;
            Url?: string | null;
            EditUrl?: string | null;
            Status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            BrandingTheme?: string | null;
            /** Format: uuid */
            BrandingThemeId?: string | null;
            PaymentDetails?: components['schemas']['IntegrationsXeroPaymentDetailsAnswer'];
            HasCisDeduction: boolean;
            /** Format: double */
            CisTaxAmount?: number | null;
            EmailIsSentFromXero?: boolean | null;
            Allocations: components['schemas']['IntegrationsXeroAllocationAnswer'][];
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            IsStatusPushPending: boolean;
        };
        IntegrationsXeroInvoiceAnswerCamelCased: {
            /** Format: uuid */
            invoiceId: string;
            invoiceType?: string | null;
            integrationEnabled: boolean;
            contact?: components['schemas']['ApiIntegrationsContactCamelCased'];
            date?: string | null;
            dueDate?: string | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            lineItems?: components['schemas']['IntegrationsXeroLineItemWithCisDeductionAnswerCamelCased'][] | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            amountDue?: number | null;
            invoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswerCamelCased'][] | null;
            invoiceNumber?: string | null;
            invoiceReference?: string | null;
            url?: string | null;
            editUrl?: string | null;
            status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            brandingTheme?: string | null;
            /** Format: uuid */
            brandingThemeId?: string | null;
            paymentDetails?: components['schemas']['IntegrationsXeroPaymentDetailsAnswerCamelCased'];
            hasCisDeduction: boolean;
            /** Format: double */
            cisTaxAmount?: number | null;
            emailIsSentFromXero?: boolean | null;
            allocations: components['schemas']['IntegrationsXeroAllocationAnswerCamelCased'][];
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
        };
        IntegrationsXeroInvoiceTaxAnswer: {
            /** Format: double */
            TaxRatePercent: number;
            /** Format: double */
            TaxValue: number;
            TaxRateString?: string | null;
        };
        IntegrationsXeroInvoiceTaxAnswerCamelCased: {
            /** Format: double */
            taxRatePercent: number;
            /** Format: double */
            taxValue: number;
            taxRateString?: string | null;
        };
        IntegrationsXeroLineItemAnswer: {
            /** Format: uuid */
            LineItemId?: string | null;
            Item?: string | null;
            Description?: string | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Account?: string | null;
            TaxRateString?: string | null;
            TaxCode?: string | null;
            /** Format: uuid */
            AccountId?: string | null;
            ItemCode?: string | null;
            /** Format: uuid */
            ItemId?: string | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRateEffective?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Discount?: number | null;
            /** Format: double */
            DiscountAmount?: number | null;
            DiscountType?: components['schemas']['XeroDomainEntitiesDocumentsDiscountType'];
            Tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswer'][] | null;
            IsInventory?: boolean | null;
        };
        IntegrationsXeroLineItemAnswerCamelCased: {
            /** Format: uuid */
            lineItemId?: string | null;
            item?: string | null;
            description?: string | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            account?: string | null;
            taxRateString?: string | null;
            taxCode?: string | null;
            /** Format: uuid */
            accountId?: string | null;
            itemCode?: string | null;
            /** Format: uuid */
            itemId?: string | null;
            /** Format: double */
            taxRate?: number | null;
            /** Format: double */
            taxRateEffective?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            /** Format: double */
            discount?: number | null;
            /** Format: double */
            discountAmount?: number | null;
            discountType?: components['schemas']['XeroDomainEntitiesDocumentsDiscountType'];
            tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswerCamelCased'][] | null;
            isInventory?: boolean | null;
        };
        IntegrationsXeroLineItemWithCisDeductionAnswer: {
            /** Format: double */
            CisTaxAmount?: number | null;
            /** Format: double */
            CisRate?: number | null;
            /** Format: uuid */
            LineItemId?: string | null;
            Item?: string | null;
            Description?: string | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            /** Format: double */
            CatalogUnitPrice?: number | null;
            Account?: string | null;
            TaxRateString?: string | null;
            TaxCode?: string | null;
            /** Format: uuid */
            AccountId?: string | null;
            ItemCode?: string | null;
            /** Format: uuid */
            ItemId?: string | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRateEffective?: number | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            /** Format: double */
            Discount?: number | null;
            /** Format: double */
            DiscountAmount?: number | null;
            DiscountType?: components['schemas']['XeroDomainEntitiesDocumentsDiscountType'];
            Tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswer'][] | null;
            IsInventory?: boolean | null;
        };
        IntegrationsXeroLineItemWithCisDeductionAnswerCamelCased: {
            /** Format: double */
            cisTaxAmount?: number | null;
            /** Format: double */
            cisRate?: number | null;
            /** Format: uuid */
            lineItemId?: string | null;
            item?: string | null;
            description?: string | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            /** Format: double */
            catalogUnitPrice?: number | null;
            account?: string | null;
            taxRateString?: string | null;
            taxCode?: string | null;
            /** Format: uuid */
            accountId?: string | null;
            itemCode?: string | null;
            /** Format: uuid */
            itemId?: string | null;
            /** Format: double */
            taxRate?: number | null;
            /** Format: double */
            taxRateEffective?: number | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            /** Format: double */
            discount?: number | null;
            /** Format: double */
            discountAmount?: number | null;
            discountType?: components['schemas']['XeroDomainEntitiesDocumentsDiscountType'];
            tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswerCamelCased'][] | null;
            isInventory?: boolean | null;
        };
        IntegrationsXeroManualJournalAnswer: {
            /** Format: uuid */
            ManualJournalId: string;
            ManualJournalNumber?: string | null;
            IntegrationEnabled: boolean;
            /** Format: date-time */
            Date?: string | null;
            Narration?: string | null;
            ShowOnCashBasisReports: boolean;
            Status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            LineItems?: components['schemas']['IntegrationsXeroManualJournalLineItemAnswer'][] | null;
            InvoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswer'][] | null;
            Url?: string | null;
            EditUrl?: string | null;
            /** Format: date-time */
            CreatedDate?: string | null;
            /** Format: date-time */
            ModifiedDate?: string | null;
            /** Format: double */
            DebitSubTotal?: number | null;
            /** Format: double */
            DebitTotalTax?: number | null;
            /** Format: double */
            CreditSubTotal?: number | null;
            /** Format: double */
            CreditTotalTax?: number | null;
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            IsStatusPushPending: boolean;
        };
        IntegrationsXeroManualJournalAnswerCamelCased: {
            /** Format: uuid */
            manualJournalId: string;
            manualJournalNumber?: string | null;
            integrationEnabled: boolean;
            /** Format: date-time */
            date?: string | null;
            narration?: string | null;
            showOnCashBasisReports: boolean;
            status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            lineItems?: components['schemas']['IntegrationsXeroManualJournalLineItemAnswerCamelCased'][] | null;
            invoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswerCamelCased'][] | null;
            url?: string | null;
            editUrl?: string | null;
            /** Format: date-time */
            createdDate?: string | null;
            /** Format: date-time */
            modifiedDate?: string | null;
            /** Format: double */
            debitSubTotal?: number | null;
            /** Format: double */
            debitTotalTax?: number | null;
            /** Format: double */
            creditSubTotal?: number | null;
            /** Format: double */
            creditTotalTax?: number | null;
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
        };
        IntegrationsXeroManualJournalLineItemAnswer: {
            /** Format: uuid */
            LineItemId?: string | null;
            Description?: string | null;
            Account?: string | null;
            TaxRateString?: string | null;
            TaxCode?: string | null;
            /** Format: uuid */
            AccountId?: string | null;
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxRateEffective?: number | null;
            /** Format: double */
            Amount?: number | null;
            AmountSide?: components['schemas']['DomainEntitiesAmountSide'];
            /** Format: double */
            TaxAmount?: number | null;
            Tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswer'][] | null;
        };
        IntegrationsXeroManualJournalLineItemAnswerCamelCased: {
            /** Format: uuid */
            lineItemId?: string | null;
            description?: string | null;
            account?: string | null;
            taxRateString?: string | null;
            taxCode?: string | null;
            /** Format: uuid */
            accountId?: string | null;
            /** Format: double */
            taxRate?: number | null;
            /** Format: double */
            taxRateEffective?: number | null;
            /** Format: double */
            amount?: number | null;
            amountSide?: components['schemas']['DomainEntitiesAmountSide'];
            /** Format: double */
            taxAmount?: number | null;
            tracking?: components['schemas']['IntegrationsXeroTrackingCategoryAnswerCamelCased'][] | null;
        };
        IntegrationsXeroPaymentDetailsAnswer: {
            Date?: string | null;
            BankAccountId?: string | null;
            BankAccountName?: string | null;
            BankAccountNumber?: string | null;
            BankAccountCode?: string | null;
            BankAccountCurrencyCode?: string | null;
            /** Format: double */
            Amount: number;
        };
        IntegrationsXeroPaymentDetailsAnswerCamelCased: {
            date?: string | null;
            bankAccountId?: string | null;
            bankAccountName?: string | null;
            bankAccountNumber?: string | null;
            bankAccountCode?: string | null;
            bankAccountCurrencyCode?: string | null;
            /** Format: double */
            amount: number;
        };
        IntegrationsXeroPurchaseOrderAnswer: {
            /** Format: uuid */
            PurchaseOrderId: string;
            PurchaseOrderNumber?: string | null;
            PurchaseOrderReference?: string | null;
            IntegrationEnabled: boolean;
            Contact?: components['schemas']['ApiIntegrationsContact'];
            Date?: string | null;
            DeliveryDate?: string | null;
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            LineItems?: components['schemas']['IntegrationsXeroLineItemAnswer'][] | null;
            /** Format: double */
            SubTotal?: number | null;
            InvoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswer'][] | null;
            DeliveryAddress?: string | null;
            AttentionTo?: string | null;
            Phone?: string | null;
            DeliveryInstructions?: string | null;
            Url?: string | null;
            EditUrl?: string | null;
            BrandingTheme?: string | null;
            EmailToContactParams?: components['schemas']['IntegrationsEmailToContactParamsAnswer'];
            /** Format: uuid */
            BrandingThemeId?: string | null;
            IsBilled?: boolean | null;
            GrnStatus?: components['schemas']['DomainEntitiesGrnStatus'];
            Status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            MarkAsBilledSource?: components['schemas']['XeroDomainEntitiesRequestsMarkAsBilledSource'];
            IsStatusPushPending: boolean;
        };
        IntegrationsXeroPurchaseOrderAnswerCamelCased: {
            /** Format: uuid */
            purchaseOrderId: string;
            purchaseOrderNumber?: string | null;
            purchaseOrderReference?: string | null;
            integrationEnabled: boolean;
            contact?: components['schemas']['ApiIntegrationsContactCamelCased'];
            date?: string | null;
            deliveryDate?: string | null;
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            lineItems?: components['schemas']['IntegrationsXeroLineItemAnswerCamelCased'][] | null;
            /** Format: double */
            subTotal?: number | null;
            invoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswerCamelCased'][] | null;
            deliveryAddress?: string | null;
            attentionTo?: string | null;
            phone?: string | null;
            deliveryInstructions?: string | null;
            url?: string | null;
            editUrl?: string | null;
            brandingTheme?: string | null;
            emailToContactParams?: components['schemas']['IntegrationsEmailToContactParamsAnswerCamelCased'];
            /** Format: uuid */
            brandingThemeId?: string | null;
            isBilled?: boolean | null;
            grnStatus?: components['schemas']['DomainEntitiesGrnStatus'];
            status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            markAsBilledSource?: components['schemas']['XeroDomainEntitiesRequestsMarkAsBilledSource'];
            isStatusPushPending: boolean;
        };
        IntegrationsXeroQuoteAnswer: {
            /** Format: uuid */
            QuoteId: string;
            QuoteNumber?: string | null;
            IntegrationEnabled: boolean;
            Contact?: components['schemas']['ApiIntegrationsContact'];
            IsAccepted?: boolean | null;
            Date?: string | null;
            ExpiryDate?: string | null;
            Status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            LineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            LineItems?: components['schemas']['IntegrationsXeroLineItemAnswer'][] | null;
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            /** Format: double */
            TotalDiscount?: number | null;
            InvoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswer'][] | null;
            QuoteReference?: string | null;
            Url?: string | null;
            EditUrl?: string | null;
            BrandingTheme?: string | null;
            /** Format: uuid */
            BrandingThemeId?: string | null;
            Terms?: string | null;
            Title?: string | null;
            Summary?: string | null;
            DecisionMaker?: components['schemas']['IntegrationsXeroQuoteDecisionMakerAnswer'];
            LockDate?: string | null;
            CompanyLockDate?: string | null;
            TemplateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            IsStatusPushPending: boolean;
        };
        IntegrationsXeroQuoteAnswerCamelCased: {
            /** Format: uuid */
            quoteId: string;
            quoteNumber?: string | null;
            integrationEnabled: boolean;
            contact?: components['schemas']['ApiIntegrationsContactCamelCased'];
            isAccepted?: boolean | null;
            date?: string | null;
            expiryDate?: string | null;
            status?: components['schemas']['XeroDomainEntitiesXeroDocumentStatus'];
            lineAmountType?: components['schemas']['AccountingDomainEntitiesDocumentsLineAmountType'];
            lineItems?: components['schemas']['IntegrationsXeroLineItemAnswerCamelCased'][] | null;
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            /** Format: double */
            totalDiscount?: number | null;
            invoiceTaxes?: components['schemas']['IntegrationsXeroInvoiceTaxAnswerCamelCased'][] | null;
            quoteReference?: string | null;
            url?: string | null;
            editUrl?: string | null;
            brandingTheme?: string | null;
            /** Format: uuid */
            brandingThemeId?: string | null;
            terms?: string | null;
            title?: string | null;
            summary?: string | null;
            decisionMaker?: components['schemas']['IntegrationsXeroQuoteDecisionMakerAnswerCamelCased'];
            lockDate?: string | null;
            companyLockDate?: string | null;
            templateLockDatePolicy: components['schemas']['AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType'];
            isStatusPushPending: boolean;
        };
        IntegrationsXeroQuoteDecisionMakerAnswer: {
            FirstName?: string | null;
            LastName?: string | null;
            Company?: string | null;
            Title?: string | null;
            Comment?: string | null;
        };
        IntegrationsXeroQuoteDecisionMakerAnswerCamelCased: {
            firstName?: string | null;
            lastName?: string | null;
            company?: string | null;
            title?: string | null;
            comment?: string | null;
        };
        IntegrationsXeroTaxAnswer: {
            id: string;
            text: string;
        };
        IntegrationsXeroTaxAnswerCamelCased: {
            id: string;
            text: string;
        };
        IntegrationsXeroTrackingCategoryAnswer: {
            CategoryId?: string | null;
            CategoryName?: string | null;
            OptionId?: string | null;
            OptionName?: string | null;
            /** Format: int32 */
            OrderNumber: number;
        };
        IntegrationsXeroTrackingCategoryAnswerCamelCased: {
            categoryId?: string | null;
            categoryName?: string | null;
            optionId?: string | null;
            optionName?: string | null;
            /** Format: int32 */
            orderNumber: number;
        };
        ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsAnswer: {
            items: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsAnswer'][];
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsAnswerCamelCased: {
            items: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsAnswerCamelCased'][];
            result?: string | null;
            errorCode?: string | null;
            errorMsg?: string | null;
            errorDetails?: string | null;
            validationErrors?: string[] | null;
        };
        ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswer: {
            items: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswer'][];
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        ListAnswerV2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased: {
            items: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased'][];
            result?: string | null;
            errorCode?: string | null;
            errorMsg?: string | null;
            errorDetails?: string | null;
            validationErrors?: string[] | null;
        };
        MatchingNetSuiteBillMatchingInfo: Record<string, never>;
        MatchingNetSuiteGetRequestMatchingAnswer: {
            MatchingLinesInfos: components['schemas']['MatchingNetSuiteRequestMatchingAnswer'][];
        };
        MatchingNetSuiteGetRequestMatchingAnswerCamelCased: {
            matchingLinesInfos: components['schemas']['MatchingNetSuiteRequestMatchingAnswerCamelCased'][];
        };
        MatchingNetSuiteRequestMatchingAnswer: {
            /** Format: int32 */
            DocumentLineNumber: number;
            DocumentLineType: components['schemas']['NetSuiteDomainEntitiesMatchingPairsPairLineType'];
            /** Format: uuid */
            readonly RequestId: string;
            /** Format: date-time */
            readonly Date?: string | null;
            readonly FriendlyName?: string | null;
            /** Format: double */
            readonly TotalAmount?: number | null;
            Currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            Line?: components['schemas']['MatchingNetSuiteRequestMatchingLineAnswer'];
        };
        MatchingNetSuiteRequestMatchingAnswerCamelCased: {
            /** Format: int32 */
            documentLineNumber: number;
            documentLineType: components['schemas']['NetSuiteDomainEntitiesMatchingPairsPairLineTypeCamelCased'];
            /** Format: uuid */
            readonly requestId: string;
            /** Format: date-time */
            readonly date?: string | null;
            readonly friendlyName?: string | null;
            /** Format: double */
            readonly totalAmount?: number | null;
            currency?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            line?: components['schemas']['MatchingNetSuiteRequestMatchingLineAnswerCamelCased'];
        };
        MatchingNetSuiteRequestMatchingLineAnswer: {
            /** Format: int32 */
            readonly LineNumber?: number | null;
            /** Format: double */
            readonly Amount?: number | null;
            /** Format: double */
            readonly TaxAmount?: number | null;
            Class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            TaxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswer'];
            readonly IsBillable?: boolean | null;
        };
        MatchingNetSuiteRequestMatchingLineAnswerCamelCased: {
            /** Format: int32 */
            readonly lineNumber?: number | null;
            /** Format: double */
            readonly amount?: number | null;
            /** Format: double */
            readonly grossAmount?: number | null;
            /** Format: double */
            readonly taxAmount?: number | null;
            class?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            taxCode?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            department?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            location?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            customer?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            category?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            account?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            item?: components['schemas']['IntegrationsNetSuiteRecordRefAnswerCamelCased'];
            readonly isBillable?: boolean | null;
        };
        MatchingQBooksMatchingContext: {
            PurchaseOrders?: components['schemas']['MatchingQBooksMatchingPurchaseOrder'][] | null;
        };
        MatchingQBooksMatchingContextCamelCased: {
            purchaseOrders?: components['schemas']['MatchingQBooksMatchingPurchaseOrderCamelCased'][] | null;
        };
        MatchingQBooksMatchingPurchaseOrder: {
            /** Format: uuid */
            Id: string;
            Date?: string | null;
            FriendlyName: string;
            /** Format: double */
            TotalAmount: number;
            Currency: string;
            ItemBasedLines?: components['schemas']['IntegrationsQBooksPurchaseOrderItemBasedLineAnswer'][] | null;
            AccountBasedLines?: components['schemas']['IntegrationsQBooksPurchaseOrderAccountBasedLineAnswer'][] | null;
        };
        MatchingQBooksMatchingPurchaseOrderCamelCased: {
            /** Format: uuid */
            id: string;
            date?: string | null;
            friendlyName: string;
            /** Format: double */
            totalAmount: number;
            currency: string;
            itemBasedLines?:
                | components['schemas']['IntegrationsQBooksPurchaseOrderItemBasedLineAnswerCamelCased'][]
                | null;
            accountBasedLines?:
                | components['schemas']['IntegrationsQBooksPurchaseOrderAccountBasedLineAnswerCamelCased'][]
                | null;
        };
        MatchingXeroBillMatchingInfo: {
            documents: components['schemas']['MatchingXeroMatchedPurchaseOrder'][];
            /** Format: double */
            readonly totalAmount: number;
            /** Format: double */
            readonly totalAllocatedAmount: number;
            currency: components['schemas']['CurrencyIsoCode'];
        };
        MatchingXeroDocumentMatchingInfo: {
            /** Format: double */
            readonly totalAmount: number;
            /** Format: double */
            readonly totalAllocatedAmount: number;
            currency: components['schemas']['CurrencyIsoCode'];
        };
        MatchingXeroMatchedPurchaseOrder: {
            matchedBy: components['schemas']['UserAnswer'];
            isBilled: boolean;
            grnStatus: components['schemas']['DomainEntitiesGrnStatus'];
            /** Format: uuid */
            readonly requestId: string;
            readonly isMatched: boolean;
            /** Format: double */
            readonly allocatedAmount?: number | null;
            readonly friendlyName?: string | null;
            statusV2: components['schemas']['DomainEntitiesRequestsRequestStatusV2'];
            /** Format: double */
            readonly totalAmount: number;
            currency: components['schemas']['CurrencyIsoCode'];
            readonly date: string;
            requester?: components['schemas']['UserAnswer'];
            readonly reference?: string | null;
        };
        MentionedUserAnswer: {
            /** Format: uuid */
            UserProfileId: string;
            Email: string;
        };
        MentionedUserAnswerCamelCased: {
            /** Format: uuid */
            userProfileId: string;
            email: string;
        };
        MicrosoftAspNetCoreMvcProblemDetails: {
            Type?: string | null;
            Title?: string | null;
            /** Format: int32 */
            Status?: number | null;
            Detail?: string | null;
            Instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        MicrosoftAspNetCoreMvcProblemDetailsCamelCased: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        NamedObjectAnswerGuid: {
            /** Format: uuid */
            Id: string;
            Name: string;
        };
        /**
         * Format: string
         * @description <ul><li><i>Employee</i> - employee</li><li><i>Vendor</i> - vendor</li></ul>
         * @enum {string}
         */
        NetSuiteApiClientModelsCommonPayeeType: NetSuiteApiClientModelsCommonPayeeType;
        /**
         * Format: string
         * @description <ul><li><i>Company</i> - company</li><li><i>Individual</i> - individual</li><li><i>Unknown</i> - unknown</li></ul>
         */
        NetSuiteApiClientModelsVendorsVendorType: string;
        NetSuiteDomainEntitiesApprovalEntitiesNetSuiteAddress: {
            InternalId?: string | null;
            FullAddress: string;
            IsDefaultShipping?: boolean | null;
            IsDefaultBilling?: boolean | null;
        };
        NetSuiteDomainEntitiesApprovalEntitiesNetSuiteAddressCamelCased: {
            internalId?: string | null;
            fullAddress: string;
            isDefaultShipping?: boolean | null;
            isDefaultBilling?: boolean | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>Expense-lines</i></li><li><i>Item-lines</i></li></ul>
         */
        NetSuiteDomainEntitiesMatchingPairsPairLineType: string;
        /**
         * Format: string
         * @description <ul><li><i>Expense-lines</i></li><li><i>Item-lines</i></li></ul>
         */
        NetSuiteDomainEntitiesMatchingPairsPairLineTypeCamelCased: string;
        NetSuiteDomainEntitiesRecordRef: {
            Id?: string | null;
            Name?: string | null;
        };
        NetSuiteDomainEntitiesRecordRefCamelCased: {
            id?: string | null;
            name?: string | null;
        };
        NetSuiteDomainEntitiesUnitPrice: {
            /** Format: double */
            readonly Value: number;
            readonly IsAbsolute: boolean;
        };
        NetSuiteRefDataClientContractsModelsCurrenciesCurrency: {
            InternalId: string;
            Symbol: string;
            Name: string;
            IsBaseCurrency: boolean;
            CurrencyPrecision: components['schemas']['NetSuiteRefDataClientContractsModelsCurrenciesCurrencyPrecision'];
        };
        NetSuiteRefDataClientContractsModelsCurrenciesCurrencyCamelCased: {
            internalId: string;
            symbol: string;
            name: string;
            isBaseCurrency: boolean;
            currencyPrecision: components['schemas']['NetSuiteRefDataClientContractsModelsCurrenciesCurrencyPrecision'];
        };
        /**
         * Format: string
         * @description <ul><li><i>Two</i> - _two</li><li><i>Zero</i> - _zero</li></ul>
         * @enum {string}
         */
        NetSuiteRefDataClientContractsModelsCurrenciesCurrencyPrecision: NetSuiteRefDataClientContractsModelsCurrenciesCurrencyPrecision;
        /**
         * Format: string
         * @description <ul><li><i>ExpenseList</i></li><li><i>ItemList</i></li><li><i>LineList</i></li></ul>
         * @enum {string}
         */
        NetSuiteRefDataClientContractsModelsDocumentSublistType: NetSuiteRefDataClientContractsModelsDocumentSublistType;
        /**
         * Format: string
         * @description <ul><li><i>BillPayment</i></li><li><i>ExpenseReport</i></li><li><i>JournalEntry</i></li><li><i>PurchaseOrder</i></li><li><i>ReturnAuthorization</i></li><li><i>SalesInvoice</i></li><li><i>SalesOrder</i></li><li><i>Vendor</i></li><li><i>VendorBill</i></li><li><i>VendorReturnAuthorization</i></li></ul>
         * @enum {string}
         */
        NetSuiteRefDataClientContractsModelsDocumentType: NetSuiteRefDataClientContractsModelsDocumentType;
        /**
         * Format: string
         * @description <ul><li><i>Assembly</i></li><li><i>Description</i></li><li><i>Discount</i></li><li><i>DownloadItem</i></li><li><i>EndOfGroup</i></li><li><i>GiftCertificateItem</i></li><li><i>InventoryItem</i></li><li><i>ItemGroup</i></li><li><i>Kit</i></li><li><i>Markup</i></li><li><i>NonInventoryItem</i></li><li><i>OtherCharge</i></li><li><i>Payment</i></li><li><i>Service</i></li><li><i>Subtotal</i></li></ul>
         * @enum {string}
         */
        NetSuiteRefDataClientContractsModelsItemsItemType: NetSuiteRefDataClientContractsModelsItemsItemType;
        NetSuiteRefDataClientContractsModelsItemsPrice: {
            /** Format: double */
            Value: number;
            /** Format: double */
            Quantity: number;
        };
        NetSuiteRefDataClientContractsModelsItemsPriceCamelCased: {
            /** Format: double */
            value: number;
            /** Format: double */
            quantity: number;
        };
        NetSuiteRefDataClientContractsModelsItemsPriceLevel: {
            InternalId: string;
            Name: string;
            /** Format: double */
            DiscountPercentage?: number | null;
        };
        NetSuiteRefDataClientContractsModelsItemsPriceLevelCamelCased: {
            internalId: string;
            name: string;
            /** Format: double */
            discountPercentage?: number | null;
        };
        NetSuiteRefDataClientContractsModelsItemsPricing: {
            Currency?: components['schemas']['NetSuiteRefDataClientContractsModelsCurrenciesCurrency'];
            PriceLevel?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPriceLevel'];
            Price?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPrice'];
            CurrencyId?: string | null;
            PriceLevelId?: string | null;
            /** Format: double */
            MinQuantity?: number | null;
            /** Format: double */
            MaxQuantity?: number | null;
            /** Format: double */
            Value?: number | null;
        };
        NetSuiteRefDataClientContractsModelsItemsPricingCamelCased: {
            currency?: components['schemas']['NetSuiteRefDataClientContractsModelsCurrenciesCurrencyCamelCased'];
            priceLevel?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPriceLevelCamelCased'];
            price?: components['schemas']['NetSuiteRefDataClientContractsModelsItemsPriceCamelCased'];
            currencyId?: string | null;
            priceLevelId?: string | null;
            /** Format: double */
            minQuantity?: number | null;
            /** Format: double */
            maxQuantity?: number | null;
            /** Format: double */
            value?: number | null;
        };
        OcrContractsModelsCustomerInfo: {
            Name?: string | null;
            TaxNumber?: string | null;
            BankAccountDetails?: string | null;
            Address?: components['schemas']['OcrContractsModelsXeroAddressInfo'];
        };
        OcrContractsModelsCustomerInfoCamelCased: {
            name?: string | null;
            taxNumber?: string | null;
            bankAccountDetails?: string | null;
            address?: components['schemas']['OcrContractsModelsXeroAddressInfoCamelCased'];
        };
        OcrContractsModelsNetSuiteRecognizedBillAnswer: {
            Reference?: string | null;
            VendorIds?: string[] | null;
            /** Format: date-time */
            TransactionDate?: string | null;
            /** Format: date-time */
            DueDate?: string | null;
            CurrencyId?: string | null;
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            LineItems?: components['schemas']['OcrContractsModelsNetSuiteRecognizedLineItemAnswer'][] | null;
            Vendor?: components['schemas']['OcrContractsModelsVendorInfo'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsNetSuiteRecognizedBillAnswerCamelCased: {
            reference?: string | null;
            vendorIds?: string[] | null;
            /** Format: date-time */
            transactionDate?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            currencyId?: string | null;
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            lineItems?: components['schemas']['OcrContractsModelsNetSuiteRecognizedLineItemAnswerCamelCased'][] | null;
            vendor?: components['schemas']['OcrContractsModelsVendorInfoCamelCased'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsNetSuiteRecognizedLineItemAnswer: {
            /** Format: int32 */
            LineOrder: number;
            Memo?: string | null;
            /** Format: double */
            Amount?: number | null;
            /** Format: double */
            TaxRate?: number | null;
            TaxCodeIds?: string[] | null;
            CategoryIds?: string[] | null;
            AccountIds?: string[] | null;
        };
        OcrContractsModelsNetSuiteRecognizedLineItemAnswerCamelCased: {
            /** Format: int32 */
            lineOrder: number;
            memo?: string | null;
            /** Format: double */
            amount?: number | null;
            /** Format: double */
            taxRate?: number | null;
            taxCodeIds?: string[] | null;
            categoryIds?: string[] | null;
            accountIds?: string[] | null;
        };
        OcrContractsModelsQBooksRecognizedBillAnswer: {
            Number?: string | null;
            /** Format: date-time */
            Date?: string | null;
            /** Format: date-time */
            DueDate?: string | null;
            CurrencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            VendorIds?: string[] | null;
            TermId?: string | null;
            LineItems?: components['schemas']['OcrContractsModelsQBooksRecognizedLineItemAnswer'][] | null;
            Vendor?: components['schemas']['OcrContractsModelsVendorInfo'];
            DepartmentIds?: string[] | null;
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsQBooksRecognizedBillAnswerCamelCased: {
            number?: string | null;
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            currencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            vendorIds?: string[] | null;
            termId?: string | null;
            lineItems?: components['schemas']['OcrContractsModelsQBooksRecognizedLineItemAnswerCamelCased'][] | null;
            vendor?: components['schemas']['OcrContractsModelsVendorInfoCamelCased'];
            departmentIds?: string[] | null;
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsQBooksRecognizedLineItemAnswer: {
            /** Format: int32 */
            LineOrder: number;
            Description?: string | null;
            /** Format: double */
            Amount?: number | null;
            AccountIds?: string[] | null;
            ClassIds?: string[] | null;
            TaxCodeIds?: string[] | null;
            CustomerIds?: string[] | null;
        };
        OcrContractsModelsQBooksRecognizedLineItemAnswerCamelCased: {
            /** Format: int32 */
            lineOrder: number;
            description?: string | null;
            /** Format: double */
            amount?: number | null;
            accountIds?: string[] | null;
            classIds?: string[] | null;
            taxCodeIds?: string[] | null;
            customerIds?: string[] | null;
        };
        OcrContractsModelsRecognizedDocumentAnswer: Record<string, never>;
        OcrContractsModelsRecognizedDocumentAnswerCamelCased: Record<string, never>;
        OcrContractsModelsVendorInfo: {
            Name?: string | null;
            TaxNumber?: string | null;
            BankAccountDetails?: string | null;
            Address?: components['schemas']['OcrContractsModelsXeroAddressInfo'];
        };
        OcrContractsModelsVendorInfoCamelCased: {
            name?: string | null;
            taxNumber?: string | null;
            bankAccountDetails?: string | null;
            address?: components['schemas']['OcrContractsModelsXeroAddressInfoCamelCased'];
        };
        OcrContractsModelsXeroAddressInfo: {
            Street?: string | null;
            City?: string | null;
            Region?: string | null;
            PostalCode?: string | null;
            Country?: string | null;
        };
        OcrContractsModelsXeroAddressInfoCamelCased: {
            street?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
        };
        OcrContractsModelsXeroAmountFieldAnswer: {
            /** Format: double */
            SourceValue?: number | null;
            /** Format: double */
            CalculatedValue?: number | null;
        };
        OcrContractsModelsXeroAmountFieldAnswerCamelCased: {
            /** Format: double */
            sourceValue?: number | null;
            /** Format: double */
            calculatedValue?: number | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>NoTax</i> - No Tax</li><li><i>TaxExclusive</i> - Tax Exclusive</li><li><i>TaxInclusive</i> - Tax Inclusive</li></ul>
         * @enum {string}
         */
        OcrContractsModelsXeroLineAmountTypeAnswer: OcrContractsModelsXeroLineAmountTypeAnswer;
        OcrContractsModelsXeroPaymentTermAnswer: {
            Type: components['schemas']['OcrContractsModelsXeroPaymentTermTypeAnswer'];
            /** Format: int32 */
            Days: number;
        };
        OcrContractsModelsXeroPaymentTermAnswerCamelCased: {
            type: components['schemas']['OcrContractsModelsXeroPaymentTermTypeAnswer'];
            /** Format: int32 */
            days: number;
        };
        /**
         * Format: string
         * @description <ul><li><i>AfterBillDate</i></li><li><i>CurrentMonth</i></li><li><i>DaysAfterBillMonth</i></li><li><i>FollowingMonth</i></li></ul>
         * @enum {string}
         */
        OcrContractsModelsXeroPaymentTermTypeAnswer: OcrContractsModelsXeroPaymentTermTypeAnswer;
        OcrContractsModelsXeroRecognizedBillAnswer: {
            Number?: string | null;
            /** Format: date-time */
            Date?: string | null;
            /** Format: date-time */
            DueDate?: string | null;
            CurrencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            LineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            LineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswer'][] | null;
            SupplierIds?: string[] | null;
            Supplier?: components['schemas']['OcrContractsModelsVendorInfo'];
            PaymentTerm?: components['schemas']['OcrContractsModelsXeroPaymentTermAnswer'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsXeroRecognizedBillAnswerCamelCased: {
            number?: string | null;
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            currencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            lineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            lineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswerCamelCased'][] | null;
            supplierIds?: string[] | null;
            supplier?: components['schemas']['OcrContractsModelsVendorInfoCamelCased'];
            paymentTerm?: components['schemas']['OcrContractsModelsXeroPaymentTermAnswerCamelCased'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsXeroRecognizedLineItemAnswer: {
            /** Format: int32 */
            LineOrder: number;
            Description?: string | null;
            /** Format: double */
            Qty?: number | null;
            /** Format: double */
            UnitPrice?: number | null;
            Amount?: components['schemas']['OcrContractsModelsXeroAmountFieldAnswer'];
            /** Format: double */
            TaxRate?: number | null;
            /** Format: double */
            TaxAmount?: number | null;
            AccountIds?: string[] | null;
            TaxTypes?: string[] | null;
            TrackingCategoryOptions: components['schemas']['OcrContractsModelsXeroTrackingCategoryOptionAnswer'][];
        };
        OcrContractsModelsXeroRecognizedLineItemAnswerCamelCased: {
            /** Format: int32 */
            lineOrder: number;
            description?: string | null;
            /** Format: double */
            qty?: number | null;
            /** Format: double */
            unitPrice?: number | null;
            amount?: components['schemas']['OcrContractsModelsXeroAmountFieldAnswerCamelCased'];
            /** Format: double */
            taxRate?: number | null;
            /** Format: double */
            taxAmount?: number | null;
            accountIds?: string[] | null;
            taxTypes?: string[] | null;
            trackingCategoryOptions: components['schemas']['OcrContractsModelsXeroTrackingCategoryOptionAnswerCamelCased'][];
        };
        OcrContractsModelsXeroRecognizedPayableCreditNoteAnswer: {
            Number?: string | null;
            /** Format: date-time */
            Date?: string | null;
            CurrencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            LineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            LineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswer'][] | null;
            SupplierIds?: string[] | null;
            Supplier?: components['schemas']['OcrContractsModelsVendorInfo'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsXeroRecognizedPayableCreditNoteAnswerCamelCased: {
            number?: string | null;
            /** Format: date-time */
            date?: string | null;
            currencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            lineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            lineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswerCamelCased'][] | null;
            supplierIds?: string[] | null;
            supplier?: components['schemas']['OcrContractsModelsVendorInfoCamelCased'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsXeroRecognizedPurchaseOrderAnswer: {
            Number?: string | null;
            /** Format: date-time */
            Date?: string | null;
            /** Format: date-time */
            DeliveryDate?: string | null;
            CurrencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            LineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            LineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswer'][] | null;
            ContactIds?: string[] | null;
            Contact?: components['schemas']['OcrContractsModelsVendorInfo'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsXeroRecognizedPurchaseOrderAnswerCamelCased: {
            number?: string | null;
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            deliveryDate?: string | null;
            currencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            lineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            lineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswerCamelCased'][] | null;
            contactIds?: string[] | null;
            contact?: components['schemas']['OcrContractsModelsVendorInfoCamelCased'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsXeroRecognizedSalesInvoiceAnswer: {
            Number?: string | null;
            /** Format: date-time */
            Date?: string | null;
            /** Format: date-time */
            DueDate?: string | null;
            CurrencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            Total?: number | null;
            /** Format: double */
            SubTotal?: number | null;
            /** Format: double */
            TotalTax?: number | null;
            LineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            LineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswer'][] | null;
            CustomerIds?: string[] | null;
            PaymentTerm?: components['schemas']['OcrContractsModelsXeroPaymentTermAnswer'];
            Customer?: components['schemas']['OcrContractsModelsCustomerInfo'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswer'];
        OcrContractsModelsXeroRecognizedSalesInvoiceAnswerCamelCased: {
            number?: string | null;
            /** Format: date-time */
            date?: string | null;
            /** Format: date-time */
            dueDate?: string | null;
            currencyCode?: components['schemas']['CurrencyIsoCode'];
            /** Format: double */
            total?: number | null;
            /** Format: double */
            subTotal?: number | null;
            /** Format: double */
            totalTax?: number | null;
            lineAmountType?: components['schemas']['OcrContractsModelsXeroLineAmountTypeAnswer'];
            lineItems?: components['schemas']['OcrContractsModelsXeroRecognizedLineItemAnswerCamelCased'][] | null;
            customerIds?: string[] | null;
            paymentTerm?: components['schemas']['OcrContractsModelsXeroPaymentTermAnswerCamelCased'];
            customer?: components['schemas']['OcrContractsModelsCustomerInfoCamelCased'];
        } & components['schemas']['OcrContractsModelsRecognizedDocumentAnswerCamelCased'];
        OcrContractsModelsXeroTrackingCategoryOptionAnswer: {
            /** Format: uuid */
            CategoryId: string;
            OptionIds: string[];
        };
        OcrContractsModelsXeroTrackingCategoryOptionAnswerCamelCased: {
            /** Format: uuid */
            categoryId: string;
            optionIds: string[];
        };
        /**
         * Format: string
         * @description <ul><li><i>NetSuite vendor bill</i> - NetSuite-vendor-bill</li><li><i>QBooks bill</i> - QBooks-bill</li><li><i>Xero AP credit note</i> - Xero-creditnotes-payable</li><li><i>Xero bill</i> - Xero-bill</li><li><i>Xero purchase order</i> - Xero-PO</li><li><i>Xero sales invoice</i> - Xero-invoice</li></ul>
         * @enum {string}
         */
        OcrContractsOcrDocumentTypes: OcrContractsOcrDocumentTypes;
        /**
         * Format: string
         * @description <ul><li><i>File with document per page</i> - MultiDocumentFile</li><li><i>File with one document</i> - DocumentPerFile</li></ul>
         */
        OcrContractsOcrFileContentType: string;
        /**
         * Format: string
         * @description <ul><li><i>File with document per page</i> - MultiDocumentFile</li><li><i>File with one document</i> - DocumentPerFile</li></ul>
         */
        OcrContractsOcrFileContentTypeCamelCased: string;
        OptionallyNamedObjectGuid: {
            /** Format: uuid */
            Id: string;
            Name?: string | null;
        };
        OptionallyNamedObjectGuidCamelCased: {
            /** Format: uuid */
            id: string;
            name?: string | null;
        };
        PagedAnswerApiIntegrationsXeroPaymentDetailsCounterparty: {
            hasMore: boolean;
            items: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterparty'][];
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        PagedAnswerApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased: {
            hasMore: boolean;
            items: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyCamelCased'][];
            result?: string | null;
            errorCode?: string | null;
            errorMsg?: string | null;
            errorDetails?: string | null;
            validationErrors?: string[] | null;
        };
        ProfileCompanyDelegationsAnswer: {
            /** Format: uuid */
            CompanyId: string;
            Delegates: components['schemas']['ProfileDelegationAnswer'][];
        };
        ProfileCompanyDelegationsAnswerCamelCased: {
            /** Format: uuid */
            companyId: string;
            delegates: components['schemas']['ProfileDelegationAnswerCamelCased'][];
        };
        ProfileCompanyDelegationsTransfer: {
            /** Format: uuid */
            CompanyId: string;
            Delegates: components['schemas']['ProfileDelegationTransfer'][];
        };
        ProfileCompanyDelegationsTransferCamelCased: {
            /** Format: uuid */
            companyId: string;
            delegates: components['schemas']['ProfileDelegationTransferCamelCased'][];
        };
        ProfileDelegationAnswer: {
            FromUser: components['schemas']['ProfileUserProfileAnswer'];
            ToUser?: components['schemas']['ProfileUserProfileAnswer'];
            /** Format: date-time */
            DateFrom?: string | null;
            /** Format: date-time */
            DateTo?: string | null;
        };
        ProfileDelegationAnswerCamelCased: {
            fromUser: components['schemas']['ProfileUserProfileAnswerCamelCased'];
            toUser?: components['schemas']['ProfileUserProfileAnswerCamelCased'];
            /** Format: date-time */
            dateFrom?: string | null;
            /** Format: date-time */
            dateTo?: string | null;
        };
        ProfileDelegationTransfer: {
            FromUser: components['schemas']['ProfileUserProfileTransfer'];
            ToUser?: components['schemas']['ProfileUserProfileTransfer'];
            /** Format: date-time */
            DateFrom?: string | null;
            /** Format: date-time */
            DateTo?: string | null;
        };
        ProfileDelegationTransferCamelCased: {
            fromUser: components['schemas']['ProfileUserProfileTransferCamelCased'];
            toUser?: components['schemas']['ProfileUserProfileTransferCamelCased'];
            /** Format: date-time */
            dateFrom?: string | null;
            /** Format: date-time */
            dateTo?: string | null;
        };
        ProfileUserProfileAnswer: {
            /** Format: uuid */
            readonly UserId: string;
            readonly Email: string;
            readonly UserName: string;
            readonly AvatarUrl: string;
        };
        ProfileUserProfileAnswerCamelCased: {
            /** Format: uuid */
            readonly userId: string;
            readonly email: string;
            readonly userName: string;
            readonly avatarUrl: string;
        };
        ProfileUserProfileTransfer: {
            /** Format: uuid */
            UserId: string;
        };
        ProfileUserProfileTransferCamelCased: {
            /** Format: uuid */
            userId: string;
        };
        QBooksDomainEntitiesApprovalEntitiesPaymentDetails: {
            StatementText: string;
            BankAccountName: string;
            BankAccountNumber: string;
            BankBranchIdentifier: string;
        };
        /**
         * Format: string
         * @description <ul><li><i>None</i></li><li><i>Purchases</i></li><li><i>Sales</i></li></ul>
         * @enum {string}
         */
        QBooksDomainEntitiesDocumentsJournalEntriesTaxApplicableOnType: QBooksDomainEntitiesDocumentsJournalEntriesTaxApplicableOnType;
        /**
         * Format: string
         * @description <ul><li><i>Customer</i></li><li><i>Employee</i></li><li><i>Not Set</i> - Undefined</li><li><i>Vendor</i></li></ul>
         * @enum {string}
         */
        QBooksDomainEntitiesDocumentsPayeeType: QBooksDomainEntitiesDocumentsPayeeType;
        /**
         * Format: string
         * @description <ul><li><i>None</i> - 0</li><li><i>Open</i> - 1</li><li><i>Closed</i> - 2</li></ul>
         * @enum {string}
         */
        QBooksDomainEntitiesDocumentsQBooksDocumentStatus: QBooksDomainEntitiesDocumentsQBooksDocumentStatus;
        QBooksDomainModelsAddress: {
            Street?: string | null;
            City?: string | null;
            Region?: string | null;
            PostCode?: string | null;
            Country?: string | null;
        };
        RequestAnswer: {
            /** Format: int32 */
            Version: number;
            /** Format: uuid */
            RequestId: string;
            /** Format: uuid */
            TemplateId: string;
            /** Format: uuid */
            WorkflowVersionId: string;
            TemplateName?: string | null;
            TemplateVersionIsActual: boolean;
            /** Format: uuid */
            CompanyId: string;
            CompanyName?: string | null;
            RequestUrl?: string | null;
            Author?: components['schemas']['UserAnswer'];
            AuthorRules?: components['schemas']['RuleAnswer'][] | null;
            Origin: components['schemas']['DomainEntitiesRequestsRequestOrigin'];
            Payer?: components['schemas']['UserAnswer'];
            FriendlyName?: string | null;
            IntegrationFriendlyName?: string | null;
            RequestNote?: string | null;
            IntegrationCode?: string | null;
            CreatedDate?: string | null;
            ModifiedDate?: string | null;
            DeadlineDate?: string | null;
            StatusV2: components['schemas']['DomainEntitiesRequestsRequestStatusV2'];
            ResolutionOrigin: components['schemas']['DomainEntitiesRequestsRequestResolutionOrigin'];
            ResolutionDate?: string | null;
            ResolutionEnforcedBy?: components['schemas']['UserAnswer'];
            FraudulentActivity?: components['schemas']['DomainEntitiesRequestsRequestFraudulentActivity'][] | null;
            ReadByMe: boolean;
            ReviewStep?: components['schemas']['RequestsRequestReviewStepAnswer'];
            Attachments?: components['schemas']['AttachmentAnswer'][] | null;
            Steps?: components['schemas']['RequestStepAnswer'][] | null;
            Watchers?: components['schemas']['RequestsRequestWatcherAnswer'][] | null;
            History?: components['schemas']['RequestHistoryEventAnswer'][] | null;
            /** Format: double */
            Amount: number;
            /** @deprecated */
            IsManualExchangeRate: boolean;
            Currency?: string | null;
            CompanyCurrency?: string | null;
            AuditReportUrl?: string | null;
            StandaloneDetails?: components['schemas']['RequestsStandaloneDetailsAnswer'];
            XeroInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswer'];
            XeroPurchaseOrderDetails?: components['schemas']['IntegrationsXeroPurchaseOrderAnswer'];
            XeroSalesInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswer'];
            XeroCreditNoteDetails?: components['schemas']['IntegrationsXeroCreditNoteAnswer'];
            XeroContactDetails?: components['schemas']['IntegrationsXeroContactAnswer'];
            XeroBillBatchPaymentDetails?: components['schemas']['IntegrationsXeroBillBatchPaymentAnswer'];
            AirwallexXeroBatchPaymentDetails?: components['schemas']['IntegrationsAirwallexXeroAirwallexBatchPaymentAnswer'];
            AmaxPayXeroBatchPaymentDetails?: components['schemas']['ApiAmaxPayXeroAmaxPayXeroBatchPayment'];
            XeroQuoteDetails?: components['schemas']['IntegrationsXeroQuoteAnswer'];
            XeroManualJournalDetails?: components['schemas']['IntegrationsXeroManualJournalAnswer'];
            QBooksPurchaseOrderDetails?: components['schemas']['IntegrationsQBooksPurchaseOrderAnswer'];
            QBooksBillInvoiceDetails?: components['schemas']['IntegrationsQBooksBillInvoiceAnswer'];
            QBooksExpenseDetails?: components['schemas']['IntegrationsQBooksExpenseAnswer'];
            QBooksVendorDetails?: components['schemas']['IntegrationsQBooksVendorAnswer'];
            QBooksJournalEntryDetails?: components['schemas']['IntegrationsQBooksJournalEntryAnswer'];
            QBooksSalesInvoiceDetails?: components['schemas']['IntegrationsQBooksSalesInvoiceAnswer'];
            NetSuiteVendorBillDetails?: components['schemas']['IntegrationsNetSuiteVendorBillAnswer'];
            NetSuiteVendorReturnAuthorizationDetails?: components['schemas']['IntegrationsNetSuiteVendorReturnAuthorizationAnswer'];
            NetSuitePurchaseOrderDetails?: components['schemas']['IntegrationsNetSuitePurchaseOrderAnswer'];
            NetSuiteSalesOrderDetails?: components['schemas']['IntegrationsNetSuiteSalesOrderAnswer'];
            NetSuiteInvoiceDetails?: components['schemas']['IntegrationsNetSuiteInvoiceAnswer'];
            NetSuiteExpenseReportDetails?: components['schemas']['IntegrationsNetSuiteExpenseReportAnswer'];
            NetSuiteBillPaymentDetails?: components['schemas']['IntegrationsNetSuiteBillPaymentAnswer'];
            NetSuiteVendorDetails?: components['schemas']['IntegrationsNetSuiteVendorAnswer'];
            NetSuiteReturnAuthorizationDetails?: components['schemas']['IntegrationsNetSuiteReturnAuthorizationAnswer'];
            NetSuiteJournalEntryDetails?: components['schemas']['IntegrationsNetSuiteJournalEntryAnswer'];
            DearPurchaseOrderDetails?: components['schemas']['IntegrationsDearPurchaseOrderAnswer'];
            RequiredFieldIds?: string[] | null;
            RequiredFields?: components['schemas']['FieldAnswer'][] | null;
            IMustEdit?: boolean | null;
            IMustEditForEditOnApproval?: boolean | null;
            /** @deprecated */
            NotFilledEditPermissionsRequiredFields?: components['schemas']['FieldAnswer'][] | null;
            EditPermissionsRequiredFieldsThatShouldBeFilled?: components['schemas']['FieldAnswer'][] | null;
            /** Format: double */
            ExchangeRate?: number | null;
            ExchangeRateSource?: components['schemas']['DomainEntitiesExchangeRateSource'];
            ExchangeRateDate?: string | null;
            IsAutoApprovedByRule: boolean;
            IsDeleted: boolean;
            XeroMatchingV2Info?: components['schemas']['MatchingXeroDocumentMatchingInfo'];
            EmailToContact?: components['schemas']['IntegrationsEmailToContactAnswer'];
            PaymentStep?: components['schemas']['RequestsRequestPaymentStepAnswer'];
            /** Format: date-time */
            LastNudgedAt?: string | null;
            /** Format: date-time */
            SubmittedAt?: string | null;
        };
        RequestChangeData: {
            StepsChanges: components['schemas']['StepChangeData'][];
            ReviewStepsChanges?: components['schemas']['HistoryReviewStepChangeData'];
        };
        RequestCommentAnswer: {
            /** Format: uuid */
            CommentId: string;
            Text?: string | null;
            CreatedDate?: string | null;
            Author?: components['schemas']['UserAnswer'];
            CommentAttachments?: components['schemas']['AttachmentAnswer'][] | null;
            MentionedUsers?: components['schemas']['MentionedUserAnswer'][] | null;
        };
        RequestCommentAnswerCamelCased: {
            /** Format: uuid */
            commentId: string;
            text?: string | null;
            createdDate?: string | null;
            author?: components['schemas']['UserAnswerCamelCased'];
            commentAttachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
            mentionedUsers?: components['schemas']['MentionedUserAnswerCamelCased'][] | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>ApproverEdited</i></li><li><i>EditorEdited</i></li><li><i>PostApprovalChangesDetected</i></li><li><i>RequesterResubmitted</i></li><li><i>RequesterSubmitted</i></li><li><i>ReviewerEdited</i></li><li><i>StartOverByExternalUpdate</i></li><li><i>SubmittedViaExternalSystem</i></li></ul>
         * @enum {string}
         */
        RequestDetailsVersioningDomainVersionType: RequestDetailsVersioningDomainVersionType;
        RequestDetailsVersionsRequestVersionAnswer: {
            Snapshot: components['schemas']['V2RequestsRequestAnswer'];
            /** Format: uuid */
            readonly RequestId: string;
            /** Format: uuid */
            readonly CompanyId: string;
            /** Format: int32 */
            readonly Version: number;
            VersionType: components['schemas']['RequestDetailsVersioningDomainVersionType'];
            /** Format: date-time */
            readonly SubmittedAt: string;
            /** Format: date-time */
            readonly CreatedAt: string;
            Actor?: components['schemas']['UserAnswer'];
            Comment?: components['schemas']['RequestCommentAnswer'];
            UserPlatform?: components['schemas']['DomainUserPlatform'];
        };
        RequestDetailsVersionsRequestVersionAnswerCamelCased: {
            snapshot: components['schemas']['V2RequestsRequestAnswerCamelCased'];
            /** Format: uuid */
            readonly requestId: string;
            /** Format: uuid */
            readonly companyId: string;
            /** Format: int32 */
            readonly version: number;
            versionType: components['schemas']['RequestDetailsVersioningDomainVersionType'];
            /** Format: date-time */
            readonly submittedAt: string;
            /** Format: date-time */
            readonly createdAt: string;
            actor?: components['schemas']['UserAnswerCamelCased'];
            comment?: components['schemas']['RequestCommentAnswerCamelCased'];
            userPlatform?: components['schemas']['DomainUserPlatform'];
        };
        RequestDetailsVersionsRequestVersionItemAnswer: {
            /** Format: uuid */
            readonly RequestId: string;
            /** Format: uuid */
            readonly CompanyId: string;
            /** Format: int32 */
            readonly Version: number;
            VersionType: components['schemas']['RequestDetailsVersioningDomainVersionType'];
            /** Format: date-time */
            readonly SubmittedAt: string;
            /** Format: date-time */
            readonly CreatedAt: string;
            Actor?: components['schemas']['UserAnswer'];
            Comment?: components['schemas']['RequestCommentAnswer'];
            UserPlatform?: components['schemas']['DomainUserPlatform'];
        };
        RequestDetailsVersionsRequestVersionItemAnswerCamelCased: {
            /** Format: uuid */
            readonly requestId: string;
            /** Format: uuid */
            readonly companyId: string;
            /** Format: int32 */
            readonly version: number;
            versionType: components['schemas']['RequestDetailsVersioningDomainVersionType'];
            /** Format: date-time */
            readonly submittedAt: string;
            /** Format: date-time */
            readonly createdAt: string;
            actor?: components['schemas']['UserAnswerCamelCased'];
            comment?: components['schemas']['RequestCommentAnswerCamelCased'];
            userPlatform?: components['schemas']['DomainUserPlatform'];
        };
        RequestDetailsVersionsRequestVersionsAnswer: {
            Items: components['schemas']['RequestDetailsVersionsRequestVersionItemAnswer'][];
        };
        RequestDetailsVersionsRequestVersionsAnswerCamelCased: {
            items: components['schemas']['RequestDetailsVersionsRequestVersionItemAnswerCamelCased'][];
        };
        RequestFieldValueAnswer: {
            Values?: components['schemas']['FieldValueAnswer'][] | null;
            /** Format: uuid */
            FieldId: string;
            Name?: string | null;
            Type: components['schemas']['DomainEntitiesFieldType'];
            SystemPurpose: components['schemas']['DomainEntitiesFieldPurpose'];
            CurrencyISOCode?: string | null;
            ExactValues?: components['schemas']['FieldValueAnswer'][] | null;
            HasMore?: boolean | null;
            readonly SubmitterApplicable: boolean;
        };
        RequestHistoryEventAnswer: {
            /** Format: uuid */
            EventId: string;
            EventDate?: string | null;
            EventType: components['schemas']['DomainEntitiesRequestHistoryRecordsRequestEventType'];
            /** Format: uuid */
            Step?: string | null;
            /** Format: uuid */
            NextStep?: string | null;
            StepName?: string | null;
            NextStepName?: string | null;
            Author?: components['schemas']['UserAnswer'];
            OnBehalfOf?: components['schemas']['UserAnswer'];
            Comment?: components['schemas']['RequestCommentAnswer'];
            Changes?: components['schemas']['RequestChangeData'];
            IsSystem: boolean;
            Description?: string | null;
            UserPlatform?: components['schemas']['DomainUserPlatform'];
        };
        RequestStepAnswer: {
            /** Format: uuid */
            StepId: string;
            Name?: string | null;
            Type: components['schemas']['DomainEntitiesStepApprovalType'];
            /** Format: int32 */
            ApprovalCount?: number | null;
            CreatedDate?: string | null;
            ModifiedDate?: string | null;
            State: components['schemas']['DomainEntitiesRequestsStepsRequestStepState'];
            Resolution: components['schemas']['DomainEntitiesStepResolution'];
            ResolutionDate?: string | null;
            RequiredFieldIds?: string[] | null;
            RequiredFields?: components['schemas']['FieldAnswer'][] | null;
            EditPermissionsRequiredFieldIds?: string[] | null;
            EditPermissionsRequiredFields?: components['schemas']['FieldAnswer'][] | null;
            Participants?: components['schemas']['RequestStepParticipantAnswer'][] | null;
            Editors?: components['schemas']['RequestStepEditorAnswer'][] | null;
        };
        RequestStepEditorAnswer: {
            Rules?: components['schemas']['RuleAnswer'][] | null;
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        RequestStepParticipantAnswer: {
            Decision: components['schemas']['DomainEntitiesApproverResponse'];
            DecisionDate?: string | null;
            EnabledAccordingToRule: boolean;
            Required: boolean;
            Source: components['schemas']['DomainEntitiesStepParticipantOrigin'];
            AddedBy?: components['schemas']['UserAnswer'];
            CanEdit: boolean;
            EditPermissions?: components['schemas']['RuleAnswer'][] | null;
            DelegateFor?: components['schemas']['UserAnswer'];
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        RequestSummaryAnswer: {
            /** Format: uuid */
            CompanyId: string;
            /** Format: uuid */
            RequestId: string;
            FriendlyName: string;
        };
        RequestSummaryAnswerCamelCased: {
            /** Format: uuid */
            companyId: string;
            /** Format: uuid */
            requestId: string;
            friendlyName: string;
        };
        RequestsLinkedRequestAnswerMatchingNetSuiteBillMatchingInfo: {
            Request?: components['schemas']['RequestAnswer'];
            Counterparty?: components['schemas']['RequestsRequestCounterpartyDetailsAnswer'];
            PossibleDuplicates?: components['schemas']['RequestSummaryAnswer'][] | null;
            MatchingInfo?: components['schemas']['MatchingNetSuiteBillMatchingInfo'];
        };
        RequestsLinkedRequestAnswerMatchingXeroBillMatchingInfo: {
            Request?: components['schemas']['RequestAnswer'];
            Counterparty?: components['schemas']['RequestsRequestCounterpartyDetailsAnswer'];
            PossibleDuplicates?: components['schemas']['RequestSummaryAnswer'][] | null;
            MatchingInfo?: components['schemas']['MatchingXeroBillMatchingInfo'];
        };
        RequestsRequestCounterpartyDetailsAnswer: {
            emailAddress?: string | null;
            addressLine1?: string | null;
            addressLine2?: string | null;
            addressLine3?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
            taxNumber?: string | null;
            companyNumber?: string | null;
            accountNumber?: string | null;
        };
        RequestsRequestPaymentStepAnswer: {
            /** Format: uuid */
            PaymentStepId: string;
            /** Format: date-time */
            readonly CompletedAt?: string | null;
            readonly IsCompleted: boolean;
            Payers: components['schemas']['RequestsRequestStepPayerAnswer'][];
        };
        RequestsRequestReceiptBankTransactionDetailsAnswer: {
            originDeepLink?: string | null;
            hasNewSupplier: boolean;
        };
        RequestsRequestReceiptBankTransactionDetailsAnswerCamelCased: {
            originDeepLink?: string | null;
            hasNewSupplier: boolean;
        };
        RequestsRequestReviewStepAnswer: {
            /** Format: uuid */
            ReviewStepId: string;
            CompletedByUser?: components['schemas']['UserAnswer'];
            /** Format: date-time */
            CompletedAt?: string | null;
            readonly IsCompleted: boolean;
            Reviewers: components['schemas']['RequestsRequestStepReviewerAnswer'][];
        };
        RequestsRequestStepPayerAnswer: {
            AddedBy?: components['schemas']['UserAnswer'];
            DelegateFor?: components['schemas']['UserAnswer'];
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        RequestsRequestStepReviewerAnswer: {
            AddedBy?: components['schemas']['UserAnswer'];
            Source: components['schemas']['DomainEntitiesRequestsStepsReviewersRequestStepReviewerOrigin'];
            DelegateFor?: components['schemas']['UserAnswer'];
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        RequestsRequestWatcherAnswer: {
            Watcher?: components['schemas']['UserAnswer'];
            AddedBy?: components['schemas']['UserAnswer'];
            /** Format: date-time */
            CreatedDate: string;
        };
        /**
         * Format: string
         * @description <ul><li><i>UserDecisionRequired</i> - 0</li><li><i>RequestsUserCanSee</i> - 6</li><li><i>UserSubmittedOpenRequests</i> - 7</li><li><i>UserDraftRequests</i> - 8</li><li><i>UserReviewRequired</i> - 9</li><li><i>UserOcrRequests</i> - 10</li><li><i>UserReadyToPayRequests</i> - 11</li><li><i>UserOnHoldRequests</i> - 12</li></ul>
         * @enum {string}
         */
        RequestsSelectFilterType: RequestsSelectFilterType;
        RequestsSelectRequestsAnswer: {
            Requests: components['schemas']['RequestAnswer'][];
            ContinuationToken?: string | null;
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        RequestsStandaloneDetailsAnswer: {
            Name: string;
            Description: string;
            /** Format: date */
            Date?: string | null;
            FieldValues?: components['schemas']['RequestFieldValueAnswer'][] | null;
        };
        RuleAnswer: {
            Name?: string | null;
            Conditions?: components['schemas']['RuleConditionAnswer'][] | null;
        };
        RuleConditionAnswer: {
            /** Format: uuid */
            FieldId: string;
            Name?: string | null;
            SystemPurpose: components['schemas']['DomainEntitiesFieldPurpose'];
            ConditionType: components['schemas']['DomainEntitiesFieldType'];
            AmountType: components['schemas']['DomainEntitiesAmountConditionType'];
            ExactConstraint?: components['schemas']['ExactConstraintAnswer'][] | null;
            GroupOfXeroAccountsConstraints?: components['schemas']['GroupOfXeroAccountsConstraintAnswer'][] | null;
            ExactBooleanConstraint?: boolean | null;
            /** Format: double */
            RangeConstraintLess?: number | null;
            /** Format: double */
            RangeConstraintGreaterEquals?: number | null;
            AllowCreation?: boolean | null;
            AllowEditing?: boolean | null;
            /** Format: int32 */
            FieldValuesFilterType?: number | null;
        };
        /**
         * Format: string
         * @description <ul><li><i>April</i> - 4</li><li><i>August</i> - 8</li><li><i>December</i> - 12</li><li><i>February</i> - 2</li><li><i>January</i> - 1</li><li><i>July</i> - 7</li><li><i>June</i> - 6</li><li><i>March</i> - 3</li><li><i>May</i> - 5</li><li><i>November</i> - 11</li><li><i>October</i> - 10</li><li><i>September</i> - 9</li></ul>
         */
        SharedKernelDatesMonth: string;
        /**
         * Format: string
         * @description <ul><li><i>April</i> - 4</li><li><i>August</i> - 8</li><li><i>December</i> - 12</li><li><i>February</i> - 2</li><li><i>January</i> - 1</li><li><i>July</i> - 7</li><li><i>June</i> - 6</li><li><i>March</i> - 3</li><li><i>May</i> - 5</li><li><i>November</i> - 11</li><li><i>October</i> - 10</li><li><i>September</i> - 9</li></ul>
         */
        SharedKernelDatesMonthCamelCased: string;
        SharedKernelDatesMonthOfYear: {
            month: components['schemas']['SharedKernelDatesMonth'];
            /** Format: int32 */
            year: number;
            /** Format: date-time */
            readonly asDateTime: string;
            /** Format: date-time */
            readonly asDateTimeOffsetUtc: string;
        };
        SharedKernelDatesMonthOfYearCamelCased: {
            month: components['schemas']['SharedKernelDatesMonthCamelCased'];
            /** Format: int32 */
            year: number;
            /** Format: date-time */
            readonly asDateTime: string;
            /** Format: date-time */
            readonly asDateTimeOffsetUtc: string;
        };
        StepChangeData: {
            /** Format: uuid */
            StepId: string;
            StepName?: string | null;
            Name?: string | null;
            Deadline?: string | null;
            DeadlineWasDeleted?: boolean | null;
            AddedApprovers?: components['schemas']['UserWithDelegateAnswer'][] | null;
            RemovedApprovers?: components['schemas']['UserWithDelegateAnswer'][] | null;
        };
        UserAnswer: {
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        UserAnswerCamelCased: {
            /** Format: uuid */
            userId: string;
            userName?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            userEmail?: string | null;
            avatarHttps?: string | null;
            /** Format: date-time */
            avatarModifiedDate?: string | null;
            loggedIn: boolean;
            isInvited: boolean;
            isSystem: boolean;
        };
        UserWithDelegateAnswer: {
            DelegateFor?: components['schemas']['UserAnswer'];
            /** Format: uuid */
            UserId: string;
            UserName?: string | null;
            FirstName?: string | null;
            LastName?: string | null;
            UserEmail?: string | null;
            AvatarHttps?: string | null;
            /** Format: date-time */
            AvatarModifiedDate?: string | null;
            LoggedIn: boolean;
            IsInvited: boolean;
            IsSystem: boolean;
        };
        V2AmaxPayOpenBankingBankAccountBalanceAnswer: {
            /** Format: uuid */
            id: string;
            /** Format: double */
            amount: number;
            currency?: string | null;
        };
        V2AmaxPayOpenBankingBankAccountBalanceAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            /** Format: double */
            amount: number;
            currency?: string | null;
        };
        V2CollectionAnswerApiAmaxPayWalletsFundingAccount: {
            items: components['schemas']['ApiAmaxPayWalletsFundingAccount'][];
        };
        V2CollectionAnswerApiAmaxPayWalletsFundingAccountCamelCased: {
            items: components['schemas']['ApiAmaxPayWalletsFundingAccountCamelCased'][];
        };
        V2CollectionAnswerApiAmaxPayWalletsWallet: {
            items: components['schemas']['ApiAmaxPayWalletsWallet'][];
        };
        V2CollectionAnswerApiAmaxPayWalletsWalletCamelCased: {
            items: components['schemas']['ApiAmaxPayWalletsWalletCamelCased'][];
        };
        V2CollectionAnswerApiIntegrationsCurrency: {
            items: components['schemas']['ApiIntegrationsCurrency'][];
        };
        V2CollectionAnswerApiIntegrationsCurrencyCamelCased: {
            items: components['schemas']['ApiIntegrationsCurrencyCamelCased'][];
        };
        V2CollectionAnswerApiIntegrationsNetSuiteDocumentAvailableForBillPayment: {
            items: components['schemas']['ApiIntegrationsNetSuiteDocumentAvailableForBillPayment'][];
        };
        V2CollectionAnswerApiIntegrationsNetSuiteDocumentAvailableForBillPaymentCamelCased: {
            items: components['schemas']['ApiIntegrationsNetSuiteDocumentAvailableForBillPaymentCamelCased'][];
        };
        V2CollectionAnswerApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecord: {
            items: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecord'][];
        };
        V2CollectionAnswerApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecordCamelCased: {
            items: components['schemas']['ApiIntegrationsXeroPaymentDetailsCounterpartyPaymentDetailsHistoryRecordCamelCased'][];
        };
        V2CollectionAnswerApiRequestsBatchPaymentInvoiceAmountsAnswer: {
            items: components['schemas']['ApiRequestsBatchPaymentInvoiceAmountsAnswer'][];
        };
        V2CollectionAnswerApiRequestsBatchPaymentInvoiceAmountsAnswerCamelCased: {
            items: components['schemas']['ApiRequestsBatchPaymentInvoiceAmountsAnswerCamelCased'][];
        };
        V2CollectionAnswerProfileCompanyDelegationsAnswer: {
            items: components['schemas']['ProfileCompanyDelegationsAnswer'][];
        };
        V2CollectionAnswerProfileCompanyDelegationsAnswerCamelCased: {
            items: components['schemas']['ProfileCompanyDelegationsAnswerCamelCased'][];
        };
        V2CollectionAnswerRequestSummaryAnswer: {
            items: components['schemas']['RequestSummaryAnswer'][];
        };
        V2CollectionAnswerRequestSummaryAnswerCamelCased: {
            items: components['schemas']['RequestSummaryAnswerCamelCased'][];
        };
        V2CollectionAnswerV2CompaniesUserCompanyAnswer: {
            items: components['schemas']['V2CompaniesUserCompanyAnswer'][];
        };
        V2CollectionAnswerV2CompaniesUserCompanyAnswerCamelCased: {
            items: components['schemas']['V2CompaniesUserCompanyAnswerCamelCased'][];
        };
        V2CollectionAnswerV2CompaniesUserCompanyInvitationAnswer: {
            items: components['schemas']['V2CompaniesUserCompanyInvitationAnswer'][];
        };
        V2CollectionAnswerV2CompaniesUserCompanyInvitationAnswerCamelCased: {
            items: components['schemas']['V2CompaniesUserCompanyInvitationAnswerCamelCased'][];
        };
        V2CollectionAnswerV2WorkflowsUserCompanyWorkflowAnswer: {
            items: components['schemas']['V2WorkflowsUserCompanyWorkflowAnswer'][];
        };
        V2CollectionAnswerV2WorkflowsUserCompanyWorkflowAnswerCamelCased: {
            items: components['schemas']['V2WorkflowsUserCompanyWorkflowAnswerCamelCased'][];
        };
        V2CompaniesCompanyDetailsAnswer: {
            /** Format: uuid */
            Id: string;
            Name: string;
            BetaFeatures: string[];
            IsReadonly: boolean;
            ProductPlanId: string;
            /** Format: uuid */
            LicenseOwnerId: string;
            ProductPlanFeatures: string[];
            /** Format: date-time */
            LicenseExpires: string;
            AllFeaturesTrialStatus: components['schemas']['DomainEntitiesLicensesAllFeaturesTrialStatus'];
            IntegrationType: components['schemas']['DomainIntegrationType'];
            IsIntegrationEnabled: boolean;
            IntegrationVersion?: string | null;
        };
        V2CompaniesCompanyDetailsAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            name: string;
            betaFeatures: string[];
            isReadonly: boolean;
            productPlanId: string;
            /** Format: uuid */
            licenseOwnerId: string;
            productPlanFeatures: string[];
            /** Format: date-time */
            licenseExpires: string;
            allFeaturesTrialStatus: components['schemas']['DomainEntitiesLicensesAllFeaturesTrialStatus'];
            integrationType: components['schemas']['DomainIntegrationType'];
            isIntegrationEnabled: boolean;
            integrationVersion?: string | null;
        };
        V2CompaniesUserCompanyAnswer: {
            /** Format: uuid */
            Id: string;
            Name: string;
            BetaFeatures: string[];
            IntegrationType: components['schemas']['DomainIntegrationType'];
            ProductPlanFeatures: string[];
            AllFeaturesTrialStatus: components['schemas']['DomainEntitiesLicensesAllFeaturesTrialStatus'];
            ProductPlanId: string;
        };
        V2CompaniesUserCompanyAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            name: string;
            betaFeatures: string[];
            integrationType: components['schemas']['DomainIntegrationType'];
            productPlanFeatures: string[];
            allFeaturesTrialStatus: components['schemas']['DomainEntitiesLicensesAllFeaturesTrialStatus'];
            productPlanId: string;
        };
        V2CompaniesUserCompanyInvitationAnswer: {
            /** Format: uuid */
            CompanyId: string;
            CompanyName: string;
            InviterUserFirstName?: string | null;
            InviterUserLastName?: string | null;
            InviterUserEmail: string;
        };
        V2CompaniesUserCompanyInvitationAnswerCamelCased: {
            /** Format: uuid */
            companyId: string;
            companyName: string;
            inviterUserFirstName?: string | null;
            inviterUserLastName?: string | null;
            inviterUserEmail: string;
        };
        V2CompanyParticipantsCompanyParticipantDetailsAnswer: {
            /** Format: uuid */
            Id: string;
            FirstName?: string | null;
            LastName?: string | null;
            Email: string;
            Role: components['schemas']['DomainEntitiesCompanyRole'];
            Permissions: components['schemas']['DomainEntitiesCompaniesParticipantsPermission'][];
        };
        V2CompanyParticipantsCompanyParticipantDetailsAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            email: string;
            role: components['schemas']['DomainEntitiesCompanyRole'];
            permissions: components['schemas']['DomainEntitiesCompaniesParticipantsPermission'][];
        };
        V2GroupsOfXeroAccountsGroupOfXeroAccountsAnswer: {
            /** Format: uuid */
            Id: string;
            /** Format: uuid */
            CompanyId: string;
            Name: string;
            LatestVersion?: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswer'];
            IsArchived: boolean;
            IsDeleted: boolean;
            Workflows: components['schemas']['CompaniesWorkflowInfoAnswer'][];
        };
        V2GroupsOfXeroAccountsGroupOfXeroAccountsAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            /** Format: uuid */
            companyId: string;
            name: string;
            latestVersion?: components['schemas']['V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased'];
            isArchived: boolean;
            isDeleted: boolean;
            workflows: components['schemas']['CompaniesWorkflowInfoAnswerCamelCased'][];
        };
        V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswer: {
            /** Format: uuid */
            Id: string;
            /** Format: int32 */
            VersionNumber: number;
            /** Format: uuid */
            GroupOfXeroAccountsId: string;
            /** Format: uuid */
            CompanyId: string;
            Values: components['schemas']['FieldValueAnswer'][];
            Comment?: string | null;
            Author?: components['schemas']['UserAnswer'];
            /** Format: date-time */
            CreatedAt: string;
        };
        V2GroupsOfXeroAccountsGroupOfXeroAccountsVersionAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            /** Format: int32 */
            versionNumber: number;
            /** Format: uuid */
            groupOfXeroAccountsId: string;
            /** Format: uuid */
            companyId: string;
            values: components['schemas']['FieldValueAnswerCamelCased'][];
            comment?: string | null;
            author?: components['schemas']['UserAnswerCamelCased'];
            /** Format: date-time */
            createdAt: string;
        };
        V2OcrOcrResultAnswer: {
            status: components['schemas']['DomainEntitiesOcrOcrStatus'];
            failureReason?: string | null;
            document?:
                | (
                      | components['schemas']['OcrContractsModelsXeroRecognizedBillAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPayableCreditNoteAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPurchaseOrderAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedSalesInvoiceAnswer']
                      | components['schemas']['OcrContractsModelsQBooksRecognizedBillAnswer']
                      | components['schemas']['OcrContractsModelsNetSuiteRecognizedBillAnswer']
                  )
                | null;
        };
        V2OcrOcrResultAnswerCamelCased: {
            status: components['schemas']['DomainEntitiesOcrOcrStatus'];
            failureReason?: string | null;
            document?:
                | (
                      | components['schemas']['OcrContractsModelsXeroRecognizedBillAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPayableCreditNoteAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPurchaseOrderAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedSalesInvoiceAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsQBooksRecognizedBillAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsNetSuiteRecognizedBillAnswerCamelCased']
                  )
                | null;
        };
        V2OcrResultAnswer: {
            failureReason?: string | null;
            document?:
                | (
                      | components['schemas']['OcrContractsModelsXeroRecognizedBillAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPayableCreditNoteAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPurchaseOrderAnswer']
                      | components['schemas']['OcrContractsModelsXeroRecognizedSalesInvoiceAnswer']
                      | components['schemas']['OcrContractsModelsQBooksRecognizedBillAnswer']
                      | components['schemas']['OcrContractsModelsNetSuiteRecognizedBillAnswer']
                  )
                | null;
        };
        V2OcrResultAnswerCamelCased: {
            failureReason?: string | null;
            document?:
                | (
                      | components['schemas']['OcrContractsModelsXeroRecognizedBillAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPayableCreditNoteAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedPurchaseOrderAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsXeroRecognizedSalesInvoiceAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsQBooksRecognizedBillAnswerCamelCased']
                      | components['schemas']['OcrContractsModelsNetSuiteRecognizedBillAnswerCamelCased']
                  )
                | null;
        };
        V2OcrStatusAnswer: {
            status: components['schemas']['DomainEntitiesOcrOcrStatus'];
        };
        V2OcrStatusAnswerCamelCased: {
            status: components['schemas']['DomainEntitiesOcrOcrStatus'];
        };
        V2RequestsRequestAnswer: {
            /** Format: int32 */
            Version: number;
            /** Format: uuid */
            RequestId: string;
            FriendlyName?: string | null;
            RequestNote?: string | null;
            CreatedAt?: string | null;
            ModifiedAt?: string | null;
            Attachments?: components['schemas']['AttachmentAnswer'][] | null;
            EmailToContact?: components['schemas']['IntegrationsEmailToContactAnswer'];
            /** Format: double */
            Amount: number;
            Currency?: string | null;
            /** Format: double */
            ExchangeRate?: number | null;
            CompanyCurrency?: string | null;
            ExchangeRateSource?: components['schemas']['DomainEntitiesExchangeRateSource'];
            XeroInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswer'];
            XeroPurchaseOrderDetails?: components['schemas']['IntegrationsXeroPurchaseOrderAnswer'];
            XeroSalesInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswer'];
            XeroCreditNoteDetails?: components['schemas']['IntegrationsXeroCreditNoteAnswer'];
            XeroContactDetails?: components['schemas']['IntegrationsXeroContactAnswer'];
            XeroBillBatchPaymentDetails?: components['schemas']['IntegrationsXeroBillBatchPaymentAnswer'];
            XeroQuoteDetails?: components['schemas']['IntegrationsXeroQuoteAnswer'];
            AirwallexXeroBatchPaymentDetails?: components['schemas']['IntegrationsAirwallexXeroAirwallexBatchPaymentAnswer'];
            XeroManualJournalDetails?: components['schemas']['IntegrationsXeroManualJournalAnswer'];
            QBooksPurchaseOrderDetails?: components['schemas']['IntegrationsQBooksPurchaseOrderAnswer'];
            QBooksBillInvoiceDetails?: components['schemas']['IntegrationsQBooksBillInvoiceAnswer'];
            QBooksExpenseDetails?: components['schemas']['IntegrationsQBooksExpenseAnswer'];
        };
        V2RequestsRequestAnswerCamelCased: {
            /** Format: int32 */
            version: number;
            /** Format: uuid */
            requestId: string;
            friendlyName?: string | null;
            requestNote?: string | null;
            createdAt?: string | null;
            modifiedAt?: string | null;
            attachments?: components['schemas']['AttachmentAnswerCamelCased'][] | null;
            emailToContact?: components['schemas']['IntegrationsEmailToContactAnswerCamelCased'];
            /** Format: double */
            amount: number;
            currency?: string | null;
            /** Format: double */
            exchangeRate?: number | null;
            companyCurrency?: string | null;
            exchangeRateSource?: components['schemas']['DomainEntitiesExchangeRateSource'];
            xeroInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswerCamelCased'];
            xeroPurchaseOrderDetails?: components['schemas']['IntegrationsXeroPurchaseOrderAnswerCamelCased'];
            xeroSalesInvoiceDetails?: components['schemas']['IntegrationsXeroInvoiceAnswerCamelCased'];
            xeroCreditNoteDetails?: components['schemas']['IntegrationsXeroCreditNoteAnswerCamelCased'];
            xeroContactDetails?: components['schemas']['IntegrationsXeroContactAnswerCamelCased'];
            xeroBillBatchPaymentDetails?: components['schemas']['IntegrationsXeroBillBatchPaymentAnswerCamelCased'];
            xeroQuoteDetails?: components['schemas']['IntegrationsXeroQuoteAnswerCamelCased'];
            airwallexXeroBatchPaymentDetails?: components['schemas']['IntegrationsAirwallexXeroAirwallexBatchPaymentAnswerCamelCased'];
            xeroManualJournalDetails?: components['schemas']['IntegrationsXeroManualJournalAnswerCamelCased'];
            qBooksPurchaseOrderDetails?: components['schemas']['IntegrationsQBooksPurchaseOrderAnswerCamelCased'];
            qBooksBillInvoiceDetails?: components['schemas']['IntegrationsQBooksBillInvoiceAnswerCamelCased'];
            qBooksExpenseDetails?: components['schemas']['IntegrationsQBooksExpenseAnswerCamelCased'];
        };
        V2RequestsRequestCreateAnswer: {
            /** Format: uuid */
            requestId: string;
            Result?: string | null;
            ErrorCode?: string | null;
            ErrorMsg?: string | null;
            ErrorDetails?: string | null;
            ValidationErrors?: string[] | null;
        };
        V2RequestsRequestCreateAnswerCamelCased: {
            /** Format: uuid */
            requestId: string;
            result?: string | null;
            errorCode?: string | null;
            errorMsg?: string | null;
            errorDetails?: string | null;
            validationErrors?: string[] | null;
        };
        V2WorkflowsIsUserWorkflowPayerAnswer: {
            IsWorkflowPayer: boolean;
        };
        V2WorkflowsIsUserWorkflowPayerAnswerCamelCased: {
            isWorkflowPayer: boolean;
        };
        V2WorkflowsUserCompanyWorkflowAnswer: {
            /** Format: uuid */
            Id: string;
            Name?: string | null;
            /** Format: uuid */
            CompanyId: string;
            IntegrationCode: string;
            IsEnabled: boolean;
            IsEnabledForRequestCreation: boolean;
            IsGrnEnabled: boolean;
        };
        V2WorkflowsUserCompanyWorkflowAnswerCamelCased: {
            /** Format: uuid */
            id: string;
            name?: string | null;
            /** Format: uuid */
            companyId: string;
            integrationCode: string;
            isEnabled: boolean;
            isEnabledForRequestCreation: boolean;
            isGrnEnabled: boolean;
        };
        WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsTransfer: {
            Name: string;
        };
        WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsTransferCamelCased: {
            name: string;
        };
        WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsVersionTransfer: {
            /** Format: int32 */
            PrevVersionNumber?: number | null;
            Values: components['schemas']['FieldValueAnswer'][];
            Comment?: string | null;
            ForceCreate: boolean;
        };
        WebApiModelsGroupsOfXeroAccountsCreateGroupOfXeroAccountsVersionTransferCamelCased: {
            /** Format: int32 */
            prevVersionNumber?: number | null;
            values: components['schemas']['FieldValueAnswerCamelCased'][];
            comment?: string | null;
            forceCreate: boolean;
        };
        WebApiModelsGroupsOfXeroAccountsToggleGroupOfXeroAccountsIsArchivedTransfer: {
            IsArchived: boolean;
        };
        WebApiModelsGroupsOfXeroAccountsToggleGroupOfXeroAccountsIsArchivedTransferCamelCased: {
            isArchived: boolean;
        };
        WebApiModelsGroupsOfXeroAccountsUpdateGroupOfXeroAccountsTransfer: {
            Name: string;
        };
        WebApiModelsGroupsOfXeroAccountsUpdateGroupOfXeroAccountsTransferCamelCased: {
            name: string;
        };
        WebApiModelsOCRUploadFilesForOcrTransfer: {
            FileUploadOptions: components['schemas']['BackendCoreOcrOcrFileUploadOptions'];
            FileRecordIds: string[];
            UseLinesMerge: boolean;
        };
        WebApiModelsOCRUploadFilesForOcrTransferCamelCased: {
            fileUploadOptions: components['schemas']['BackendCoreOcrOcrFileUploadOptionsCamelCased'];
            fileRecordIds: string[];
            useLinesMerge: boolean;
        };
        WebApiModelsRequestsPutOnHoldTransfer: {
            /** Format: int32 */
            RequestVersion: number;
            Comment?: string | null;
        };
        WebApiModelsRequestsPutOnHoldTransferCamelCased: {
            /** Format: int32 */
            requestVersion: number;
            comment?: string | null;
        };
        WebApiModelsRequestsTakeOffHoldTransfer: {
            /** Format: int32 */
            RequestVersion: number;
            Comment?: string | null;
        };
        WebApiModelsRequestsTakeOffHoldTransferCamelCased: {
            /** Format: int32 */
            requestVersion: number;
            comment?: string | null;
        };
        WorkflowsGenerateOcrEmailAddressAnswer: {
            /** Format: email */
            EmailAddress: string;
        };
        WorkflowsGenerateOcrEmailAddressAnswerCamelCased: {
            /** Format: email */
            emailAddress: string;
        };
        /**
         * Format: string
         * @description <ul><li><i>Amount</i></li><li><i>PreAmount</i></li><li><i>PreRate</i></li><li><i>Rate</i></li></ul>
         * @enum {string}
         */
        XeroDomainEntitiesDocumentsDiscountType: XeroDomainEntitiesDocumentsDiscountType;
        /**
         * Format: string
         * @description <ul><li><i>None</i> - 0</li><li><i>Xero</i> - 1</li><li><i>User</i> - 2</li><li><i>System</i> - 3</li></ul>
         * @enum {string}
         */
        XeroDomainEntitiesRequestsMarkAsBilledSource: XeroDomainEntitiesRequestsMarkAsBilledSource;
        /**
         * Format: string
         * @description <ul><li><i>None</i> - 0</li><li><i>Submitted</i> - 1</li><li><i>Authorised</i> - 2</li><li><i>Paid</i> - 3</li><li><i>Billed</i> - 4</li><li><i>Deleted</i> - 5</li><li><i>Voided</i> - 6</li><li><i>Draft</i> - 7</li><li><i>Active</i> - 8</li><li><i>Archived</i> - 9</li><li><i>GdprRequest</i> - 10</li><li><i>Sent</i> - 11</li><li><i>Accepted</i> - 12</li><li><i>Declined</i> - 13</li><li><i>Invoiced</i> - 14</li><li><i>Posted</i> - 15</li></ul>
         * @enum {string}
         */
        XeroDomainEntitiesXeroDocumentStatus: XeroDomainEntitiesXeroDocumentStatus;
        XeroDomainModelsAddressInfo: {
            Address?: string | null;
            City?: string | null;
            Region?: string | null;
            PostalCode?: string | null;
            Country?: string | null;
            AttentionTo?: string | null;
        };
        XeroDomainModelsAddressInfoCamelCased: {
            address?: string | null;
            city?: string | null;
            region?: string | null;
            postalCode?: string | null;
            country?: string | null;
            attentionTo?: string | null;
        };
        XeroDomainModelsPhone: {
            CountryCode?: string | null;
            AreaCode?: string | null;
            Number?: string | null;
        };
        XeroDomainModelsPhoneCamelCased: {
            countryCode?: string | null;
            areaCode?: string | null;
            number?: string | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export enum AccountingDomainEntitiesBudgetCheckPeriod {
    Annually = 'Annually',
    AnnuallyWithCustomFirstMonth = 'AnnuallyWithCustomFirstMonth',
    Custom = 'Custom',
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    Semiannually = 'Semiannually',
    YearToDate = 'YearToDate',
    YearToDateWithCustomFirstMonth = 'YearToDateWithCustomFirstMonth',
}
export enum AccountingDomainEntitiesBudgetCheckStatus {
    Ok = 'Ok',
    Overbudget = 'Overbudget',
    Warning = 'Warning',
}
export enum AccountingDomainEntitiesBudgetZeroAmountHandlingType {
    Consider = 'Consider',
    NotConsider = 'NotConsider',
}
export enum AccountingDomainEntitiesDocumentsLineAmountType {
    No_Tax = 'No Tax',
    Tax_Exclusive = 'Tax Exclusive',
    Tax_Inclusive = 'Tax Inclusive',
}
export enum AccountingDomainEntitiesSynchronizationStatus {
    failed = 'failed',
    in_progress = 'in-progress',
    succeeded = 'succeeded',
}
export enum AccountingDomainEntitiesWorkflowsConfigurationsLockDatePolicyType {
    LockApproval = 'LockApproval',
    ApproveWithNextDay = 'ApproveWithNextDay',
}
export enum AddressType {
    Postal = 'Postal',
    Physical = 'Physical',
}
export enum AirwallexApiClientAirwallexPaymentPurpose {
    audio_visual_services = 'audio_visual_services',
    business_expenses = 'business_expenses',
    construction = 'construction',
    donation_charitable_contribution = 'donation_charitable_contribution',
    education_training = 'education_training',
    family_support = 'family_support',
    freight = 'freight',
    goods_purchased = 'goods_purchased',
    investment_capital = 'investment_capital',
    investment_proceeds = 'investment_proceeds',
    living_expenses = 'living_expenses',
    loan_credit_repayment = 'loan_credit_repayment',
    medical_services = 'medical_services',
    other_services = 'other_services',
    pension = 'pension',
    personal_remittance = 'personal_remittance',
    professional_business_services = 'professional_business_services',
    real_estate = 'real_estate',
    taxes = 'taxes',
    technical_services = 'technical_services',
    transfer_to_own_account = 'transfer_to_own_account',
    travel = 'travel',
    wages_salary = 'wages_salary',
}
export enum AirwallexDomainEntitiesAirwallexApprovalEntityStatus {
    Awaiting_Payment = 'Awaiting Payment',
    Failed = 'Failed',
    None = 'None',
    Paid = 'Paid',
    Partially_Paid = 'Partially Paid',
    Processing = 'Processing',
}
export enum AirwallexDomainEntitiesAirwallexBeneficiaryPaymentMethod {
    local = 'local',
    swift = 'swift',
}
export enum AirwallexDomainEntitiesAirwallexPaymentFee {
    Payer = 'Payer',
    Shared = 'Shared',
}
export enum AirwallexDomainEntitiesBeneficiaryPaymentStatus {
    never_paid = 'never-paid',
    not_checked = 'not-checked',
    paid_previously = 'paid-previously',
    payment_details_changed = 'payment-details-changed',
}
export enum AmaxPayXeroDomainEntitiesApprovalEntitiesAmaxPayXeroBatchPaymentStatus {
    awaiting_payment = 'awaiting-payment',
    cancelled = 'cancelled',
    failed = 'failed',
    none = 'none',
    paid = 'paid',
    partially_paid = 'partially-paid',
    processing = 'processing',
}
export enum AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentDetailsPaymentStatus {
    never_paid = 'never-paid',
    not_checked = 'not-checked',
    paid_previously = 'paid-previously',
    payment_details_changed = 'payment-details-changed',
}
export enum AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource {
    none = 'none',
    open_banking = 'open-banking',
    virtual_account = 'virtual-account',
}
export enum AmaxPayXeroDomainEntitiesPaymentsAmaxPayPaymentStatus {
    cancelled_by_user = 'cancelled-by-user',
    failed = 'failed',
    paid = 'paid',
    processing = 'processing',
    ready_to_pay = 'ready-to-pay',
    scheduled = 'scheduled',
}
export enum ApiAmaxPayLegalEntityType {
    company = 'company',
    individual = 'individual',
}
export enum ApiAmaxPayPaymentDetailsAccountVerificationStatus {
    close_match = 'close-match',
    full_match = 'full-match',
    no_match = 'no-match',
}
export enum ApiAmaxPayPaymentDetailsVerificationStatus {
    close_match = 'close-match',
    full_match = 'full-match',
    no_match = 'no-match',
    not_checked = 'not-checked',
}
export enum ApiAmaxPayPaymentType {
    priority = 'priority',
    regular = 'regular',
}
export enum ApiAmaxPayTransactionStatus {
    failed = 'failed',
    initiated = 'initiated',
    paid = 'paid',
    processing = 'processing',
    scheduled = 'scheduled',
    unknown = 'unknown',
}
export enum ApiIntegrationsQBooksTaxCodeTaxRateRefTaxTypeApplicable {
    TaxOnAmount = 'TaxOnAmount',
    TaxOnAmountPlusTax = 'TaxOnAmountPlusTax',
    TaxOnTax = 'TaxOnTax',
}
export enum ApiIntegrationsXeroPaymentDetailsEventType {
    create = 'create',
    delete = 'delete',
    unspecified = 'unspecified',
    update = 'update',
}
export enum BudgetsQBooksDimensionType {
    class = 'class',
    customer = 'customer',
    location = 'location',
    none = 'none',
}
export enum CountryIsoCode {
    AD = 'AD',
    AE = 'AE',
    AF = 'AF',
    AG = 'AG',
    AI = 'AI',
    AL = 'AL',
    AM = 'AM',
    AO = 'AO',
    AQ = 'AQ',
    AR = 'AR',
    AS = 'AS',
    AT = 'AT',
    AU = 'AU',
    AW = 'AW',
    AX = 'AX',
    AZ = 'AZ',
    BA = 'BA',
    BB = 'BB',
    BD = 'BD',
    BE = 'BE',
    BF = 'BF',
    BG = 'BG',
    BH = 'BH',
    BI = 'BI',
    BJ = 'BJ',
    BL = 'BL',
    BM = 'BM',
    BN = 'BN',
    BO = 'BO',
    BQ = 'BQ',
    BR = 'BR',
    BS = 'BS',
    BT = 'BT',
    BV = 'BV',
    BW = 'BW',
    BY = 'BY',
    BZ = 'BZ',
    CA = 'CA',
    CC = 'CC',
    CD = 'CD',
    CF = 'CF',
    CG = 'CG',
    CH = 'CH',
    CI = 'CI',
    CK = 'CK',
    CL = 'CL',
    CM = 'CM',
    CN = 'CN',
    CO = 'CO',
    CR = 'CR',
    CU = 'CU',
    CV = 'CV',
    CW = 'CW',
    CX = 'CX',
    CY = 'CY',
    CZ = 'CZ',
    DE = 'DE',
    DJ = 'DJ',
    DK = 'DK',
    DM = 'DM',
    DO = 'DO',
    DZ = 'DZ',
    EC = 'EC',
    EE = 'EE',
    EG = 'EG',
    EH = 'EH',
    ER = 'ER',
    ES = 'ES',
    ET = 'ET',
    FI = 'FI',
    FJ = 'FJ',
    FK = 'FK',
    FM = 'FM',
    FO = 'FO',
    FR = 'FR',
    GA = 'GA',
    GB = 'GB',
    GD = 'GD',
    GE = 'GE',
    GF = 'GF',
    GG = 'GG',
    GH = 'GH',
    GI = 'GI',
    GL = 'GL',
    GM = 'GM',
    GN = 'GN',
    GP = 'GP',
    GQ = 'GQ',
    GR = 'GR',
    GS = 'GS',
    GT = 'GT',
    GU = 'GU',
    GW = 'GW',
    GY = 'GY',
    HK = 'HK',
    HM = 'HM',
    HN = 'HN',
    HR = 'HR',
    HT = 'HT',
    HU = 'HU',
    ID = 'ID',
    IE = 'IE',
    IL = 'IL',
    IM = 'IM',
    IN = 'IN',
    IO = 'IO',
    IQ = 'IQ',
    IR = 'IR',
    IS = 'IS',
    IT = 'IT',
    JE = 'JE',
    JM = 'JM',
    JO = 'JO',
    JP = 'JP',
    KE = 'KE',
    KG = 'KG',
    KH = 'KH',
    KI = 'KI',
    KM = 'KM',
    KN = 'KN',
    KP = 'KP',
    KR = 'KR',
    KW = 'KW',
    KY = 'KY',
    KZ = 'KZ',
    LA = 'LA',
    LB = 'LB',
    LC = 'LC',
    LI = 'LI',
    LK = 'LK',
    LR = 'LR',
    LS = 'LS',
    LT = 'LT',
    LU = 'LU',
    LV = 'LV',
    LY = 'LY',
    MA = 'MA',
    MC = 'MC',
    MD = 'MD',
    ME = 'ME',
    MF = 'MF',
    MG = 'MG',
    MH = 'MH',
    MK = 'MK',
    ML = 'ML',
    MM = 'MM',
    MN = 'MN',
    MO = 'MO',
    MP = 'MP',
    MQ = 'MQ',
    MR = 'MR',
    MS = 'MS',
    MT = 'MT',
    MU = 'MU',
    MV = 'MV',
    MW = 'MW',
    MX = 'MX',
    MY = 'MY',
    MZ = 'MZ',
    NA = 'NA',
    NC = 'NC',
    NE = 'NE',
    NF = 'NF',
    NG = 'NG',
    NI = 'NI',
    NL = 'NL',
    NO = 'NO',
    NP = 'NP',
    NR = 'NR',
    NU = 'NU',
    NZ = 'NZ',
    OM = 'OM',
    PA = 'PA',
    PE = 'PE',
    PF = 'PF',
    PG = 'PG',
    PH = 'PH',
    PK = 'PK',
    PL = 'PL',
    PM = 'PM',
    PN = 'PN',
    PR = 'PR',
    PS = 'PS',
    PT = 'PT',
    PW = 'PW',
    PY = 'PY',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RS = 'RS',
    RU = 'RU',
    RW = 'RW',
    SA = 'SA',
    SB = 'SB',
    SC = 'SC',
    SD = 'SD',
    SE = 'SE',
    SG = 'SG',
    SH = 'SH',
    SI = 'SI',
    SJ = 'SJ',
    SK = 'SK',
    SL = 'SL',
    SM = 'SM',
    SN = 'SN',
    SO = 'SO',
    SR = 'SR',
    SS = 'SS',
    ST = 'ST',
    SV = 'SV',
    SX = 'SX',
    SY = 'SY',
    SZ = 'SZ',
    TC = 'TC',
    TD = 'TD',
    TF = 'TF',
    TG = 'TG',
    TH = 'TH',
    TJ = 'TJ',
    TK = 'TK',
    TL = 'TL',
    TM = 'TM',
    TN = 'TN',
    TO = 'TO',
    TR = 'TR',
    TT = 'TT',
    TV = 'TV',
    TW = 'TW',
    TZ = 'TZ',
    UA = 'UA',
    UG = 'UG',
    UM = 'UM',
    US = 'US',
    UY = 'UY',
    UZ = 'UZ',
    VA = 'VA',
    VC = 'VC',
    VE = 'VE',
    VG = 'VG',
    VI = 'VI',
    VN = 'VN',
    VU = 'VU',
    WF = 'WF',
    WS = 'WS',
    XK = 'XK',
    YE = 'YE',
    YT = 'YT',
    ZA = 'ZA',
    ZM = 'ZM',
    ZW = 'ZW',
}
export enum CurrencyIsoCode {
    ADA = 'ADA',
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    ARS = 'ARS',
    AUD = 'AUD',
    AWG = 'AWG',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BCH = 'BCH',
    BDT = 'BDT',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BNB = 'BNB',
    BND = 'BND',
    BOB = 'BOB',
    BRL = 'BRL',
    BSD = 'BSD',
    BTC = 'BTC',
    BTN = 'BTN',
    BWP = 'BWP',
    BYN = 'BYN',
    BYR = 'BYR',
    BZD = 'BZD',
    CAD = 'CAD',
    CDF = 'CDF',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    CLF = 'CLF',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    COU = 'COU',
    CRC = 'CRC',
    CUC = 'CUC',
    CUP = 'CUP',
    CVE = 'CVE',
    CZK = 'CZK',
    DJF = 'DJF',
    DKK = 'DKK',
    DOGE = 'DOGE',
    DOP = 'DOP',
    DZD = 'DZD',
    EEK = 'EEK',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    ETC = 'ETC',
    ETH = 'ETH',
    EUR = 'EUR',
    FJD = 'FJD',
    FKP = 'FKP',
    GBP = 'GBP',
    GEL = 'GEL',
    GHS = 'GHS',
    GIP = 'GIP',
    GMD = 'GMD',
    GNF = 'GNF',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    ILS = 'ILS',
    INR = 'INR',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KRW = 'KRW',
    KTD = 'KTD',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LAK = 'LAK',
    LBP = 'LBP',
    LEO = 'LEO',
    LINK = 'LINK',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LTC = 'LTC',
    LTL = 'LTL',
    LVL = 'LVL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRO = 'MRO',
    MRU = 'MRU',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MXV = 'MXV',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NGN = 'NGN',
    NIO = 'NIO',
    NOK = 'NOK',
    NPR = 'NPR',
    NZD = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    PYG = 'PYG',
    QAR = 'QAR',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    SKK = 'SKK',
    SLE = 'SLE',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    STD = 'STD',
    STN = 'STN',
    SVC = 'SVC',
    SYP = 'SYP',
    SZL = 'SZL',
    THB = 'THB',
    TJS = 'TJS',
    TMT = 'TMT',
    TND = 'TND',
    TOP = 'TOP',
    TRX = 'TRX',
    TRY = 'TRY',
    TTD = 'TTD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD = 'USD',
    USDT = 'USDT',
    UYU = 'UYU',
    UZS = 'UZS',
    VEF = 'VEF',
    VES = 'VES',
    VND = 'VND',
    VUV = 'VUV',
    WST = 'WST',
    XAF = 'XAF',
    XCD = 'XCD',
    XLM = 'XLM',
    XMR = 'XMR',
    XOF = 'XOF',
    XPF = 'XPF',
    XRP = 'XRP',
    YER = 'YER',
    ZAR = 'ZAR',
    ZMK = 'ZMK',
    ZMW = 'ZMW',
    ZWD = 'ZWD',
    ZWL = 'ZWL',
}
export enum DearDomainEntitiesApprovalEntitiesApproachType {
    InvoiceFirst = 'InvoiceFirst',
    StockFirst = 'StockFirst',
    Unknown = 'Unknown',
}
export enum DearDomainEntitiesApprovalEntitiesPurchaseOrdersOrderStatus {
    Authorised = 'Authorised',
    AuthorisedWithoutAllocation = 'AuthorisedWithoutAllocation',
    Closed = 'Closed',
    Draft = 'Draft',
    Fulfilled = 'Fulfilled',
    NotAvailable = 'NotAvailable',
    Received = 'Received',
    Unknown = 'Unknown',
    Voided = 'Voided',
}
export enum DearDomainEntitiesApprovalEntitiesPurchaseStatus {
    Completed = 'Completed',
    CompletedCreditNoteClosed = 'CompletedCreditNoteClosed',
    Credited = 'Credited',
    Draft = 'Draft',
    Invoiced = 'Invoiced',
    Ordered = 'Ordered',
    Ordering = 'Ordering',
    PartiallyInvoiced = 'PartiallyInvoiced',
    Received = 'Received',
    ReceivedCredited = 'ReceivedCredited',
    Receiving = 'Receiving',
    ReceivingCredited = 'ReceivingCredited',
    Unknown = 'Unknown',
    Voided = 'Voided',
}
export enum DearDomainEntitiesApprovalEntitiesPurchaseType {
    AdvancedPurchase = 'AdvancedPurchase',
    ServicePurchase = 'ServicePurchase',
    SimplePurchase = 'SimplePurchase',
    Unknown = 'Unknown',
}
export enum DearDomainEntitiesApprovalEntitiesTaxCalculationType {
    TaxExclusive = 'TaxExclusive',
    TaxInclusive = 'TaxInclusive',
    Unknown = 'Unknown',
}
export enum DomainEntitiesAmountConditionType {
    Gross = 'Gross',
    Net = 'Net',
}
export enum DomainEntitiesAmountSide {
    Credit = 'Credit',
    Debit = 'Debit',
    None = 'None',
}
export enum DomainEntitiesApproverResponse {
    NoResponse = 'NoResponse',
    Reject = 'Reject',
    Approve = 'Approve',
}
export enum DomainEntitiesAttachmentType {
    General = 'General',
    DocumentPDF = 'DocumentPDF',
}
export enum DomainEntitiesCompaniesParticipantsPermission {
    payment_details_add = 'payment-details-add',
    payment_details_edit = 'payment-details-edit',
    payment_details_view = 'payment-details-view',
}
export enum DomainEntitiesCompanyRole {
    Participant = 'Participant',
    Manager = 'Manager',
    Auditor = 'Auditor',
    WorkflowManager = 'WorkflowManager',
}
export enum DomainEntitiesExchangeRateSource {
    Bills = 'Bills',
    Cin7Core = 'Cin7Core',
    CoinLayer = 'CoinLayer',
    Fixer = 'Fixer',
    Manual = 'Manual',
    NetSuite = 'NetSuite',
    None = 'None',
    OpenExchangeRate = 'OpenExchangeRate',
    QBooks = 'QBooks',
    Xero = 'Xero',
}
export enum DomainEntitiesFieldPurpose {
    General = 'General',
    Amount = 'Amount',
    XeroTracking = 'XeroTracking',
    XeroSupplier = 'XeroSupplier',
    XeroCustomer = 'XeroCustomer',
    XeroAccount = 'XeroAccount',
    XeroItem = 'XeroItem',
    Requester = 'Requester',
    XeroBranding = 'XeroBranding',
    XeroTax = 'XeroTax',
    QBooksVendor = 'QBooksVendor',
    QBooksPoItem = 'QBooksPoItem',
    QBooksDepartment = 'QBooksDepartment',
    QBooksClass = 'QBooksClass',
    QBooksCustomer = 'QBooksCustomer',
    QBooksCustom = 'QBooksCustom',
    QBooksAccount = 'QBooksAccount',
    QBooksTerm = 'QBooksTerm',
    XeroBankAccount = 'XeroBankAccount',
    NetSuiteSubsidiary = 'NetSuiteSubsidiary',
    NetSuiteVendor = 'NetSuiteVendor',
    NetSuiteAccount = 'NetSuiteAccount',
    NetSuiteExpenseCategory = 'NetSuiteExpenseCategory',
    NetSuiteItem = 'NetSuiteItem',
    NetSuiteDepartment = 'NetSuiteDepartment',
    NetSuiteClass = 'NetSuiteClass',
    NetSuiteLocation = 'NetSuiteLocation',
    QBooksPaymentMethod = 'QBooksPaymentMethod',
    QBooksPaymentType = 'QBooksPaymentType',
    QBooksPaymentAccount = 'QBooksPaymentAccount',
    QBooksPayeeCustomer = 'QBooksPayeeCustomer',
    QBooksPayeeVendor = 'QBooksPayeeVendor',
    QBooksPayeeEmployee = 'QBooksPayeeEmployee',
    XeroManualExchangeRate = 'XeroManualExchangeRate',
    QBooksManualExchangeRate = 'QBooksManualExchangeRate',
    NetSuiteCurrency = 'NetSuiteCurrency',
    QBooksDocumentStatus = 'QBooksDocumentStatus',
    DearSupplier = 'DearSupplier',
    DearInventoryAccount = 'DearInventoryAccount',
    DearProduct = 'DearProduct',
    DearProductCategory = 'DearProductCategory',
    DearProductFamily = 'DearProductFamily',
    DearBrand = 'DearBrand',
    DearLocation = 'DearLocation',
    NetSuiteCustom = 'NetSuiteCustom',
    AirwallexBeneficiary = 'AirwallexBeneficiary',
    AirwallexCurrency = 'AirwallexCurrency',
    AirwallexPaymentFee = 'AirwallexPaymentFee',
    AirwallexPaymentPurpose = 'AirwallexPaymentPurpose',
    AirwallexPaymentMethod = 'AirwallexPaymentMethod',
    AirwallexSourceAmount = 'AirwallexSourceAmount',
    AirwallexFeeAmount = 'AirwallexFeeAmount',
    AirwallexBatchPaymentStatus = 'AirwallexBatchPaymentStatus',
    AirwallexPaymentItemStatus = 'AirwallexPaymentItemStatus',
    QBooksCurrency = 'QBooksCurrency',
    NetSuiteEmployee = 'NetSuiteEmployee',
    NetSuiteCustomer = 'NetSuiteCustomer',
    NetSuiteTaxCode = 'NetSuiteTaxCode',
    QBooksTax = 'QBooksTax',
    AmaxPayBankAccount = 'AmaxPayBankAccount',
    XeroDate = 'XeroDate',
    XeroDueDate = 'XeroDueDate',
    XeroLineDescription = 'XeroLineDescription',
    XeroLineDiscount = 'XeroLineDiscount',
    NoteForApprovers = 'NoteForApprovers',
    EmailToSupplier = 'EmailToSupplier',
    XeroCurrency = 'XeroCurrency',
    XeroReference = 'XeroReference',
    XeroAttachment = 'XeroAttachment',
    XeroLineAmountType = 'XeroLineAmountType',
    XeroLineQty = 'XeroLineQty',
    XeroLineUnitPrice = 'XeroLineUnitPrice',
    XeroLineTaxAmount = 'XeroLineTaxAmount',
    XeroDeliveryAddress = 'XeroDeliveryAddress',
    XeroContactName = 'XeroContactName',
    XeroContactAccountNumber = 'XeroContactAccountNumber',
    XeroContactPrimaryPersonFirstName = 'XeroContactPrimaryPersonFirstName',
    XeroContactPrimaryPersonLastName = 'XeroContactPrimaryPersonLastName',
    XeroContactPrimaryPersonEmail = 'XeroContactPrimaryPersonEmail',
    XeroContactPersons = 'XeroContactPersons',
    XeroContactPhone = 'XeroContactPhone',
    XeroContactFax = 'XeroContactFax',
    XeroContactMobile = 'XeroContactMobile',
    XeroContactDirectDial = 'XeroContactDirectDial',
    XeroContactSkypeNameOrNumber = 'XeroContactSkypeNameOrNumber',
    XeroContactBillingAddress = 'XeroContactBillingAddress',
    XeroContactDeliveryAddress = 'XeroContactDeliveryAddress',
    XeroContactSalesAccount = 'XeroContactSalesAccount',
    XeroContactSalesTrackingCategories = 'XeroContactSalesTrackingCategories',
    XeroContactPurchaseAccount = 'XeroContactPurchaseAccount',
    XeroContactPurchaseTrackingCategories = 'XeroContactPurchaseTrackingCategories',
    XeroContactTaxNumber = 'XeroContactTaxNumber',
    XeroContactCompanyNumber = 'XeroContactCompanyNumber',
    XeroContactSalesTax = 'XeroContactSalesTax',
    XeroContactPurchaseTax = 'XeroContactPurchaseTax',
    XeroContactDefaultCurrency = 'XeroContactDefaultCurrency',
    XeroContactBankAccountDetails = 'XeroContactBankAccountDetails',
    XeroQuoteNumber = 'XeroQuoteNumber',
    XeroQuoteTitle = 'XeroQuoteTitle',
    XeroQuoteSummary = 'XeroQuoteSummary',
    XeroQuoteTerms = 'XeroQuoteTerms',
    XeroQuoteExpiry = 'XeroQuoteExpiry',
    XeroDeliveryDate = 'XeroDeliveryDate',
    NetSuitePayee = 'NetSuitePayee',
    QBooksEmployee = 'QBooksEmployee',
    QBooksSalesItem = 'QBooksSalesItem',
    QBooksInvoiceCustomer = 'QBooksInvoiceCustomer',
    QBooksInvoiceCustom = 'QBooksInvoiceCustom',
    XeroBatchPaymentItems = 'XeroBatchPaymentItems',
    AmaxPayWallet = 'AmaxPayWallet',
}
export enum DomainEntitiesFieldType {
    NumericRange = 'NumericRange',
    ExactValueRange = 'ExactValueRange',
    ExactValueRangeNegative = 'ExactValueRangeNegative',
}
export enum DomainEntitiesGrnStatus {
    FullyReceived = 'FullyReceived',
    NotReceived = 'NotReceived',
    PartiallyReceived = 'PartiallyReceived',
}
export enum DomainEntitiesLicensesAllFeaturesTrialStatus {
    Undefined = 'Undefined',
    Active = 'Active',
    InActive = 'InActive',
    Expired = 'Expired',
    AwaitingActivation = 'AwaitingActivation',
}
export enum DomainEntitiesOcrOcrStatus {
    Failed = 'Failed',
    InProgress = 'InProgress',
    Requested = 'Requested',
    Skipped = 'Skipped',
    Succeeded = 'Succeeded',
}
export enum DomainEntitiesRequestHistoryRecordsRequestEventType {
    RequesterSubmitted = 'RequesterSubmitted',
    ApproverApproved = 'ApproverApproved',
    ApproverApprovedStepApproved = 'ApproverApprovedStepApproved',
    ApproverApprovedRequestApproved = 'ApproverApprovedRequestApproved',
    ApproverRejected = 'ApproverRejected',
    ApproverRevoked = 'ApproverRevoked',
    ApproverRevokedStepChanged = 'ApproverRevokedStepChanged',
    RequesterClosed = 'RequesterClosed',
    RequesterCancelled = 'RequesterCancelled',
    Comment = 'Comment',
    CommentDeleted = 'CommentDeleted',
    RequesterReopened = 'RequesterReopened',
    RequesterReopenedWithReset = 'RequesterReopenedWithReset',
    RequesterReopenedStepChanged = 'RequesterReopenedStepChanged',
    RequesterReopenedRequestApproved = 'RequesterReopenedRequestApproved',
    RequesterUpdated = 'RequesterUpdated',
    RequesterUpdatedWithReset = 'RequesterUpdatedWithReset',
    RequesterUpdatedStepChanged = 'RequesterUpdatedStepChanged',
    RequesterUpdatedRequestApproved = 'RequesterUpdatedRequestApproved',
    StepSkipped = 'StepSkipped',
    StepSkippedRequestApproved = 'StepSkippedRequestApproved',
    ForcedApproval = 'ForcedApproval',
    ForcedReject = 'ForcedReject',
    ApprovedInXero = 'ApprovedInXero',
    CancelledInXero = 'CancelledInXero',
    RequesterResetTemplate = 'RequesterResetTemplate',
    ParticipantsWereChanged = 'ParticipantsWereChanged',
    ParticipantsWereChangedStepChanged = 'ParticipantsWereChangedStepChanged',
    ParticipantsWereChangedRequestApproved = 'ParticipantsWereChangedRequestApproved',
    EmailToPartnerSent = 'EmailToPartnerSent',
    EditorEdited = 'EditorEdited',
    EditorEditedStepApproved = 'EditorEditedStepApproved',
    EditorEditedRequestApproved = 'EditorEditedRequestApproved',
    RejectedExternally = 'RejectedExternally',
    StepSkippedRequestRejected = 'StepSkippedRequestRejected',
    PulledFromSource = 'PulledFromSource',
    PushedToSource = 'PushedToSource',
    RequestMatchedByUser = 'RequestMatchedByUser',
    RequestMatchedBySystem = 'RequestMatchedBySystem',
    RequestUnmatchedByUser = 'RequestUnmatchedByUser',
    RequestUnmatchedBySystem = 'RequestUnmatchedBySystem',
    MarkedAsBilled = 'MarkedAsBilled',
    UnmarkedAsBilled = 'UnmarkedAsBilled',
    MarkAsBilledSynced = 'MarkAsBilledSynced',
    PostApprovalChangeDetected = 'PostApprovalChangeDetected',
    UpdatedExternallyResetTemplate = 'UpdatedExternallyResetTemplate',
    MatchingAllocationAdded = 'MatchingAllocationAdded',
    MatchingAllocationRemoved = 'MatchingAllocationRemoved',
    AutoMarkedAsBilled = 'AutoMarkedAsBilled',
    AutoUnmarkedAsBilled = 'AutoUnmarkedAsBilled',
    LineMatchingAdded = 'LineMatchingAdded',
    LineMatchingRemoved = 'LineMatchingRemoved',
    CancelledExternally = 'CancelledExternally',
    DocumentClosed = 'DocumentClosed',
    DocumentOpened = 'DocumentOpened',
    DocumentClosedStatusSynced = 'DocumentClosedStatusSynced',
    DocumentOpenedStatusSynced = 'DocumentOpenedStatusSynced',
    AirwallexBatchPaymentRequestPaid = 'AirwallexBatchPaymentRequestPaid',
    AttachmentUploadFailed = 'AttachmentUploadFailed',
    GrnStatusChangedToNotReceived = 'GrnStatusChangedToNotReceived',
    GrnStatusChangedToPartiallyReceived = 'GrnStatusChangedToPartiallyReceived',
    GrnStatusChangedToFullyReceived = 'GrnStatusChangedToFullyReceived',
    DocumentStatusSyncFailed = 'DocumentStatusSyncFailed',
    ParticipantsWereAddedDueToMatchingBillWithPO = 'ParticipantsWereAddedDueToMatchingBillWithPO',
    MarkAsCustomerDecisionSynced = 'MarkAsCustomerDecisionSynced',
    WatchersChanged = 'WatchersChanged',
    ApprovedExternally = 'ApprovedExternally',
    QuoteDecisionSet = 'QuoteDecisionSet',
    AirwallexRequestScheduledForPayment = 'AirwallexRequestScheduledForPayment',
    AirwallexScheduledPaymentCancelled = 'AirwallexScheduledPaymentCancelled',
    AirwallexScheduledPaymentFailedDueToPaymentServiceIntegrationDisconnected = 'AirwallexScheduledPaymentFailedDueToPaymentServiceIntegrationDisconnected',
    AirwallexScheduledPaymentFailedDueToExceededAmountDue = 'AirwallexScheduledPaymentFailedDueToExceededAmountDue',
    AirwallexScheduledPaymentFailedDueToBeneficiaryDiscrepancy = 'AirwallexScheduledPaymentFailedDueToBeneficiaryDiscrepancy',
    AirwallexScheduledPaymentFailedDueToInsufficientFunds = 'AirwallexScheduledPaymentFailedDueToInsufficientFunds',
    AirwallexScheduledPaymentFailedDueToCompanyIntegrationDisabled = 'AirwallexScheduledPaymentFailedDueToCompanyIntegrationDisabled',
    ReviewersChanged = 'ReviewersChanged',
    ReviewForcedByAdmin = 'ReviewForcedByAdmin',
    ReviewCompleted = 'ReviewCompleted',
    MarkedAsSentSynced = 'MarkedAsSentSynced',
    AttachmentsAdded = 'AttachmentsAdded',
    AttachmentDeleted = 'AttachmentDeleted',
    ReturnedToReview = 'ReturnedToReview',
    ReviewerEdited = 'ReviewerEdited',
    AmaxPayBatchPaymentBillPaymentCancelled = 'AmaxPayBatchPaymentBillPaymentCancelled',
    ReviewSkipped = 'ReviewSkipped',
    ApproverEdited = 'ApproverEdited',
    PushingSkipped = 'PushingSkipped',
    AmaxPayBatchPaymentFinalStatusSet = 'AmaxPayBatchPaymentFinalStatusSet',
    PutOnHold = 'PutOnHold',
    TakenOffHold = 'TakenOffHold',
    AmaxPayPaymentApprovedAsPartOfBatchPayment = 'AmaxPayPaymentApprovedAsPartOfBatchPayment',
    AmaxPayPaymentCancelledAsPartOfBatchPayment = 'AmaxPayPaymentCancelledAsPartOfBatchPayment',
    CaptureRequestCreatedFromFile = 'CaptureRequestCreatedFromFile',
    CaptureAttachmentAssigned = 'CaptureAttachmentAssigned',
    CaptureSubmitRequestFailed = 'CaptureSubmitRequestFailed',
    ParticipantsNudged = 'ParticipantsNudged',
    CommentPushFailed = 'CommentPushFailed',
    CreditNoteInvoiceAllocationCreated = 'CreditNoteInvoiceAllocationCreated',
}
export enum DomainEntitiesRequestsRequestFraudulentActivity {
    PostApprovalChange = 'PostApprovalChange',
    ExternalResolving = 'ExternalResolving',
    AutomaticResolving = 'AutomaticResolving',
    AdminEnforcedResolving = 'AdminEnforcedResolving',
    DroppingOffApprovers = 'DroppingOffApprovers',
}
export enum DomainEntitiesRequestsRequestOrigin {
    ApprovalMax = 'ApprovalMax',
    Xero = 'Xero',
    QBooks = 'QBooks',
    ReceiptBank = 'ReceiptBank',
    NetSuite = 'NetSuite',
    Dear = 'Dear',
    PublicApi = 'PublicApi',
    Email = 'Email',
}
export enum DomainEntitiesRequestsRequestResolutionOrigin {
    ResolvedRegularly = 'ResolvedRegularly',
    EnforcedExternally = 'EnforcedExternally',
    EnforcedByAdmin = 'EnforcedByAdmin',
    ResolvedAutomatically = 'ResolvedAutomatically',
    ChangedApprovers = 'ChangedApprovers',
    ResolvedExternally = 'ResolvedExternally',
}
export enum DomainEntitiesRequestsRequestStatusV2 {
    approved = 'approved',
    cancelled = 'cancelled',
    draft = 'draft',
    on_approval = 'on-approval',
    on_hold = 'on-hold',
    on_review = 'on-review',
    rejected = 'rejected',
}
export enum DomainEntitiesRequestsStepsRequestStepState {
    NotStarted = 'NotStarted',
    Active = 'Active',
    Done = 'Done',
}
export enum DomainEntitiesRequestsStepsReviewersRequestStepReviewerOrigin {
    backup = 'backup',
    manual = 'manual',
    rules = 'rules',
}
export enum DomainEntitiesStepApprovalType {
    All = 'All',
    AnyOf = 'AnyOf',
}
export enum DomainEntitiesStepParticipantOrigin {
    ByRules = 'ByRules',
    IsBackup = 'IsBackup',
    Manually = 'Manually',
    ByMatching = 'ByMatching',
}
export enum DomainEntitiesStepResolution {
    NoResolution = 'NoResolution',
    Rejected = 'Rejected',
    Approved = 'Approved',
}
export enum DomainIntegrationType {
    Dear = 'Dear',
    NetSuite = 'NetSuite',
    None = 'None',
    QBooks = 'QBooks',
    Xero = 'Xero',
}
export enum DomainUserPlatform {
    email = 'email',
    mobile = 'mobile',
    slack = 'slack',
    web = 'web',
}
export enum FilesFileUploadResult {
    OK = 'OK',
    TooBig = 'TooBig',
    RestrictedFileType = 'RestrictedFileType',
    VirusFound = 'VirusFound',
}
export enum IntegrationsAirwallexAirwallexInvoiceUIStatus {
    Cancelled = 'Cancelled',
    Failed = 'Failed',
    Processing = 'Processing',
    Rejected = 'Rejected',
    Sent = 'Sent',
}
export enum NetSuiteApiClientModelsCommonPayeeType {
    employee = 'employee',
    vendor = 'vendor',
}
export enum NetSuiteRefDataClientContractsModelsCurrenciesCurrencyPrecision {
    _two = '_two',
    _zero = '_zero',
}
export enum NetSuiteRefDataClientContractsModelsDocumentSublistType {
    ExpenseList = 'ExpenseList',
    ItemList = 'ItemList',
    LineList = 'LineList',
}
export enum NetSuiteRefDataClientContractsModelsDocumentType {
    BillPayment = 'BillPayment',
    ExpenseReport = 'ExpenseReport',
    JournalEntry = 'JournalEntry',
    PurchaseOrder = 'PurchaseOrder',
    ReturnAuthorization = 'ReturnAuthorization',
    SalesInvoice = 'SalesInvoice',
    SalesOrder = 'SalesOrder',
    Vendor = 'Vendor',
    VendorBill = 'VendorBill',
    VendorReturnAuthorization = 'VendorReturnAuthorization',
}
export enum NetSuiteRefDataClientContractsModelsItemsItemType {
    Assembly = 'Assembly',
    Description = 'Description',
    Discount = 'Discount',
    DownloadItem = 'DownloadItem',
    EndOfGroup = 'EndOfGroup',
    GiftCertificateItem = 'GiftCertificateItem',
    InventoryItem = 'InventoryItem',
    ItemGroup = 'ItemGroup',
    Kit = 'Kit',
    Markup = 'Markup',
    NonInventoryItem = 'NonInventoryItem',
    OtherCharge = 'OtherCharge',
    Payment = 'Payment',
    Service = 'Service',
    Subtotal = 'Subtotal',
}
export enum OcrContractsModelsXeroLineAmountTypeAnswer {
    No_Tax = 'No Tax',
    Tax_Exclusive = 'Tax Exclusive',
    Tax_Inclusive = 'Tax Inclusive',
}
export enum OcrContractsModelsXeroPaymentTermTypeAnswer {
    AfterBillDate = 'AfterBillDate',
    CurrentMonth = 'CurrentMonth',
    DaysAfterBillMonth = 'DaysAfterBillMonth',
    FollowingMonth = 'FollowingMonth',
}
export enum OcrContractsOcrDocumentTypes {
    NetSuite_vendor_bill = 'NetSuite-vendor-bill',
    QBooks_bill = 'QBooks-bill',
    Xero_creditnotes_payable = 'Xero-creditnotes-payable',
    Xero_bill = 'Xero-bill',
    Xero_PO = 'Xero-PO',
    Xero_invoice = 'Xero-invoice',
}
export enum QBooksDomainEntitiesDocumentsJournalEntriesTaxApplicableOnType {
    None = 'None',
    Purchases = 'Purchases',
    Sales = 'Sales',
}
export enum QBooksDomainEntitiesDocumentsPayeeType {
    Customer = 'Customer',
    Employee = 'Employee',
    Undefined = 'Undefined',
    Vendor = 'Vendor',
}
export enum QBooksDomainEntitiesDocumentsQBooksDocumentStatus {
    None = 'None',
    Open = 'Open',
    Closed = 'Closed',
}
export enum RequestDetailsVersioningDomainVersionType {
    ApproverEdited = 'ApproverEdited',
    EditorEdited = 'EditorEdited',
    PostApprovalChangesDetected = 'PostApprovalChangesDetected',
    RequesterResubmitted = 'RequesterResubmitted',
    RequesterSubmitted = 'RequesterSubmitted',
    ReviewerEdited = 'ReviewerEdited',
    StartOverByExternalUpdate = 'StartOverByExternalUpdate',
    SubmittedViaExternalSystem = 'SubmittedViaExternalSystem',
}
export enum RequestsSelectFilterType {
    UserDecisionRequired = 'UserDecisionRequired',
    RequestsUserCanSee = 'RequestsUserCanSee',
    UserSubmittedOpenRequests = 'UserSubmittedOpenRequests',
    UserDraftRequests = 'UserDraftRequests',
    UserReviewRequired = 'UserReviewRequired',
    UserOcrRequests = 'UserOcrRequests',
    UserReadyToPayRequests = 'UserReadyToPayRequests',
    UserOnHoldRequests = 'UserOnHoldRequests',
}
export enum XeroDomainEntitiesDocumentsDiscountType {
    Amount = 'Amount',
    PreAmount = 'PreAmount',
    PreRate = 'PreRate',
    Rate = 'Rate',
}
export enum XeroDomainEntitiesRequestsMarkAsBilledSource {
    None = 'None',
    Xero = 'Xero',
    User = 'User',
    System = 'System',
}
export enum XeroDomainEntitiesXeroDocumentStatus {
    None = 'None',
    Submitted = 'Submitted',
    Authorised = 'Authorised',
    Paid = 'Paid',
    Billed = 'Billed',
    Deleted = 'Deleted',
    Voided = 'Voided',
    Draft = 'Draft',
    Active = 'Active',
    Archived = 'Archived',
    GdprRequest = 'GdprRequest',
    Sent = 'Sent',
    Accepted = 'Accepted',
    Declined = 'Declined',
    Invoiced = 'Invoiced',
    Posted = 'Posted',
}
export type operations = Record<string, never>;
